webpackJsonp([1],{

/***/ "++Ft":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactComponents = __webpack_require__("fmgT");

var _reportTable = __webpack_require__("MdXx");

var _reportTable2 = _interopRequireDefault(_reportTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ReportTable pro-forma template for stateless component
 * Displays heading, subheading & table with footer
 */
var ReportTable = function ReportTable(_ref) {
    var heading = _ref.heading,
        subHeading = _ref.subHeading,
        tableConfig = _ref.tableConfig,
        tableData = _ref.tableData,
        tableFooterData = _ref.tableFooterData;
    return _react2.default.createElement(
        'div',
        { className: _reportTable2.default.component },
        _react2.default.createElement(
            'h3',
            null,
            heading
        ),
        _react2.default.createElement(
            'p',
            { className: _reportTable2.default['sub-heading'] },
            subHeading
        ),
        _react2.default.createElement(_reactComponents.DataTable, {
            className: _reportTable2.default['data-table'],
            config: tableConfig,
            data: tableData,
            footerData: tableFooterData
        })
    );
};

ReportTable.propTypes = {
    heading: _propTypes2.default.string,
    subHeading: _propTypes2.default.string,
    tableConfig: _propTypes2.default.object,
    tableData: _propTypes2.default.array,
    tableFooterData: _propTypes2.default.object
};

exports.default = (0, _reactStyleable2.default)(_reportTable2.default)(ReportTable);

/***/ }),

/***/ "+lTj":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---2tfKJ {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  background-color: #cfd2d4;\n  font-size: 20px;\n  width: 100%; }\n  .component---2tfKJ .academicYear---13owX {\n    font-weight: bold;\n    padding-right: 20px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2tfKJ",
	"academicYear": "academicYear---13owX"
};

/***/ }),

/***/ "+pLX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("4n+p");

var _reactComponents = __webpack_require__("fmgT");

var _headerWithAcademicYear = __webpack_require__("aAV2");

var _headerWithAcademicYear2 = _interopRequireDefault(_headerWithAcademicYear);

var _utils = __webpack_require__("6QRH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderWithAcademicYear = function HeaderWithAcademicYear(props) {
    var localeData = props.localeData,
        academicYear = props.academicYear,
        title = props.title;


    if (!localeData || !academicYear || !title) {
        return null;
    }

    var startDate = academicYear.startDate,
        endDate = academicYear.endDate;

    var formattedStartDate = (0, _utils.formatDate)(startDate);
    var formattedEndDate = (0, _utils.formatDate)(endDate);

    return _react2.default.createElement(
        'div',
        { className: _headerWithAcademicYear2.default.component },
        _react2.default.createElement(_reactComponents.Header, { title: title }),
        _react2.default.createElement(
            'div',
            null,
            localeData['Label - AcademicYear'],
            ':',
            _react2.default.createElement(
                'span',
                { className: _headerWithAcademicYear2.default.academicYear },
                ' ',
                formattedStartDate,
                ' > ',
                formattedEndDate
            )
        )
    );
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        localeData: state.localeData,
        academicYear: state.academicYear
    };
}

HeaderWithAcademicYear.propTypes = {
    title: _propTypes2.default.string,
    academicYear: _propTypes2.default.object,
    localeData: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(HeaderWithAcademicYear);

/***/ }),

/***/ "+sYB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!action) return state;

    switch (action.type) {
        case _classDetailsActions.CLASS_DETAILS_DATA_RETRIEVED:
            return action.payload;
        default:
            return state;
    }
};

var _classDetailsActions = __webpack_require__("CXkR");

var defaultState = [];

/**
 * Class Details Reducer
 *
 * Consumes CLASS_DETAILS_DATA_RETRIEVED action
 *
 * @param {array} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - current list of items to display in class details table
 */

/***/ }),

/***/ "+vlH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!action) return state;

    switch (action.type) {
        case _downloadCertificatesActions.DOWNLOAD_SERVICE_IS_ACTIVE:
            {
                var _action$payload = action.payload,
                    isActive = _action$payload.isActive,
                    downloadType = _action$payload.downloadType;

                return { isActive: isActive, downloadType: downloadType };
            }
        default:
            return state;
    }
};

var _downloadCertificatesActions = __webpack_require__("EzKo");

var defaultState = {
    isActive: false,
    downloadType: null
};

/**
 * Download Certificates Reducer
 *
 * Consumes DOWNLOAD_SERVICE_IS_ACTIVE action
 *
 * @param {array} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - contains list of individual student certificates for a class
 *                     as well as total for class
 */

/***/ }),

/***/ "+zM/":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/ce5c9bf307add3fd442cca19330b4fcf.svg";

/***/ }),

/***/ "/tNG":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/37009227f57f17c09c5ced382bcb598d.svg";

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "05XZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactInlinesvg = __webpack_require__("h2Qy");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("M4fF");

var _Bronze = __webpack_require__("Op+y");

var _Bronze2 = _interopRequireDefault(_Bronze);

var _Bronze3 = __webpack_require__("7BBg");

var _Bronze4 = _interopRequireDefault(_Bronze3);

var _Bronze5 = __webpack_require__("0loc");

var _Bronze6 = _interopRequireDefault(_Bronze5);

var _Bronze7 = __webpack_require__("4Ksa");

var _Bronze8 = _interopRequireDefault(_Bronze7);

var _Bronze9 = __webpack_require__("UIQG");

var _Bronze10 = _interopRequireDefault(_Bronze9);

var _Bronze11 = __webpack_require__("on1x");

var _Bronze12 = _interopRequireDefault(_Bronze11);

var _Silver = __webpack_require__("hHdG");

var _Silver2 = _interopRequireDefault(_Silver);

var _Silver3 = __webpack_require__("EC7T");

var _Silver4 = _interopRequireDefault(_Silver3);

var _Silver5 = __webpack_require__("qfeG");

var _Silver6 = _interopRequireDefault(_Silver5);

var _Silver7 = __webpack_require__("mEYJ");

var _Silver8 = _interopRequireDefault(_Silver7);

var _Silver9 = __webpack_require__("BhLC");

var _Silver10 = _interopRequireDefault(_Silver9);

var _Silver11 = __webpack_require__("c7bk");

var _Silver12 = _interopRequireDefault(_Silver11);

var _Gold = __webpack_require__("u0LN");

var _Gold2 = _interopRequireDefault(_Gold);

var _Gold3 = __webpack_require__("ShFx");

var _Gold4 = _interopRequireDefault(_Gold3);

var _Gold5 = __webpack_require__("wBUB");

var _Gold6 = _interopRequireDefault(_Gold5);

var _Gold7 = __webpack_require__("eKZK");

var _Gold8 = _interopRequireDefault(_Gold7);

var _Gold9 = __webpack_require__("C4aY");

var _Gold10 = _interopRequireDefault(_Gold9);

var _Gold11 = __webpack_require__("LMoJ");

var _Gold12 = _interopRequireDefault(_Gold11);

var _Platinum = __webpack_require__("77wF");

var _Platinum2 = _interopRequireDefault(_Platinum);

var _Platinum3 = __webpack_require__("spca");

var _Platinum4 = _interopRequireDefault(_Platinum3);

var _Platinum5 = __webpack_require__("jLtQ");

var _Platinum6 = _interopRequireDefault(_Platinum5);

var _Platinum7 = __webpack_require__("/tNG");

var _Platinum8 = _interopRequireDefault(_Platinum7);

var _Platinum9 = __webpack_require__("ep4t");

var _Platinum10 = _interopRequireDefault(_Platinum9);

var _Platinum11 = __webpack_require__("27Yv");

var _Platinum12 = _interopRequireDefault(_Platinum11);

var _Emerald = __webpack_require__("smAp");

var _Emerald2 = _interopRequireDefault(_Emerald);

var _Emerald3 = __webpack_require__("R1VL");

var _Emerald4 = _interopRequireDefault(_Emerald3);

var _Emerald5 = __webpack_require__("yu+Z");

var _Emerald6 = _interopRequireDefault(_Emerald5);

var _Emerald7 = __webpack_require__("g5Dq");

var _Emerald8 = _interopRequireDefault(_Emerald7);

var _Emerald9 = __webpack_require__("xebo");

var _Emerald10 = _interopRequireDefault(_Emerald9);

var _Emerald11 = __webpack_require__("ixbo");

var _Emerald12 = _interopRequireDefault(_Emerald11);

var _Diamond = __webpack_require__("HnjT");

var _Diamond2 = _interopRequireDefault(_Diamond);

var _Diamond3 = __webpack_require__("WZai");

var _Diamond4 = _interopRequireDefault(_Diamond3);

var _Diamond5 = __webpack_require__("sR3R");

var _Diamond6 = _interopRequireDefault(_Diamond5);

var _Diamond7 = __webpack_require__("9A8k");

var _Diamond8 = _interopRequireDefault(_Diamond7);

var _Diamond9 = __webpack_require__("PXvo");

var _Diamond10 = _interopRequireDefault(_Diamond9);

var _Diamond11 = __webpack_require__("qC0W");

var _Diamond12 = _interopRequireDefault(_Diamond11);

var _Epic = __webpack_require__("pxdW");

var _Epic2 = _interopRequireDefault(_Epic);

var _Epic3 = __webpack_require__("W7lP");

var _Epic4 = _interopRequireDefault(_Epic3);

var _Epic5 = __webpack_require__("RYvy");

var _Epic6 = _interopRequireDefault(_Epic5);

var _Epic7 = __webpack_require__("Z6mg");

var _Epic8 = _interopRequireDefault(_Epic7);

var _Epic9 = __webpack_require__("ao7Y");

var _Epic10 = _interopRequireDefault(_Epic9);

var _Epic11 = __webpack_require__("w22/");

var _Epic12 = _interopRequireDefault(_Epic11);

var _Legend = __webpack_require__("P6IG");

var _Legend2 = _interopRequireDefault(_Legend);

var _Legend3 = __webpack_require__("+zM/");

var _Legend4 = _interopRequireDefault(_Legend3);

var _Legend5 = __webpack_require__("n/tl");

var _Legend6 = _interopRequireDefault(_Legend5);

var _Legend7 = __webpack_require__("wmVF");

var _Legend8 = _interopRequireDefault(_Legend7);

var _Legend9 = __webpack_require__("AqsK");

var _Legend10 = _interopRequireDefault(_Legend9);

var _Legend11 = __webpack_require__("C97H");

var _Legend12 = _interopRequireDefault(_Legend11);

var _ribbonBronze = __webpack_require__("fBpJ");

var _ribbonBronze2 = _interopRequireDefault(_ribbonBronze);

var _ribbonSilver = __webpack_require__("Phym");

var _ribbonSilver2 = _interopRequireDefault(_ribbonSilver);

var _ribbonGold = __webpack_require__("jbqH");

var _ribbonGold2 = _interopRequireDefault(_ribbonGold);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CertificateIcon = function CertificateIcon(_ref) {
    var rank = _ref.rank,
        className = _ref.className,
        total = _ref.total;

    var numGems = total > 5 ? 5 : total;
    var iconDictionary = {
        bronze0: _Bronze2.default,
        bronze1: _Bronze4.default,
        bronze2: _Bronze6.default,
        bronze3: _Bronze8.default,
        bronze4: _Bronze10.default,
        bronze5: _Bronze12.default,
        silver0: _Silver2.default,
        silver1: _Silver4.default,
        silver2: _Silver6.default,
        silver3: _Silver8.default,
        silver4: _Silver10.default,
        silver5: _Silver12.default,
        gold0: _Gold2.default,
        gold1: _Gold4.default,
        gold2: _Gold6.default,
        gold3: _Gold8.default,
        gold4: _Gold10.default,
        gold5: _Gold12.default,
        platinum0: _Platinum2.default,
        platinum1: _Platinum4.default,
        platinum2: _Platinum6.default,
        platinum3: _Platinum8.default,
        platinum4: _Platinum10.default,
        platinum5: _Platinum12.default,
        emerald0: _Emerald2.default,
        emerald1: _Emerald4.default,
        emerald2: _Emerald6.default,
        emerald3: _Emerald8.default,
        emerald4: _Emerald10.default,
        emerald5: _Emerald12.default,
        diamond0: _Diamond2.default,
        diamond1: _Diamond4.default,
        diamond2: _Diamond6.default,
        diamond3: _Diamond8.default,
        diamond4: _Diamond10.default,
        diamond5: _Diamond12.default,
        epic0: _Epic2.default,
        epic1: _Epic4.default,
        epic2: _Epic6.default,
        epic3: _Epic8.default,
        epic4: _Epic10.default,
        epic5: _Epic12.default,
        legend0: _Legend2.default,
        legend1: _Legend4.default,
        legend2: _Legend6.default,
        legend3: _Legend8.default,
        legend4: _Legend10.default,
        legend5: _Legend12.default,
        bronzePast: _ribbonBronze2.default,
        silverPast: _ribbonSilver2.default,
        goldPast: _ribbonGold2.default
    };

    var src = rank.includes('Past') ? rank : '' + rank + (numGems || 0);
    var imgSrc = iconDictionary[src] || '';
    return _react2.default.createElement(_reactInlinesvg2.default, { src: imgSrc, className: className, key: (0, _lodash.uniqueId)() });
};

CertificateIcon.propTypes = {
    className: _propTypes2.default.string,
    rank: _propTypes2.default.string,
    total: _propTypes2.default.number
};

exports.default = CertificateIcon;

/***/ }),

/***/ "0Cvf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BusyIndicator = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("4n+p");

var _redux = __webpack_require__("2KeS");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _busyIndicatorActions = __webpack_require__("qS76");

var _busyIndicatorActions2 = _interopRequireDefault(_busyIndicatorActions);

var _busyIndicator = __webpack_require__("gxHR");

var _busyIndicator2 = _interopRequireDefault(_busyIndicator);

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * BusyIndicator Redux component
 * Displays an overlay on the application and a busy cursor while API requests are
 * being processed
 */
var BusyIndicator = exports.BusyIndicator = (_temp = _class = function (_Component) {
    _inherits(BusyIndicator, _Component);

    function BusyIndicator(props) {
        _classCallCheck(this, BusyIndicator);

        var _this = _possibleConstructorReturn(this, (BusyIndicator.__proto__ || Object.getPrototypeOf(BusyIndicator)).call(this, props));

        props.hideBusy();
        return _this;
    }

    _createClass(BusyIndicator, [{
        key: 'render',
        value: function render() {
            if (this.props.busyIndicatorCount < 1) {
                return null;
            }
            return _react2.default.createElement('div', { className: _busyIndicator2.default.component });
        }
    }]);

    return BusyIndicator;
}(_react.Component), _class.propTypes = {
    busyIndicatorCount: _propTypes2.default.number,
    hideBusy: _propTypes2.default.func
}, _temp);

/**
 * Add Resources interceptors to dispatch busy indicator actions
 * when sending requests and receiving responses
 */

function addInterceptors(dispatch) {
    var env = _resources2.default.env;

    function requestInterceptor() {
        dispatch(_busyIndicatorActions2.default.showBusy());
    }

    function responseInterceptor(response) {
        if (!env.havePendingRequests()) {
            dispatch(_busyIndicatorActions2.default.hideBusy());
        }

        return response;
    }

    env.addRequestInterceptor(requestInterceptor);
    env.addResponseInterceptor(responseInterceptor);
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        busyIndicatorCount: state.busyIndicatorCount
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    addInterceptors(dispatch);

    return (0, _redux.bindActionCreators)({
        hideBusy: _busyIndicatorActions2.default.hideBusy,
        showBusy: _busyIndicatorActions2.default.showBusy
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable2.default)(_busyIndicator2.default)(BusyIndicator));

/***/ }),

/***/ "0loc":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/c6149a6ed0324d3faa8a7b5c04a995e5.svg";

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1O84":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SELECT_STUDENT = undefined;

var _reduxActions = __webpack_require__("sTbe");

var SELECT_STUDENT = exports.SELECT_STUDENT = 'SELECT_STUDENT';

var selectStudent = (0, _reduxActions.createAction)(SELECT_STUDENT);

exports.default = {
    selectStudent: selectStudent
};

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("x4K0");


/***/ }),

/***/ "273U":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "FxR1",
	"./af.js": "FxR1",
	"./am": "1tLf",
	"./am.js": "1tLf",
	"./ar": "GiWf",
	"./ar-dz": "EZCs",
	"./ar-dz.js": "EZCs",
	"./ar-iq": "I1ik",
	"./ar-iq.js": "I1ik",
	"./ar-kw": "wDM/",
	"./ar-kw.js": "wDM/",
	"./ar-ly": "9Nx9",
	"./ar-ly.js": "9Nx9",
	"./ar-ma": "vYFi",
	"./ar-ma.js": "vYFi",
	"./ar-sa": "NR0I",
	"./ar-sa.js": "NR0I",
	"./ar-tn": "jNUn",
	"./ar-tn.js": "jNUn",
	"./ar.js": "GiWf",
	"./az": "GpbD",
	"./az.js": "GpbD",
	"./be": "KkxE",
	"./be.js": "KkxE",
	"./bg": "1cHP",
	"./bg.js": "1cHP",
	"./bi": "bRA9",
	"./bi.js": "bRA9",
	"./bm": "EGRV",
	"./bm.js": "EGRV",
	"./bn": "A0uZ",
	"./bn-bd": "lNiJ",
	"./bn-bd.js": "lNiJ",
	"./bn.js": "A0uZ",
	"./bo": "Q4xp",
	"./bo.js": "Q4xp",
	"./br": "vva5",
	"./br.js": "vva5",
	"./bs": "pcUf",
	"./bs.js": "pcUf",
	"./ca": "g3sV",
	"./ca.js": "g3sV",
	"./cs": "oINk",
	"./cs.js": "oINk",
	"./cv": "FM+v",
	"./cv.js": "FM+v",
	"./cy": "/9q4",
	"./cy.js": "/9q4",
	"./da": "yQ5d",
	"./da.js": "yQ5d",
	"./de": "RPZl",
	"./de-at": "ajYt",
	"./de-at.js": "ajYt",
	"./de-ch": "h5/7",
	"./de-ch.js": "h5/7",
	"./de.js": "RPZl",
	"./dv": "Dl08",
	"./dv.js": "Dl08",
	"./el": "/F1G",
	"./el.js": "/F1G",
	"./en": "RZac",
	"./en-au": "Z3Bs",
	"./en-au.js": "Z3Bs",
	"./en-ca": "M54S",
	"./en-ca.js": "M54S",
	"./en-gb": "eCXk",
	"./en-gb.js": "eCXk",
	"./en-ie": "p+GI",
	"./en-ie.js": "p+GI",
	"./en-il": "QIMF",
	"./en-il.js": "QIMF",
	"./en-in": "IgRb",
	"./en-in.js": "IgRb",
	"./en-nz": "0Jgx",
	"./en-nz.js": "0Jgx",
	"./en-sg": "XWPz",
	"./en-sg.js": "XWPz",
	"./en-tt": "Blem",
	"./en-tt.js": "Blem",
	"./en.js": "RZac",
	"./eo": "et6a",
	"./eo.js": "et6a",
	"./es": "O6/0",
	"./es-do": "sUkO",
	"./es-do.js": "sUkO",
	"./es-mx": "Xf3+",
	"./es-mx.js": "Xf3+",
	"./es-pr": "O1Ef",
	"./es-pr.js": "O1Ef",
	"./es-us": "mqqW",
	"./es-us.js": "mqqW",
	"./es.js": "O6/0",
	"./et": "EShX",
	"./et.js": "EShX",
	"./eu": "evCj",
	"./eu.js": "evCj",
	"./fa": "UR6A",
	"./fa.js": "UR6A",
	"./fi": "iir9",
	"./fi.js": "iir9",
	"./fo": "tXMN",
	"./fo.js": "tXMN",
	"./fr": "pOV2",
	"./fr-ca": "J1v9",
	"./fr-ca.js": "J1v9",
	"./fr-ch": "YJPy",
	"./fr-ch.js": "YJPy",
	"./fr.js": "pOV2",
	"./fy": "r5jE",
	"./fy.js": "r5jE",
	"./ga": "aV1g",
	"./ga.js": "aV1g",
	"./gd": "6raY",
	"./gd.js": "6raY",
	"./gl": "vr1D",
	"./gl.js": "vr1D",
	"./gom-latn": "+D52",
	"./gom-latn.js": "+D52",
	"./gu": "2tDl",
	"./gu.js": "2tDl",
	"./he": "GjNe",
	"./he.js": "GjNe",
	"./hi": "Zc/q",
	"./hi.js": "Zc/q",
	"./hr": "30LY",
	"./hr.js": "30LY",
	"./ht": "i6Zz",
	"./ht.js": "i6Zz",
	"./hu": "u48e",
	"./hu.js": "u48e",
	"./hy-am": "mPXc",
	"./hy-am.js": "mPXc",
	"./id": "r4/8",
	"./id.js": "r4/8",
	"./index.d.ts": "Tyq0",
	"./is": "9ojU",
	"./is.js": "9ojU",
	"./it": "m8fN",
	"./it-ch": "tSuc",
	"./it-ch.js": "tSuc",
	"./it.js": "m8fN",
	"./ja": "p6+x",
	"./ja.js": "p6+x",
	"./jv": "Hv3K",
	"./jv.js": "Hv3K",
	"./ka": "FQMB",
	"./ka.js": "FQMB",
	"./kk": "dUrl",
	"./kk.js": "dUrl",
	"./km": "Q4R+",
	"./km.js": "Q4R+",
	"./kn": "mPgt",
	"./kn.js": "mPgt",
	"./ko": "Bsn4",
	"./ko.js": "Bsn4",
	"./ku": "al1s",
	"./ku.js": "al1s",
	"./ky": "NMqG",
	"./ky.js": "NMqG",
	"./lb": "LaFg",
	"./lb.js": "LaFg",
	"./lo": "JvTo",
	"./lo.js": "JvTo",
	"./lt": "PbC2",
	"./lt.js": "PbC2",
	"./lv": "USDX",
	"./lv.js": "USDX",
	"./me": "Hq/O",
	"./me.js": "Hq/O",
	"./mi": "BReM",
	"./mi.js": "BReM",
	"./mk": "xvnQ",
	"./mk.js": "xvnQ",
	"./ml": "0Mqv",
	"./ml.js": "0Mqv",
	"./mn": "LDRn",
	"./mn.js": "LDRn",
	"./mr": "1tWl",
	"./mr.js": "1tWl",
	"./ms": "PuVt",
	"./ms-my": "DOOo",
	"./ms-my.js": "DOOo",
	"./ms.js": "PuVt",
	"./mt": "RJyg",
	"./mt.js": "RJyg",
	"./my": "UQFf",
	"./my.js": "UQFf",
	"./nb": "5cfY",
	"./nb.js": "5cfY",
	"./ne": "kXrc",
	"./ne.js": "kXrc",
	"./nl": "wzgP",
	"./nl-be": "KT97",
	"./nl-be.js": "KT97",
	"./nl.js": "wzgP",
	"./nn": "F3nE",
	"./nn.js": "F3nE",
	"./oc-lnc": "GZ5A",
	"./oc-lnc.js": "GZ5A",
	"./pa-in": "pmsz",
	"./pa-in.js": "pmsz",
	"./pl": "WD3i",
	"./pl.js": "WD3i",
	"./pt": "TfcT",
	"./pt-br": "oLPB",
	"./pt-br.js": "oLPB",
	"./pt.js": "TfcT",
	"./rn": "4rH+",
	"./rn.js": "4rH+",
	"./ro": "ArT2",
	"./ro.js": "ArT2",
	"./ru": "uJ5d",
	"./ru.js": "uJ5d",
	"./rw": "7Kc7",
	"./rw.js": "7Kc7",
	"./sd": "2K85",
	"./sd.js": "2K85",
	"./se": "tUVU",
	"./se.js": "tUVU",
	"./si": "3APx",
	"./si.js": "3APx",
	"./sk": "wXaR",
	"./sk.js": "wXaR",
	"./sl": "VBrG",
	"./sl.js": "VBrG",
	"./sq": "xiHR",
	"./sq.js": "xiHR",
	"./sr": "lcjf",
	"./sr-cyrl": "P2Ta",
	"./sr-cyrl.js": "P2Ta",
	"./sr.js": "lcjf",
	"./ss": "fmvT",
	"./ss.js": "fmvT",
	"./sv": "6N7W",
	"./sv-fi": "ETrX",
	"./sv-fi.js": "ETrX",
	"./sv.js": "6N7W",
	"./sw": "xBTJ",
	"./sw.js": "xBTJ",
	"./ta": "7uBO",
	"./ta.js": "7uBO",
	"./te": "TCUs",
	"./te.js": "TCUs",
	"./tet": "/n4M",
	"./tet.js": "/n4M",
	"./tg": "/sTo",
	"./tg.js": "/sTo",
	"./th": "70gj",
	"./th.js": "70gj",
	"./tk": "zRCG",
	"./tk.js": "zRCG",
	"./tl-ph": "XPc6",
	"./tl-ph.js": "XPc6",
	"./tlh": "2Zy+",
	"./tlh.js": "2Zy+",
	"./tr": "97ee",
	"./tr.js": "97ee",
	"./types.d.ts": "nV4w",
	"./tzl": "z095",
	"./tzl.js": "z095",
	"./tzm": "5MwZ",
	"./tzm-latn": "XOnx",
	"./tzm-latn.js": "XOnx",
	"./tzm.js": "5MwZ",
	"./ug-cn": "DXQ0",
	"./ug-cn.js": "DXQ0",
	"./uk": "friy",
	"./uk.js": "friy",
	"./ur": "Wrv1",
	"./ur.js": "Wrv1",
	"./uz": "IFxE",
	"./uz-latn": "9JqJ",
	"./uz-latn.js": "9JqJ",
	"./uz.js": "IFxE",
	"./vi": "/LcT",
	"./vi.js": "/LcT",
	"./x-pseudo": "rRn+",
	"./x-pseudo.js": "rRn+",
	"./yo": "Jp64",
	"./yo.js": "Jp64",
	"./zh": "L5bc",
	"./zh-cn": "uM1m",
	"./zh-cn.js": "uM1m",
	"./zh-hk": "Q/NU",
	"./zh-hk.js": "Q/NU",
	"./zh-tw": "vxUN",
	"./zh-tw.js": "vxUN",
	"./zh.js": "L5bc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "273U";

/***/ }),

/***/ "27Yv":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/94e4fd4b08789b3efe68e19416146174.svg";

/***/ }),

/***/ "2atI":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/20ce1e1c6c52ac50d85a51336b714b29.svg";

/***/ }),

/***/ "2z6x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// For local development, we can use mock-rest-server (or a similar REST server like json-server)
//
// You should be able to use this code as is, apart from perhaps changing MOCK_SERVICE_PORT to whatever
// port you're using for your mock server.

var MOCK_SERVICES_PORT = 4321;

var MOCK_SERVICES_HOST = 'localhost';
var MOCK_SERVICES_URL = 'http://' + MOCK_SERVICES_HOST + ':' + MOCK_SERVICES_PORT; // eslint-disable-line no-unused-vars


// The app's configuration will have a base URL for each service we use.  For local testing, we define
// the configuration to point to our local server.
//
// For each resource, we have a constant for the base URL, as it would be in production. For example,
// below we have "AvatarAdminBaseUrl" which represents the base of the URL for access to all of
// the Avatar Admin application's resources.  Replace that with the resource(s) your application uses.

var localConfig = {
    BaseName: ''
};

exports.default = localConfig;

/***/ }),

/***/ "3Q3o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!action) return state;

    var payload = action.payload,
        type = action.type;

    switch (type) {
        case _localeActions.SET_LOCALE_DATA:
            {
                return _extends({}, payload.translations);
            }
        default:
            return state;
    }
};

var _localeActions = __webpack_require__("rrpD");

var defaultState = {
    trans: null
};

/**
 * Participation Report Reducer
 *
 * Consumes PARTICIPATION_REPORT_RETRIEVED action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - current participation report info
 */

/***/ }),

/***/ "3a/N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Overview = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("4n+p");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("M4fF");

var _icon_classes = __webpack_require__("vwzQ");

var _icon_classes2 = _interopRequireDefault(_icon_classes);

var _reactComponents = __webpack_require__("fmgT");

var _overviewActions = __webpack_require__("JZ7m");

var _overviewActions2 = _interopRequireDefault(_overviewActions);

var _selectedClassActions = __webpack_require__("7wS1");

var _selectedClassActions2 = _interopRequireDefault(_selectedClassActions);

var _overview = __webpack_require__("4kNV");

var _overview2 = _interopRequireDefault(_overview);

var _modalActions = __webpack_require__("P039");

var _modalActions2 = _interopRequireDefault(_modalActions);

var _academicYearActions = __webpack_require__("nRKh");

var _academicYearActions2 = _interopRequireDefault(_academicYearActions);

var _datePickerActions = __webpack_require__("qFO3");

var _datePickerActions2 = _interopRequireDefault(_datePickerActions);

var _overviewConstants = __webpack_require__("VJOB");

var _iconMessage = __webpack_require__("nOMl");

var _iconMessage2 = _interopRequireDefault(_iconMessage);

var _headerWithAcademicYear = __webpack_require__("+pLX");

var _headerWithAcademicYear2 = _interopRequireDefault(_headerWithAcademicYear);

var _localeActions = __webpack_require__("rrpD");

var _localeActions2 = _interopRequireDefault(_localeActions);

var _datePicker = __webpack_require__("9PoH");

var _datePickerConstants = __webpack_require__("p2pT");

var _localeUtils = __webpack_require__("MGx+");

var _button = __webpack_require__("rAoZ");

var _button2 = _interopRequireDefault(_button);

var _utils = __webpack_require__("6QRH");

var _downloadIcon = __webpack_require__("vGvd");

var _downloadIcon2 = _interopRequireDefault(_downloadIcon);

var _downloadConstants = __webpack_require__("XrKD");

var _popupMenu = __webpack_require__("4dSe");

var _popupMenu2 = _interopRequireDefault(_popupMenu);

var _toastContainer = __webpack_require__("9L0d");

var _downloadCertificatesActions = __webpack_require__("EzKo");

var _downloadCertificatesActions2 = _interopRequireDefault(_downloadCertificatesActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Overview Redux component
 * Receives data via 'props'
 * Base component for Overview page, displaying data table, search bar, date picker, etc.
 */
var Overview = exports.Overview = (_temp = _class = function (_Component) {
    _inherits(Overview, _Component);

    function Overview(props) {
        _classCallCheck(this, Overview);

        var _this = _possibleConstructorReturn(this, (Overview.__proto__ || Object.getPrototypeOf(Overview)).call(this, props));

        _this.filterClasses = function (data, filterText) {
            filterText = filterText.toLowerCase();
            return data.filter(function (c) {
                return c.class.toLowerCase().indexOf(filterText) > -1;
            });
        };

        _this.highlightClass = function (classrooms, selectedClassroom) {
            if (selectedClassroom) {
                classrooms = classrooms.map(function (item) {
                    return _extends({}, item, {
                        className: selectedClassroom.id === item.id ? _overview2.default.selected : null
                    });
                });
            }
            return classrooms;
        };

        _this.setTableData = function (data, selectedClassroom) {
            data = _this.highlightClass(data, selectedClassroom);
            _this.setState({
                classOverviewData: data,
                selectedClassroom: selectedClassroom
            });
        };

        _this.setConfig = function (fullTotal, emptyDataText) {
            var tableConfig = (0, _lodash.cloneDeep)(_overviewConstants.TABLE_CONFIG);
            var localeData = _this.props.localeData;

            tableConfig.onSelectRow = _this.onSelectRow;
            (0, _localeUtils.translateTableLabels)(tableConfig, localeData, false, fullTotal);
            if (emptyDataText) {
                tableConfig.emptyDataMessage = _react2.default.createElement(_iconMessage2.default, { iconSrc: _icon_classes2.default, message: emptyDataText });
            }
            _this.setState({ tableConfig: tableConfig });
        };

        _this.displayError = function (error) {
            var localeData = _this.props.localeData;

            _this.props.openModal({
                title: localeData['Modal - Oops'],
                content: _react2.default.createElement(
                    'p',
                    null,
                    error
                ),
                buttons: [{ title: localeData['Modal - TryAgain'], primary: true }]
            });
        };

        _this.onNextClick = function () {
            var setSelectedClass = _this.props.setSelectedClass;
            var selectedClassroom = _this.state.selectedClassroom;

            setSelectedClass(selectedClassroom);
            var history = _this.context.router.history;

            history.push('/class-details');
        };

        _this.onSelectRow = function (row) {
            var classOverviewData = _this.state.classOverviewData;

            _this.setTableData(classOverviewData, row);
            _this.setState({ selectedClassroom: row });
        };

        _this.showPrintModal = function (_ref) {
            var total = _ref.total,
                selectedDateRange = _ref.selectedDateRange,
                localeData = _ref.localeData,
                classroomId = _ref.classroomId,
                downloadAllSchoolOrClassCerts = _ref.downloadAllSchoolOrClassCerts,
                filterText = _ref.filterText;

            _this.props.openModal({
                title: total + ' ' + (total === 1 ? localeData['Label - Certificate'] : localeData['Label - Certificates']),
                content: '' + localeData['PrintModal - SelectVersion'],
                certificatesCount: total,
                buttons: [{
                    title: '' + localeData['Label - FullColour'],
                    primary: true,
                    icon: _downloadIcon2.default,
                    btnType: _downloadConstants.FULL_COLOR,
                    handler: function handler() {
                        return downloadAllSchoolOrClassCerts({
                            fullColor: true,
                            classroomId: classroomId,
                            filterText: filterText,
                            startDate: selectedDateRange.startDate,
                            endDate: selectedDateRange.endDate,
                            downloadType: _downloadConstants.FULL_COLOR
                        });
                    }

                }, {
                    title: '' + localeData['Label - PrintFriendly'],
                    primary: true,
                    icon: _downloadIcon2.default,
                    btnType: _downloadConstants.PRINT_FRIENDLY,
                    handler: function handler() {
                        return downloadAllSchoolOrClassCerts({
                            fullColor: false,
                            classroomId: classroomId,
                            filterText: filterText,
                            startDate: selectedDateRange.startDate,
                            endDate: selectedDateRange.endDate,
                            downloadType: _downloadConstants.PRINT_FRIENDLY
                        });
                    }
                }],
                useNewModal: true
            });
        };

        _this.downloadCertificateOrReports = function (event) {
            var _this$state = _this.state,
                classOverviewData = _this$state.classOverviewData,
                searchFieldText = _this$state.searchFieldText;
            var _this$props = _this.props,
                selectedDateRange = _this$props.selectedDateRange,
                localeData = _this$props.localeData,
                downloadAllSchoolOrClassCerts = _this$props.downloadAllSchoolOrClassCerts;

            var totalCertificates = (0, _utils.calculateTotal)(classOverviewData);

            _this.setState(_extends({}, _this.state, {
                shouldDisplayDropdown: false
            }));

            if (event.target.id === '0') {
                if (totalCertificates > _utils.CERTIFICATE_DOWNLOAD_LIMIT) {
                    _this.setState(_extends({}, _this.state, {
                        shouldDisplayDropdown: false,
                        showToast: true
                    }));
                } else {
                    _this.showPrintModal({
                        total: totalCertificates,
                        selectedDateRange: selectedDateRange,
                        localeData: localeData,
                        classroomId: 0,
                        filterText: searchFieldText,
                        downloadAllSchoolOrClassCerts: downloadAllSchoolOrClassCerts
                    });
                }
            }

            var showToastTimer = setTimeout(function () {
                _this.setState(_extends({}, _this.state, {
                    showToast: false
                }));
                clearTimeout(showToastTimer);
            }, 3000);
        };

        _this.handleOutsideClick = function (event) {
            if (_this.state.shouldDisplayDropdown && !_this.state.dropdownTriggered) {
                _this.setState({ shouldDisplayDropdown: false });
                event.stopPropagation();
            }
            _this.setState({
                dropdownTriggered: false
            });
        };

        _this.state = {
            tableConfig: null,
            classOverviewData: [],
            selectedClassroom: null,
            searchFieldText: '',
            localeData: {},
            shouldDisplayDropdown: false,
            showToast: false,
            dropdownTriggered: false
        };
        _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
        return _this;
    }

    _createClass(Overview, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('click', this.handleOutsideClick);
            var _props = this.props,
                updateSelectedDateRange = _props.updateSelectedDateRange,
                selectedDateRange = _props.selectedDateRange,
                setTranslationData = _props.setTranslationData;


            if (!selectedDateRange.startDate) {
                this.getAcademicYear();
            } else {
                updateSelectedDateRange(selectedDateRange.type, selectedDateRange.startDate, selectedDateRange.endDate);
            }

            setTranslationData();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this.handleOutsideClick);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var selectedDateRange = this.props.selectedDateRange;


            if (selectedDateRange !== nextProps.selectedDateRange) {
                var _nextProps$selectedDa = nextProps.selectedDateRange,
                    startDate = _nextProps$selectedDa.startDate,
                    endDate = _nextProps$selectedDa.endDate;

                this.getClassOverviewData(startDate, endDate);
            }
        }
    }, {
        key: 'getAcademicYear',
        value: function getAcademicYear() {
            var _this2 = this;

            var _props2 = this.props,
                getAcademicYear = _props2.getAcademicYear,
                updateSelectedDateRange = _props2.updateSelectedDateRange;


            getAcademicYear().then(function (action) {
                if (action.type === _academicYearActions.ACADEMIC_YEAR_RETRIEVED) {
                    var _action$payload = action.payload,
                        startDate = _action$payload.startDate,
                        endDate = _action$payload.endDate;

                    updateSelectedDateRange(_datePickerConstants.THIS_SCHOOL_YEAR, startDate, endDate);
                } else {
                    _this2.displayError(action.error);
                }
            }, function (error) {
                return _this2.displayError(error.message);
            });
        }
    }, {
        key: 'getClassOverviewData',
        value: function getClassOverviewData(startDate, endDate) {
            var _this3 = this;

            var _props3 = this.props,
                getClassOverviewData = _props3.getClassOverviewData,
                productId = _props3.productId;


            getClassOverviewData(startDate, endDate, productId).then(function (action) {
                if (action.type === _overviewActions.CLASS_OVERVIEW_DATA_RETRIEVED) {
                    _this3.setClassOverviewData(action.payload.data);
                } else {
                    _this3.displayError(action.error);
                }
            }, function (error) {
                return _this3.displayError(error.message);
            });
        }
    }, {
        key: 'setClassOverviewData',
        value: function setClassOverviewData(classOverviewData) {
            var filterText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.filterText;
            var _props4 = this.props,
                selectedClassroom = _props4.selectedClassroom,
                localeData = _props4.localeData;


            this.setState(_extends({}, this.state, {
                searchFieldText: filterText
            }));
            var emptyDataText = localeData[_overviewConstants.NO_CLASSES_FOUND_LOAD];
            if (filterText) {
                classOverviewData = this.filterClasses(classOverviewData, filterText);
                emptyDataText = localeData[_overviewConstants.NO_CLASSES_FOUND_SEARCH];
            }
            var fullTotal = (0, _utils.calculateTotal)(classOverviewData).toString();

            this.setConfig(fullTotal, emptyDataText);
            this.setTableData(classOverviewData, selectedClassroom);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                tableConfig = _state.tableConfig,
                classOverviewData = _state.classOverviewData,
                selectedClassroom = _state.selectedClassroom,
                shouldDisplayDropdown = _state.shouldDisplayDropdown,
                showToast = _state.showToast;
            var _props5 = this.props,
                academicYear = _props5.academicYear,
                selectedDateRange = _props5.selectedDateRange,
                updateSelectedDateRange = _props5.updateSelectedDateRange,
                localeData = _props5.localeData,
                downloadCertificatesState = _props5.downloadCertificatesState;

            var isDownloadActive = downloadCertificatesState.isActive;
            var disableButton = !selectedClassroom;
            var title = localeData['Header - OverviewTitle'];
            var classNameLabel = localeData['Label - ClassName'];
            var nextLabel = localeData['Label - Next'];
            var totalCertificatesInAllClasses = (0, _utils.calculateTotal)(classOverviewData);
            var downloadDisabled = totalCertificatesInAllClasses === 0;
            var options = [{ label: 'certificate', value: localeData['DropDown - All Certificates'] }];
            var toastData = {
                messageData: {
                    message: localeData['Toast - Too Many Certificate Error Message'],
                    type: 'fail',
                    hasClose: true
                }
            };

            return _react2.default.createElement(
                'div',
                { className: _overview2.default.component },
                _react2.default.createElement(_headerWithAcademicYear2.default, { title: title, academicYear: academicYear }),
                _react2.default.createElement(
                    'div',
                    { className: _overview2.default['main-content'] },
                    _react2.default.createElement(
                        'div',
                        { className: _overview2.default['header-container'] },
                        _react2.default.createElement(
                            'div',
                            { className: _overview2.default['search-container'] },
                            _react2.default.createElement(_reactComponents.Search, {
                                onType: function onType(filterText) {
                                    _this4.setClassOverviewData(_this4.props.classOverviewData, filterText);
                                },
                                placeholder: classNameLabel
                            })
                        ),
                        showToast && _react2.default.createElement(_toastContainer.ToastContainer, { toastData: toastData }),
                        _react2.default.createElement(
                            'div',
                            { className: _overview2.default['download-search-container'] },
                            _react2.default.createElement(_button2.default, {
                                className: _overview2.default['export-button'],
                                text: localeData['Label - Export'],
                                primary: false,
                                type: _button2.default.LOZENGE,
                                size: _button2.default.LARGE,
                                onClick: function onClick() {
                                    // eslint-disable-next-line max-len
                                    (0, _utils.exportStudentCertificates)(0, _this4.state.searchFieldText, selectedDateRange);
                                }
                            }),
                            _react2.default.createElement(_button2.default, {
                                className: _overview2.default['download-button'],
                                text: isDownloadActive ? localeData['Label - Preparing download'] : localeData['Label - Download'],
                                primary: false,
                                type: _button2.default.LOZENGE,
                                size: _button2.default.SMALL,
                                icon: isDownloadActive ? null : _downloadIcon2.default,
                                alignIcon: _button2.default.RIGHT,
                                btnType: _downloadConstants.ALL_NEW,
                                disabled: isDownloadActive,
                                onClick: function onClick() {
                                    _this4.setState(_extends({}, _this4.state, {
                                        shouldDisplayDropdown: !_this4.state.shouldDisplayDropdown,
                                        dropdownTriggered: !_this4.state.shouldDisplayDropdown
                                    }));
                                }
                            }),
                            shouldDisplayDropdown && _react2.default.createElement(_popupMenu2.default, {
                                downloadDisabled: downloadDisabled,
                                isClassLevel: false,
                                options: options,
                                downloadCertificateOrReports: this.downloadCertificateOrReports
                            }),
                            _react2.default.createElement(_datePicker.DatePicker, {
                                currentDate: selectedDateRange,
                                academicYear: academicYear,
                                onDateChange: updateSelectedDateRange,
                                localeData: localeData
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _overview2.default['table-container'] },
                        _react2.default.createElement(_reactComponents.DataTable, {
                            className: _overview2.default['data-table'],
                            config: tableConfig,
                            data: classOverviewData,
                            onSelect: this.onSelectRow
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactComponents.Footer,
                    { alignChildren: _reactComponents.Footer.RIGHT },
                    _react2.default.createElement(_reactComponents.Button, {
                        text: nextLabel,
                        type: _reactComponents.Button.LOZENGE,
                        size: _reactComponents.Button.LARGE,
                        primary: true,
                        onClick: this.onNextClick,
                        disabled: disableButton
                    })
                )
            );
        }
    }]);

    return Overview;
}(_react.Component), _class.contextTypes = {
    router: _propTypes2.default.object
}, _class.propTypes = {
    classOverviewData: _propTypes2.default.array,
    selectedDateRange: _propTypes2.default.shape({
        type: _propTypes2.default.string,
        startDate: _propTypes2.default.string,
        endDate: _propTypes2.default.string
    }),
    getClassOverviewData: _propTypes2.default.func,
    openModal: _propTypes2.default.func,
    localeData: _propTypes2.default.object,
    setTranslationData: _propTypes2.default.func,
    getAcademicYear: _propTypes2.default.func,
    updateSelectedDateRange: _propTypes2.default.func,
    setSelectedClass: _propTypes2.default.func,
    productId: _propTypes2.default.string,
    selectedClassroom: _propTypes2.default.shape({
        id: _propTypes2.default.number,
        class: _propTypes2.default.string
    }),
    academicYear: _propTypes2.default.shape({
        startDate: _propTypes2.default.string,
        endDate: _propTypes2.default.string
    }),
    downloadAllSchoolOrClassCerts: _propTypes2.default.func,
    downloadCertificatesState: _propTypes2.default.object
}, _temp);

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */

function mapStateToProps(state) {
    return {
        localeData: state.localeData,
        classOverviewData: state.classOverviewData,
        selectedDateRange: state.selectedDateRange,
        productId: state.productId,
        selectedClassroom: state.selectedClass,
        academicYear: state.academicYear,
        studentCertificates: state.studentCertificates,
        downloadCertificatesState: state.downloadCertificatesState
    };
}

/**
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        setTranslationData: _localeActions2.default.setTranslationData,
        getClassOverviewData: _overviewActions2.default.getClassOverviewData,
        openModal: _modalActions2.default.openModal,
        getAcademicYear: _academicYearActions2.default.getAcademicYear,
        updateSelectedDateRange: _datePickerActions2.default.updateSelectedDateRange,
        setSelectedClass: _selectedClassActions2.default.setSelectedClass,
        downloadAllSchoolOrClassCerts: _downloadCertificatesActions2.default.downloadAllSchoolOrClassCerts
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Overview);

/***/ }),

/***/ "40IM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactComponents = __webpack_require__("fmgT");

var _modal = __webpack_require__("Oe6b");

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Modal component
 * Displays content and buttons (if provided)
 */
var Modal = function Modal(_ref) {
    var message = _ref.message,
        onClose = _ref.onClose;
    return _react2.default.createElement(
        'div',
        { className: _modal2.default.component },
        _react2.default.createElement(
            'div',
            { className: _modal2.default.content },
            message.title && _react2.default.createElement(
                'h2',
                null,
                message.title
            ),
            message.content,
            message.buttons ? _react2.default.createElement(
                'div',
                { className: _modal2.default.actions },
                message.buttons.map(function (item) {
                    // determine required props for Button component
                    var styleProps = {};
                    ['primary', 'danger', 'info', 'disabled'].forEach(function (className) {
                        if (item[className]) {
                            styleProps[className] = true;
                        }
                    });
                    return _react2.default.createElement(_reactComponents.Button, _extends({}, styleProps, {
                        key: _lodash2.default.uniqueId(),
                        text: item.title,
                        onClick: function onClick() {
                            if (item.handler) {
                                item.handler();
                            } else {
                                onClose();
                            }
                        }
                    }));
                })
            ) : null
        )
    );
};

Modal.propTypes = {
    onClose: _propTypes2.default.func,
    message: _propTypes2.default.shape({
        id: _propTypes2.default.number,
        content: _propTypes2.default.element,
        buttons: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            title: _propTypes2.default.string,
            handler: _propTypes2.default.func,
            primary: _propTypes2.default.bool,
            danger: _propTypes2.default.bool,
            info: _propTypes2.default.bool,
            disabled: _propTypes2.default.bool
        }))
    })
};

exports.default = (0, _reactStyleable2.default)(_modal2.default)(Modal);

/***/ }),

/***/ "4Ksa":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/621f18c4ac0a250be364bc964699d809.svg";

/***/ }),

/***/ "4dSe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _popupMenu = __webpack_require__("ukx/");

var _popupMenu2 = _interopRequireDefault(_popupMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopUpMenu = function PopUpMenu(_ref) {
    var downloadDisabled = _ref.downloadDisabled,
        isClassLevel = _ref.isClassLevel,
        options = _ref.options,
        downloadCertificateOrReports = _ref.downloadCertificateOrReports;

    var menu = options.map(function (item, index) {
        return _react2.default.createElement(
            'button',
            {
                key: item.label,
                id: index,
                'aria-hidden': 'true',
                className: _popupMenu2.default['popup-menu-item'] + '\n                ' + (downloadDisabled && index === 0 ? _popupMenu2.default.popupDisabled : '')
                /* TODO uncomment when participation option is needed
                     ${isClassLevel ? '' : css.popupMenuItemSingleItem} */
                , disabled: downloadDisabled && index === 0,
                onClick: downloadCertificateOrReports
            },
            item.value
        );
    });

    return _react2.default.createElement(
        'div',
        { className: _popupMenu2.default['popup-menu'] + '\n            ' + (isClassLevel ? _popupMenu2.default.moveLeft : '') },
        menu
    );
};

PopUpMenu.propTypes = {
    downloadDisabled: _propTypes2.default.bool,
    isClassLevel: _propTypes2.default.bool,
    options: _propTypes2.default.array,
    downloadCertificateOrReports: _propTypes2.default.func
};

exports.default = (0, _reactStyleable2.default)(_popupMenu2.default)(PopUpMenu);

/***/ }),

/***/ "4kNV":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("bKWa");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./overview.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./overview.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "5/Ko":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Override styles for specific components
 * Look at the Theming confluence doc for info on all available overrides:
 * https://mathletics.atlassian.net/wiki/spaces/BFT/pages/642515121/Theming
 * Alternatively, look in each component's styled.js file or 'theme overrides' story
 *
 */

exports.default = {
  button: {},
  calendar: {},
  container: {},
  dataTable: {},
  dropdownMenu: {},
  header: {},
  footer: {},
  modal: {},
  radio: {},
  search: {}
};

/***/ }),

/***/ "5F4+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateCertificateFilename = generateCertificateFilename;
exports.formatDateForFilename = formatDateForFilename;
exports.formatDateForGemCount = formatDateForGemCount;

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateCertificateFilename(_ref) {
    var classroomName = _ref.classroomName,
        _ref$studentName = _ref.studentName,
        studentName = _ref$studentName === undefined ? null : _ref$studentName,
        startDate = _ref.startDate,
        endDate = _ref.endDate;

    return classroomName + '_' + startDate + '_' + endDate + (studentName ? '_' + studentName : '');
}

/**
 * Format date as 'DDMM'
 */
/*
 * Helper function to genrate filenames for certificates
 */
function formatDateForFilename(date) {
    return (0, _moment2.default)(date).format('DDMM');
}

function formatDateForGemCount(date) {
    return (0, _moment2.default)(date).format('DD-MM-YYYY');
}

/***/ }),

/***/ "6BEW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("nIya");

var _certificateCount = __webpack_require__("NcRG");

var _certificateCount2 = _interopRequireDefault(_certificateCount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Certificate Count and display component
 * Displays number of Gold, Silver and Bronze certificates earned by the student
 */
var CertificateCount = function CertificateCount(_ref) {
    var icon = _ref.icon,
        title = _ref.title,
        count = _ref.count;
    return _react2.default.createElement(
        'div',
        { className: _certificateCount2.default.component },
        _react2.default.createElement(
            'div',
            { className: _certificateCount2.default.icon },
            _react2.default.createElement('img', { src: icon, alt: title })
        ),
        _react2.default.createElement(
            'div',
            { className: _certificateCount2.default.title },
            title
        ),
        _react2.default.createElement(
            'div',
            { className: _certificateCount2.default.count },
            count
        )
    );
};

CertificateCount.propTypes = {
    icon: _propTypes2.default.string,
    title: _propTypes2.default.string,
    count: _propTypes2.default.number
};

exports.default = (0, _reactStyleable2.default)(_certificateCount2.default)(CertificateCount);

/***/ }),

/***/ "6QRH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDownloadUrl = exports.CERTIFICATE_DOWNLOAD_LIMIT = exports.isUndefined = exports.formatDateForPayload = exports.formatDate = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Appends all params in paramData to the URL as well as the current auth token
 */
var getDownloadUrl = exports.getDownloadUrl = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var resourceUrl = _ref2.resourceUrl,
            paramData = _ref2.paramData,
            _ref2$dateFormat = _ref2.dateFormat,
            dateFormat = _ref2$dateFormat === undefined ? 'DD-MM-YYYY' : _ref2$dateFormat;
        var baseUrl, dateParams, parameters;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return _resources2.default.env.substituteConfigurationItems(resourceUrl);

                    case 2:
                        baseUrl = _context.sent;
                        dateParams = ['startDate', 'endDate'];

                        dateParams.forEach(function (dateParam) {
                            if (paramData[dateParam]) {
                                paramData[dateParam] = formatParamDate(paramData[dateParam], dateFormat);
                            }
                        });
                        parameters = _urlHelper2.default.generateQueryString(_extends({}, paramData));
                        return _context.abrupt('return', baseUrl + '?' + parameters.join('&'));

                    case 7:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getDownloadUrl(_x3) {
        return _ref.apply(this, arguments);
    };
}();

/*
 * Formats date into format needed by certificate gateway
 */


exports.handleDefaults = handleDefaults;
exports.capitalise = capitalise;
exports.calculateTotal = calculateTotal;
exports.calculateClassTotal = calculateClassTotal;
exports.exportStudentCertificates = exportStudentCertificates;

var _dayjs = __webpack_require__("oqQY");

var _dayjs2 = _interopRequireDefault(_dayjs);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _localeUtils = __webpack_require__("MGx+");

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _urlHelper = __webpack_require__("uOny");

var _urlHelper2 = _interopRequireDefault(_urlHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function handleDefaults(defaultObj, dynamicObj) {
    for (var key in dynamicObj) {
        defaultObj[key] = dynamicObj[key];
    }
    return defaultObj;
}

function capitalise(word) {
    var firstLetter = word.charAt(0);
    var firstLetterCap = firstLetter.toUpperCase();
    var remainingLetters = word.slice(1);
    return firstLetterCap + remainingLetters;
}
var formatDate = exports.formatDate = function formatDate(utcString) {
    var DATE_FORMAT = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD MMMM YYYY';

    var localTime = utcString.replace(/Z$/, '');

    return (0, _dayjs2.default)(localTime).format(DATE_FORMAT);
};

var formatDateForPayload = exports.formatDateForPayload = function formatDateForPayload(utcString) {
    var DATE_FORMAT = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MM-DD-YYYY';
    return (0, _dayjs2.default)(utcString).format(DATE_FORMAT);
};

var isUndefined = exports.isUndefined = function isUndefined(value) {
    return value === undefined || value === null;
};

function calculateTotal(data) {
    return data.map(function (item) {
        return item.total;
    }).reduce(function (acc, val) {
        return acc + val;
    }, 0);
}

// Class-details needs to use totalCertificates, as its data is setup differently
function calculateClassTotal(data) {
    var totalNew = data.map(function (item) {
        return item.totalNew;
    }).reduce(function (prev, curr) {
        return prev + curr;
    }, 0);
    var totalPast = data.map(function (item) {
        return item.totalPast;
    }).reduce(function (prev, curr) {
        return prev + curr;
    }, 0);
    return totalNew + totalPast;
}

var CERTIFICATE_DOWNLOAD_LIMIT = exports.CERTIFICATE_DOWNLOAD_LIMIT = 200;
function exportStudentCertificates(classroomId, filterText, selectedDateRange) {
    // eslint-disable-next-line no-underscore-dangle
    var appConfig = window._env_;
    var authToken = _resources2.default.env.authToken;
    var queryParams = ['authToken=' + authToken, 'classroomId=' + classroomId, 'nameFilter=' + (filterText || ''), 'startDate=' + formatDateForPayload(selectedDateRange.startDate), 'endDate=' + formatDateForPayload(selectedDateRange.endDate), 'locale=' + (0, _localeUtils.locale)()];
    var url = '';

    if (_urlHelper2.default.isRunningOnDeveloperMachine()) {
        queryParams.push('env=' + _resources2.default.env.name);
    } else {
        url = appConfig.SchoolUsageReportsGatewayBaseUrl;
    }

    url += '/school/export/classroom/usage?' + queryParams.join('&');

    window.open(url, '_blank');
}function formatParamDate(date, dateFormat) {
    return (0, _moment2.default)(date).format(dateFormat);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "77wF":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/e2acf5736e1d90846a624393f8656c69.svg";

/***/ }),

/***/ "7BBg":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/68cad50dfb195b18afb30ffcc16d20af.svg";

/***/ }),

/***/ "7L7O":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("r30a");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./rank-tiles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./rank-tiles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "7qIq":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("jq2L");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./date-picker-trans.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./date-picker-trans.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "7rey":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("4n+p");

var _button = __webpack_require__("rAoZ");

var _button2 = _interopRequireDefault(_button);

var _certificateIcon = __webpack_require__("05XZ");

var _certificateIcon2 = _interopRequireDefault(_certificateIcon);

var _certificateTemplate = __webpack_require__("yU2o");

var _certificateTemplate2 = _interopRequireDefault(_certificateTemplate);

var _certificatesConstants = __webpack_require__("J7W8");

var _downloadIcon = __webpack_require__("vGvd");

var _downloadIcon2 = _interopRequireDefault(_downloadIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * CertificateTemplate pro-forma template for stateless component
 * Displays certificate template with preview image and button to download
 * Calls onDownload prop when user clicks download button
 */

// import { PRIMARY, SECONDARY, CERTIFICATE_URLS } from './certificate-template-constants';
var CertificateTemplate = function CertificateTemplate(_ref) {
    var template = _ref.template,
        onDownload = _ref.onDownload,
        downloadCertificatesState = _ref.downloadCertificatesState;
    var type = template.type,
        total = template.total,
        label = template.label,
        isAllStudents = template.isAllStudents;

    var disabled = total === 0;
    var isActive = downloadCertificatesState.isActive,
        downloadType = downloadCertificatesState.downloadType;

    var hasSpinner = isActive && type === downloadType;
    return _react2.default.createElement(
        'div',
        { className: _certificateTemplate2.default['certificate-template'] + ' ' + type.toLowerCase(), key: type },
        _react2.default.createElement(_certificateIcon2.default, { className: _certificateTemplate2.default.icon, rank: type, total: isAllStudents ? 5 : total }),
        _react2.default.createElement(
            'p',
            { className: _certificateTemplate2.default['certificate-type'] },
            label
        ),
        _react2.default.createElement(
            'div',
            { className: _certificateTemplate2.default['btn-container'] },
            _react2.default.createElement(_button2.default, {
                className: _certificateTemplate2.default['download-btn'] + ' ' + (total === 0 ? _certificateTemplate2.default.disabled : ''),
                text: disabled ? '-' : total,
                icon: hasSpinner ? '' : _downloadIcon2.default,
                hasSpinner: hasSpinner,
                btnType: type,
                primary: true,
                onClick: onDownload,
                type: _button2.default.LOZENGE,
                alignIcon: _button2.default.RIGHT,
                disabled: disabled
            })
        )
    );
};

CertificateTemplate.propTypes = {
    template: _propTypes2.default.shape({
        type: _propTypes2.default.oneOf([_certificatesConstants.BRONZE_CERT_TYPE, _certificatesConstants.SILVER_CERT_TYPE, _certificatesConstants.GOLD_CERT_TYPE, _certificatesConstants.PLATINUM_CERT_TYPE, _certificatesConstants.EMERALD_CERT_TYPE, _certificatesConstants.DIAMOND_CERT_TYPE, _certificatesConstants.EPIC_CERT_TYPE, _certificatesConstants.LEGEND_CERT_TYPE, _certificatesConstants.BRONZE_CERT_TYPE_PAST, _certificatesConstants.SILVER_CERT_TYPE_PAST, _certificatesConstants.GOLD_CERT_TYPE_PAST]),
        total: _propTypes2.default.number,
        label: _propTypes2.default.string
    }),
    // schoolType: PropTypes.oneOf([PRIMARY, SECONDARY]),
    onDownload: _propTypes2.default.func,
    downloadCertificatesState: _propTypes2.default.object
};

function mapStateToProps(state) {
    return { downloadCertificatesState: state.downloadCertificatesState };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CertificateTemplate);

/***/ }),

/***/ "7wS1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SELECT_CLASS = undefined;

var _reduxActions = __webpack_require__("sTbe");

var SELECT_CLASS = exports.SELECT_CLASS = 'SELECT_CLASS';

var setSelectedClass = (0, _reduxActions.createAction)(SELECT_CLASS);

exports.default = {
    setSelectedClass: setSelectedClass
};

/***/ }),

/***/ "8FUX":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("gaf5");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./login-info.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./login-info.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "8P8H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  borderRadius: '5px',
  spacing: 8
};

/***/ }),

/***/ "9A8k":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/01f3acb5f0fcb67fa2071e939e16dcc9.svg";

/***/ }),

/***/ "9L0d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ToastContainer = undefined;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("4n+p");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _toast = __webpack_require__("cEic");

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToastContainer = exports.ToastContainer = function ToastContainer(_ref) {
    var messageData = _ref.toastData.messageData;
    return messageData ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_toast2.default, { messageData: messageData })
    ) : null;
};

function mapStateToProps(state) {
    return {
        toastData: state.toastData
    };
}

ToastContainer.propTypes = {
    toastData: _propTypes2.default.shape({
        messageData: _propTypes2.default.object
    })
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ToastContainer);

/***/ }),

/***/ "9PoH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DatePicker = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _datePickerTrans = __webpack_require__("C6s8");

var _datePickerTrans2 = _interopRequireDefault(_datePickerTrans);

var _localeUtils = __webpack_require__("MGx+");

var _datePickerConstants = __webpack_require__("p2pT");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DatePicker = exports.DatePicker = (_temp = _class = function (_Component) {
    _inherits(DatePicker, _Component);

    function DatePicker(props) {
        _classCallCheck(this, DatePicker);

        var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

        _this.getTranslatedOptions = function (options) {
            var localeData = _this.props.localeData;

            if (localeData) {
                return options.map(function (item) {
                    var label = localeData['Date Filters - ' + item.value];
                    item.label = label || item.value;
                    return item;
                });
            }
            return options;
        };

        _this.calendarLocaleData = function () {
            var localeData = _this.props.localeData;

            return {
                'Label - StartDate': localeData['Label - StartDate'],
                'Label - EndDate': localeData['Label - EndDate'],
                'Label - Monday': localeData['Label - Monday'],
                'Label - Sunday': localeData['Label - Sunday']
            };
        };

        _this.state = {
            options: _datePickerConstants.DEFAULT_DATE_OPTIONS_OBJ
        };
        return _this;
    }

    _createClass(DatePicker, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                academicYear = _props.academicYear,
                currentDate = _props.currentDate,
                onDateChange = _props.onDateChange,
                isLeft = _props.isLeft;
            var options = this.state.options;

            if (academicYear && currentDate && onDateChange) {
                return _react2.default.createElement(_datePickerTrans2.default, {
                    currentDate: currentDate,
                    options: this.getTranslatedOptions(options),
                    academicYear: academicYear,
                    onDateChange: onDateChange,
                    locale: (0, _localeUtils.locale)(),
                    calendarLocaleData: this.calendarLocaleData(),
                    isLeft: isLeft
                });
            }
            return null;
        }
    }]);

    return DatePicker;
}(_react.Component), _class.contextTypes = {
    router: _propTypes2.default.object
}, _class.propTypes = {
    academicYear: _propTypes2.default.shape({
        startDate: _propTypes2.default.string,
        endDate: _propTypes2.default.string
    }),
    currentDate: _propTypes2.default.shape({
        type: _propTypes2.default.string,
        startDate: _propTypes2.default.string,
        endDate: _propTypes2.default.string
    }),
    onDateChange: _propTypes2.default.func,
    localeData: _propTypes2.default.object,
    isLeft: _propTypes2.default.bool
}, _temp);
exports.default = DatePicker;

/***/ }),

/***/ "9wCx":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---1DYrF {\n  text-align: left;\n  padding: 0 16px; }\n  @media (min-width: 992px) {\n    .component---1DYrF {\n      padding: 0 24px; } }\n  .component---1DYrF .pointdetails---1t6qs .points---1rck_ {\n    color: #1981c4;\n    font-size: 24px;\n    line-height: 40px; }\n  @media (min-width: 768px) {\n      .component---1DYrF .pointdetails---1t6qs .points---1rck_ {\n        font-size: 28px; } }\n  @media (min-width: 992px) {\n      .component---1DYrF .pointdetails---1t6qs .points---1rck_ {\n        font-size: 45px; } }\n  .component---1DYrF .pointdetails---1t6qs .title---PJqTr {\n    color: #595959;\n    font-size: 15px; }\n  @media (min-width: 768px) {\n      .component---1DYrF .pointdetails---1t6qs .title---PJqTr {\n        font-size: 16px; } }\n  @media (min-width: 992px) {\n      .component---1DYrF .pointdetails---1t6qs .title---PJqTr {\n        font-size: 18px; } }\n  .component---1DYrF .logo---1d8n1 {\n    border-radius: 50%;\n    float: left;\n    margin-right: 12px;\n    width: 50px;\n    height: 50px; }\n  @media (min-width: 768px) {\n      .component---1DYrF .logo---1d8n1 {\n        width: 55px;\n        height: 55px; } }\n  @media (min-width: 992px) {\n      .component---1DYrF .logo---1d8n1 {\n        width: inherit;\n        height: inherit;\n        margin-right: 16px; } }\n  .component---1DYrF .logo---1d8n1.logo-tulip-background---2bweU {\n      background-color: #e7c240; }\n  .component---1DYrF .logo---1d8n1.logo-denim-background---2po0C {\n      background-color: #1981c4; }\n  .component---1DYrF .logo---1d8n1 svg {\n      height: 32px;\n      width: 39px;\n      padding: 9px 6px; }\n  @media (min-width: 768px) {\n        .component---1DYrF .logo---1d8n1 svg {\n          height: 38px;\n          width: 46px;\n          padding: 8px 5px; } }\n  @media (min-width: 992px) {\n        .component---1DYrF .logo---1d8n1 svg {\n          padding: 15px; } }\n  .component---1DYrF .logo---1d8n1 svg path {\n        fill: #fff !important; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1DYrF",
	"pointdetails": "pointdetails---1t6qs",
	"points": "points---1rck_",
	"title": "title---PJqTr",
	"logo": "logo---1d8n1",
	"logo-tulip-background": "logo-tulip-background---2bweU",
	"logo-denim-background": "logo-denim-background---2po0C"
};

/***/ }),

/***/ "AeEc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!action) return state;

    switch (action.type) {
        case _overviewActions.CLASS_OVERVIEW_DATA_RETRIEVED:
            return action.payload.data;
        default:
            return state;
    }
};

var _overviewActions = __webpack_require__("JZ7m");

var defaultState = [];

/**
 * Overview Reducer
 *
 * Consumes CLASS_OVERVIEW_DATA_RETRIEVED action
 *
 * @param {array} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - current list of items to display in overview table
 */

/***/ }),

/***/ "AgGf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!action) return state;

    switch (action.type) {
        case _studentCertificatesActions.STUDENT_CERTIFICATES_RETRIEVED:
            return action.payload;
        default:
            return state;
    }
};

var _studentCertificatesActions = __webpack_require__("SCGg");

var defaultState = {
    schoolType: null,
    allStudents: null,
    studentList: []
};

/**
 * Student Certificates Reducer
 *
 * Consumes STUDENT_CERTIFICATES_RETRIEVED action
 *
 * @param {array} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - contains list of individual student certificates for a class
 *                     as well as total for class
 */

/***/ }),

/***/ "AlNc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("LlfG");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./rank-dropdown.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./rank-dropdown.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "AoEh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---xXZpI {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 0px;\n          flex: 1 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  padding: 16px 0;\n  border-radius: 8.649px;\n  background: #fff;\n  -webkit-box-shadow: 0 4px 5px 0 rgba(0, 102, 116, .25);\n          box-shadow: 0 4px 5px 0 rgba(0, 102, 116, .25);\n  text-align: center;\n  color: #595959;\n  padding: 0 10px; }\n  @media (min-width: 992px) {\n    .component---xXZpI {\n      padding: 24px 0; } }\n  .component---xXZpI .heading---3KKEN {\n    font-size: 22px;\n    margin-top: 20px; }\n  .component---xXZpI .certificates---3Jgg- {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n  .component---xXZpI .goldbar---rBiOZ {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    padding-bottom: 10px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center; }\n  .component---xXZpI .goldbar---rBiOZ svg {\n      width: 75px; }\n  .component---xXZpI .goldbar---rBiOZ .goldbarCount---1ulTQ {\n      font-size: 18px;\n      padding: 0 16px; }\n  @media (min-width: 992px) {\n        .component---xXZpI .goldbar---rBiOZ .goldbarCount---1ulTQ {\n          font-size: 22px; } }\n", ""]);

// exports
exports.locals = {
	"component": "component---xXZpI",
	"heading": "heading---3KKEN",
	"certificates": "certificates---3Jgg-",
	"goldbar": "goldbar---rBiOZ",
	"goldbarCount": "goldbarCount---1ulTQ"
};

/***/ }),

/***/ "AqsK":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/4858dadd92c9d7d193a780c3679d6355.svg";

/***/ }),

/***/ "B+6S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = fetcher;

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetcher(url, filename) {
    return window.fetch(url, {
        headers: {
            AuthToken: _resources2.default.env.authToken
        }
    }).then(function (res) {
        if (res.status !== 200) {
            throw new Error(res.statusText || 'Unknown fetcher status message');
        }
        return res.blob();
    }).then(function (resObj) {
        var newBlob = new window.Blob([resObj], { type: 'application/pdf' });

        var href = window.URL.createObjectURL(newBlob);
        var link = window.document.createElement('a');
        link.href = href;
        link.download = filename;
        window.document.body.appendChild(link);
        link.click();
        window.document.body.removeChild(link);
    }).catch(function (err) {
        // eslint-disable-next-line no-console
        console.error('fetcher.js - ', err);
        throw new Error('fetcher.js - ' + err);
    });
} /* global window */
/*
* Using fetch method for downloading pdf files.
*/

/***/ }),

/***/ "B0Vz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = fetcherZip;

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetcherZip(url) {
    var headers = '';
    return window.fetch(url, {
        headers: {
            AuthToken: _resources2.default.env.authToken
        }
    }).then(function (res) {
        if (res.status !== 200) {
            throw new Error(res.statusText || 'Unknown fetcher status message');
        }
        headers = res.headers;
        return res.blob();
    }).then(function (resObj) {
        var newBlob = '';
        var filenameSeparator = headers.get('content-disposition').split(';');
        var filename = filenameSeparator[1].split('=');
        if (headers.get('content-type') === 'application/zip') {
            newBlob = new window.Blob([resObj], { type: 'application/zip' });
        }
        if (headers.get('content-type') === 'application/pdf') {
            newBlob = new window.Blob([resObj], { type: 'application/pdf' });
        }

        var href = window.URL.createObjectURL(newBlob);
        var link = window.document.createElement('a');
        link.href = href;
        link.download = '' + filename[1].replace(/['"]+/g, '');
        window.document.body.appendChild(link);
        link.click();
        window.document.body.removeChild(link);
    }).catch(function (err) {
        // eslint-disable-next-line no-console
        console.error('fetcher.js - ', err);
        throw new Error('fetcher.js - ' + err);
    });
} /* global window */
/*
* Using fetch method for downloading pdf files.
*/

/***/ }),

/***/ "BhLC":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/4c00e16f50d21811e7025c4d9fe70f31.svg";

/***/ }),

/***/ "BiE+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateHelper = function () {
    function DateHelper() {
        _classCallCheck(this, DateHelper);
    }

    _createClass(DateHelper, null, [{
        key: 'getPreviousMonday',
        value: function getPreviousMonday(date) {
            var prevMonday = date ? new Date(date) : new Date();
            prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7);
            return prevMonday;
        }
    }, {
        key: 'getThisWeekStartEnd',
        value: function getThisWeekStartEnd() {
            var formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';

            var thisMonday = DateHelper.getPreviousMonday();
            var startDate = (0, _moment2.default)(thisMonday).format(formatString);
            var endDate = (0, _moment2.default)(thisMonday).add(6, 'days').format(formatString);

            return { startDate: startDate, endDate: endDate };
        }
    }, {
        key: 'getLastWeekStartEnd',
        value: function getLastWeekStartEnd() {
            var formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';

            var thisMonday = DateHelper.getPreviousMonday();
            var startDate = (0, _moment2.default)(thisMonday).subtract(7, 'days').format(formatString);
            var endDate = (0, _moment2.default)(thisMonday).subtract(1, 'days').format(formatString);

            return { startDate: startDate, endDate: endDate };
        }
    }]);

    return DateHelper;
}();

exports.default = DateHelper;

/***/ }),

/***/ "C4aY":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/ab64515aac96f860a1d7eb690d9402d9.svg";

/***/ }),

/***/ "C6s8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps; /**
                                      * DatePicker component
                                      * Allows user to pick 'This week' 'Last week' 'This school year' or 'Custom date' from drop down.
                                      * Loads Calendar component if user chooses custom date range
                                      * Calls onDateChange callback prop when selection changes
                                      * User can pass in options list with translations
                                      */

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dayjs = __webpack_require__("oqQY");

var _dayjs2 = _interopRequireDefault(_dayjs);

var _icon_calendar = __webpack_require__("ZaYO");

var _icon_calendar2 = _interopRequireDefault(_icon_calendar);

var _reactComponents = __webpack_require__("fmgT");

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _calendar = __webpack_require__("KRbp");

var _calendar2 = _interopRequireDefault(_calendar);

var _datePickerConstants = __webpack_require__("p2pT");

var _dateHelper = __webpack_require__("BiE+");

var _dateHelper2 = _interopRequireDefault(_dateHelper);

var _datePickerTrans = __webpack_require__("7qIq");

var _datePickerTrans2 = _interopRequireDefault(_datePickerTrans);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * DatePickerTrans component
 * Allows user to pick 'This week' 'Last week' 'This school year' or 'Custom date' from drop down.
 * Loads Calendar component if user chooses custom date range
 * Calls onDateChange callback prop when selection changes
 */
var DatePickerTrans = (_temp = _class = function (_Component) {
    _inherits(DatePickerTrans, _Component);

    function DatePickerTrans(props) {
        _classCallCheck(this, DatePickerTrans);

        var _this = _possibleConstructorReturn(this, (DatePickerTrans.__proto__ || Object.getPrototypeOf(DatePickerTrans)).call(this, props));

        _initialiseProps.call(_this);

        var weeklyRangeOnly = props.weeklyRangeOnly,
            currentDate = props.currentDate,
            locale = props.locale,
            academicYear = props.academicYear;
        /**
         * SET LOCALE
         * */

        var localeCode = locale || 'en-AU';
        var path = 'dayjs/locale/' + localeCode.toLowerCase();
        try {
            // eslint-disable-next-line global-require,import/no-dynamic-require
            !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
        } catch (e) {
            // eslint-disable-next-line global-require,import/no-dynamic-require
            __webpack_require__("Z3Bs");
        }
        _dayjs2.default.locale(localeCode);
        _moment2.default.locale(locale);

        _this.state = {
            selectedOption: _this.getDefaultOption(),
            weeklyRangeOnly: weeklyRangeOnly !== undefined ? weeklyRangeOnly : true,
            selectedDateType: currentDate.type,
            useCustomDates: currentDate.type === _datePickerConstants.CUSTOM_DATE,
            initialDate: academicYear
        };
        return _this;
    }

    _createClass(DatePickerTrans, [{
        key: 'getDefaultOption',
        value: function getDefaultOption() {
            var _props = this.props,
                options = _props.options,
                type = _props.currentDate.type;

            return options.find(function (option) {
                return option.value === type;
            }) || options[0];
        }

        /**
         * Runs when user changes value in dropdown
         * Calls onDateChange prop with newly selected date range (unless user chose custom date)
         */


        /**
         * Runs when user selects start & end dates in calendar component
         * Calls onDateChange prop with newly selected date range
         */


        /**
         * Reverts date to previous selection if user cancelled selecting custom dates in calendar
         */


        /**
         * Generates the display text to show in the dropdown menu as the current selected option
         * Handles showing the date range if user chose custom date ie. 14 June 2018 - 28 June 2018
         */

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                selectedOption = _state.selectedOption,
                useCustomDates = _state.useCustomDates;
            var _props2 = this.props,
                academicYear = _props2.academicYear,
                reactDatesConfig = _props2.reactDatesConfig,
                options = _props2.options,
                calendarLocaleData = _props2.calendarLocaleData,
                isLeft = _props2.isLeft;

            var selectedDateType = selectedOption.value;
            /**
            * This boolean hides or shows the calendar component when required
            * for date range selection types for CustomDate or CustomDateTime
            * It is hidden again after selection of the range which may also include a time
            * @type {boolean}
            */
            var shouldDisplayCalendar = selectedDateType === _datePickerConstants.CUSTOM_DATE && !useCustomDates;
            return _react2.default.createElement(
                'div',
                { className: _datePickerTrans2.default['date-picker-wrapper'] },
                shouldDisplayCalendar && _react2.default.createElement(_calendar2.default, {
                    range: academicYear,
                    reactDatesConfig: reactDatesConfig,
                    onDatesPicked: this.onCustomDateChange,
                    onClose: this.onCustomDateClose,
                    localeData: calendarLocaleData,
                    isLeft: isLeft
                }),
                !shouldDisplayCalendar && _react2.default.createElement(_reactComponents.DropdownMenu, {
                    icon: _icon_calendar2.default,
                    options: options,
                    selectedOption: {
                        label: this.getSelectedLabel(),
                        value: selectedDateType
                    },
                    onSelectOption: function onSelectOption(option) {
                        return _this2.onDateChange(option);
                    }
                })
            );
        }
    }]);

    return DatePickerTrans;
}(_react.Component), _class.propTypes = {
    /** Range to limit the date selection to */
    academicYear: _propTypes2.default.shape({
        startDate: _propTypes2.default.string,
        endDate: _propTypes2.default.string
    }).isRequired,

    /** Current selected date */
    currentDate: _propTypes2.default.shape({
        type: _propTypes2.default.oneOf(_datePickerConstants.DATE_OPTIONS),
        startDate: _propTypes2.default.string,
        endDate: _propTypes2.default.string
    }).isRequired,

    /** Current selected date */
    locale: _propTypes2.default.string,

    /** Options to display in dropdown menu */
    options: _propTypes2.default.array,

    /** Callback when a date selection is made */
    onDateChange: _propTypes2.default.func.isRequired,

    /** Flag whether custom date range should be mon-sun
    *  enabled by default
    */
    weeklyRangeOnly: _propTypes2.default.bool,

    /** Props overrides for react-dates component
    * @see <a href="https://github.com/airbnb/react-dates#make-some-awesome-datepickers">react-dates props</a>
    */
    reactDatesConfig: _propTypes2.default.object,

    /**
     * calendarLocaleData
     */
    calendarLocaleData: _propTypes2.default.object,
    /** isLeft */
    isLeft: _propTypes2.default.bool
}, _class.defaultProps = {
    options: _datePickerConstants.DEFAULT_DATE_OPTIONS_OBJ
}, _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.onDateChange = function (option) {
        _this3.setState({
            selectedOption: option,
            useCustomDates: false,
            selectedTimeRange: false,
            dateTimeSubmitted: false
        });

        var startDate = void 0;
        var endDate = void 0;

        switch (option.value) {
            case _datePickerConstants.THIS_WEEK:
                var _DateHelper$getThisWe = _dateHelper2.default.getThisWeekStartEnd();

                startDate = _DateHelper$getThisWe.startDate;
                endDate = _DateHelper$getThisWe.endDate;

                break;
            case _datePickerConstants.LAST_WEEK:
                var _DateHelper$getLastWe = _dateHelper2.default.getLastWeekStartEnd();

                startDate = _DateHelper$getLastWe.startDate;
                endDate = _DateHelper$getLastWe.endDate;

                break;
            case _datePickerConstants.THIS_SCHOOL_YEAR:
            case _datePickerConstants.LIFETIME:
                var _props$academicYear = _this3.props.academicYear;
                startDate = _props$academicYear.startDate;
                endDate = _props$academicYear.endDate;

                break;
            case _datePickerConstants.CUSTOM_DATE:
            case _datePickerConstants.CUSTOM_DATE_TIME_OBJ.value:
                return;
            default:
                console.warn('Unhandled date type'); // eslint-disable-line no-console
        }

        _this3.props.onDateChange(option.value, startDate, endDate);
    };

    this.onCustomDateChange = function (startDate, endDate) {
        if (startDate && endDate) {
            var value = _this3.state.selectedOption.value;

            _this3.props.onDateChange(value, startDate, endDate);
            var label = _this3.getSelectedLabel();
            _this3.setState({
                selectedOption: {
                    label: label,
                    value: value
                },
                useCustomDates: true
            });
        }
    };

    this.onCustomDateClose = function () {
        // todo: i don't like this timeout but i couldn't get cancel functionality to
        // work without it
        setTimeout(function () {
            if (!_this3.state.useCustomDates) {
                _this3.setState({
                    selectedOption: _this3.getDefaultOption(),
                    useCustomDates: true,
                    hideSelectedTime: true
                });
            }
        });
    };

    this.getSelectedLabel = function () {
        var _state2 = _this3.state,
            selectedOption = _state2.selectedOption,
            time = _state2.time,
            localeCode = _state2.localeCode;

        if (selectedOption.value === _datePickerConstants.CUSTOM_DATE_TIME || selectedOption.value === _datePickerConstants.CUSTOM_DATE) {
            var _props$currentDate = _this3.props.currentDate,
                startDate = _props$currentDate.startDate,
                endDate = _props$currentDate.endDate;

            var formatString = 'DD MMM YYYY';
            _dayjs2.default.locale(localeCode);
            var formattedStartDate = (0, _dayjs2.default)(startDate).format(formatString);
            var formattedEndDate = (0, _dayjs2.default)(endDate).format(formatString);
            return selectedOption.value === _datePickerConstants.CUSTOM_DATE ? formattedStartDate + ' - ' + formattedEndDate : formattedStartDate + ' ' + time[0] + ' - ' + formattedEndDate + ' ' + time[1];
        }

        return selectedOption.label;
    };
}, _temp);
exports.default = (0, _reactStyleable2.default)(_datePickerTrans2.default)(DatePickerTrans);

/***/ }),

/***/ "C97H":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/f0857ad2ad70a026a72556e288dc5d72.svg";

/***/ }),

/***/ "CW1h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SET_PRODUCT_ID = undefined;

var _reduxActions = __webpack_require__("sTbe");

var SET_PRODUCT_ID = exports.SET_PRODUCT_ID = 'SET_PRODUCT_ID';

var setProductId = (0, _reduxActions.createAction)(SET_PRODUCT_ID);

exports.default = {
    setProductId: setProductId
};

/***/ }),

/***/ "CXkR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CLASS_DETAILS_DATA_RETRIEVED = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _resourceHandlers = __webpack_require__("Qbfx");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_DETAILS_DATA_RETRIEVED = exports.CLASS_DETAILS_DATA_RETRIEVED = 'CLASS_DETAILS_DATA_RETRIEVED';

function getClassDetailsData(classroomId, startDate, endDate) {
    return function (dispatch) {
        return _resources2.default.classDetails.get({ classroomId: classroomId }).withBody({ startDate: startDate, endDate: endDate }).send().then(function (payload) {
            var studentParticipations = payload.data.studentParticipations;

            var mappedData = studentParticipations.map(function (item) {
                var newCertificates = item.newCertificates,
                    totalCertificates = item.totalCertificates,
                    total = item.total;

                return _extends({
                    id: item.userProfileId,
                    student: item.firstName + ' ' + item.lastName,
                    firstName: item.firstName,
                    lastName: item.lastName,
                    participationPoints: item.activityPoints,
                    liveMathsPoints: item.liveMathsPoints,
                    goldPast: item.gold,
                    silverPast: item.silver,
                    bronzePast: item.bronze,
                    totalCertificates: totalCertificates,
                    totalPast: total,
                    totalNew: newCertificates.total
                }, newCertificates);
            });

            return (0, _resourceHandlers.handleResourceSuccess)(dispatch, payload, {
                type: CLASS_DETAILS_DATA_RETRIEVED,
                payload: mappedData
            });
        }, function (error) {
            return (0, _resourceHandlers.handleResourceError)(dispatch, error);
        });
    };
}

exports.default = {
    getClassDetailsData: getClassDetailsData
};

/***/ }),

/***/ "Ci4y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PARTICIPATION_REPORT_RETRIEVED = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
* Downloads participation report for entire class
*/
var downloadParticipationReport = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref4) {
        var paramData = _ref4.paramData;
        var url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return (0, _utils.getDownloadUrl)({
                            resourceUrl: _participationReportConstants.DOWNLOAD_PARTICIPATION_REPORT_URL,
                            paramData: paramData,
                            dateFormat: 'MM-DD-YYYY'
                        });

                    case 2:
                        url = _context.sent;
                        return _context.abrupt('return', function (dispatch) {
                            downloadServiceIsActive({
                                isActive: true,
                                dispatch: dispatch
                            });
                            return (0, _fetcherZip2.default)(url).then(function () {
                                downloadServiceIsActive({
                                    isActive: false,
                                    dispatch: dispatch
                                });
                            }).catch(function (err) {
                                (0, _resourceHandlers.handleResourceError)(dispatch, err, 'downloadAllClassPastCerts');
                                downloadServiceIsActive({
                                    isActive: false,
                                    dispatch: dispatch
                                });
                            });
                        });

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function downloadParticipationReport(_x) {
        return _ref3.apply(this, arguments);
    };
}();

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _resourceHandlers = __webpack_require__("Qbfx");

var _utils = __webpack_require__("6QRH");

var _participationReportConstants = __webpack_require__("HsVg");

var _downloadCertificatesActions = __webpack_require__("EzKo");

var _fetcherZip = __webpack_require__("B0Vz");

var _fetcherZip2 = _interopRequireDefault(_fetcherZip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var PARTICIPATION_REPORT_RETRIEVED = exports.PARTICIPATION_REPORT_RETRIEVED = 'PARTICIPATION_REPORT_RETRIEVED';

function getParticipationReport(_ref) {
    var productId = _ref.productId,
        profileId = _ref.profileId,
        schoolId = _ref.schoolId,
        classroomId = _ref.classroomId,
        startDate = _ref.startDate,
        endDate = _ref.endDate,
        academicYear = _ref.academicYear,
        locale = _ref.locale;

    return function (dispatch) {
        return _resources2.default.participationReport.get({ profileId: profileId }).withParams({ productId: productId, schoolId: schoolId, classroomId: classroomId, startDate: startDate, endDate: endDate, academicYear: academicYear, locale: locale }).send().then(function (payload) {
            var reportData = payload.data;
            if (reportData) {
                var newCertificateSummary = reportData.newCertificateSummary,
                    studentCertificateInfo = reportData.studentCertificateInfo,
                    courseResult = reportData.courseResult,
                    liveMathsResult = reportData.liveMathsResult,
                    questCourseResult = reportData.questCourseResult,
                    newCourseResult = reportData.newCourseResult,
                    challengesResult = reportData.challengesResult;


                return (0, _resourceHandlers.handleResourceSuccess)(dispatch, payload, {
                    type: PARTICIPATION_REPORT_RETRIEVED,
                    payload: _extends({}, reportData, {
                        newCertificateSummary: onlyRanksFromList(newCertificateSummary),
                        pastCertificateSummary: mapStudentAwards(studentCertificateInfo, courseResult),
                        courseResult: mapCourseResults(courseResult),
                        liveMathsResult: mapLiveMathsResult(liveMathsResult),
                        questCourseResult: mapQuestCourseResult(questCourseResult),
                        newCoursesResult: mapNewCoursesResult(newCourseResult),
                        challengesResult: mapChallengesResult(challengesResult)
                    })
                });
            }
            return (0, _resourceHandlers.handleResourceError)(dispatch, payload.message);
        }, function (error) {
            return (0, _resourceHandlers.handleResourceError)(dispatch, error);
        });
    };
}

function onlyRanksFromList(newCertificateSummary) {
    if (newCertificateSummary) {
        delete newCertificateSummary.total;
    }
    return newCertificateSummary;
}
function mapStudentAwards(studentCertificateInfo, courseResult) {
    if (!studentCertificateInfo || !courseResult) {
        return null;
    }

    var bronzePast = studentCertificateInfo.bronze,
        silverPast = studentCertificateInfo.silver,
        goldPast = studentCertificateInfo.gold;

    return {
        bronzePast: bronzePast,
        silverPast: silverPast,
        goldPast: goldPast,
        goldBarsPast: courseResult.goldBars
    };
}

function mapCourseResults(courseResult) {
    if (!courseResult || !courseResult.courses) {
        return null;
    }

    return _extends({}, courseResult, {
        courses: courseResult.courses.map(function (course) {
            var mappedActivities = course.allActivities.map(function (activity, idx) {
                return _extends({}, activity, {
                    id: activity.id + '-' + idx,
                    result: activity.result + '%',
                    completionDate: activity.completionDate ? (0, _utils.formatDate)(activity.completionDate) : '-'
                });
            });

            return {
                courseName: course.courseName,
                allActivities: mappedActivities,
                averageResult: 'Avg. ' + course.averageResult + '%',
                totalPoints: 'Total ' + course.totalPoints
            };
        })
    });
}

function mapLiveMathsResult(liveMathsResult) {
    if (!liveMathsResult) {
        return null;
    }

    var mappedLiveMathsInfo = liveMathsResult.liveMathsInfo.map(function (item) {
        return {
            id: item.level,
            level: item.level,
            correct: formatScore(item.correct, item.hasValue),
            points: formatScore(item.points, item.hasValue),
            accuracy: formatScore(item.accuracy, item.hasValue, '%')
        };
    });

    return {
        liveMathsInfo: mappedLiveMathsInfo,
        maxLiveMathsLevels: 'Maximum ' + liveMathsResult.maxLiveMathsLevels + ' levels',
        averageCorrect: 'Avg. ' + liveMathsResult.averageCorrect + '%',
        totalPoints: 'Total ' + liveMathsResult.totalPoints
    };
}

function mapQuestCourseResult(questCourseResult) {
    return questCourseResult.map(function (course) {
        course.averageAccuracy = 'Avg. ' + course.averageAccuracy + '%';
        course.allActivities.map(function (activity) {
            activity.completionDate = (0, _utils.formatDate)(activity.completionDate);
            activity.accuracy = activity.accuracy + '%';
            return activity;
        });

        return course;
    });
}
function mapNewCoursesResult(newCourseResult) {
    return newCourseResult.map(function (course) {
        course.courseResults.map(function (activity) {
            activity.completionDate = (0, _utils.formatDate)(activity.completionDate);
            activity.accuracy = activity.accuracy + '%';
            return activity;
        });
        course.averageResult = 'Avg. ' + course.averageAccuracy + '%';
        course.totalPoints = 'Total ' + course.totalPoints;
        return course;
    });
}

function mapChallengesResult(challengesResult) {
    if (!challengesResult || !challengesResult.challenges) {
        return null;
    }

    return {
        challenges: challengesResult.challenges.map(function (challenge) {
            return _extends({}, challenge, {
                id: challenge.name,
                completionDate: (0, _utils.formatDate)(challenge.completionDate),
                accuracy: challenge.accuracy + '%'
            });
        }),
        averageResult: 'Avg. ' + challengesResult.averageAccuracy + '%',
        totalPoints: 'Total ' + challengesResult.totalPoints
    };
}

function formatScore(score, hasValue, suffix) {
    if (score || score === 0 && hasValue) {
        if (suffix) {
            return '' + score + suffix;
        }
        return '' + score;
    }

    return '-';
}

function downloadServiceIsActive(_ref2) {
    var isActive = _ref2.isActive,
        dispatch = _ref2.dispatch;

    dispatch({
        type: _downloadCertificatesActions.DOWNLOAD_SERVICE_IS_ACTIVE,
        payload: {
            isActive: isActive
        }
    });
}exports.default = {
    getParticipationReport: getParticipationReport,
    downloadParticipationReport: downloadParticipationReport
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "CzYQ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("O7Sl");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./class-details.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./class-details.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "DDu0":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/c80487c920b6bfce6527b34a9d41f95a.svg";

/***/ }),

/***/ "EC7T":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/af48912d019b4f06798ceb5891b0d8e5.svg";

/***/ }),

/***/ "EzKo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DOWNLOAD_SERVICE_IS_ACTIVE = exports.CERTIFICATES_DOWNLOADED_FOR_TYPE = exports.ALL_CERTIFICATES_DOWNLOADED = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
* Downloads pdf Past Certificates for the entire class
*/
var downloadAllClassPastCerts = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref5) {
        var paramData = _ref5.paramData,
            filename = _ref5.filename;
        var url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return (0, _utils.getDownloadUrl)({
                            resourceUrl: _downloadConstants.DOWNLOAD_URL_ALL_STUDENTS_ALL_CERTS,
                            paramData: paramData,
                            dateFormat: 'MM-DD-YYYY'
                        });

                    case 2:
                        url = _context.sent;
                        return _context.abrupt('return', function (dispatch, getState) {
                            var downloadType = _downloadConstants.ALL_PAST;
                            downloadServiceIsActive({
                                isActive: true,
                                downloadType: downloadType,
                                dispatch: dispatch
                            });
                            (0, _fetcher2.default)(url, filename + '_PAST').then(function () {
                                dispatch({ type: ALL_CERTIFICATES_DOWNLOADED });
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            }).catch(function (err) {
                                (0, _resourceHandlers.handleResourceError)(dispatch, err, 'downloadAllClassPastCerts');
                                showFailDownloadToastMessage(dispatch, getState);
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            });
                        });

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function downloadAllClassPastCerts(_x) {
        return _ref4.apply(this, arguments);
    };
}();

/*
* Downloads all pdf Past Certificates for a students + type
*/


var downloadAllStudentPastCertsForType = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref7) {
        var userProfileId = _ref7.userProfileId,
            paramData = _ref7.paramData,
            actionType = _ref7.actionType,
            filename = _ref7.filename,
            downloadType = _ref7.downloadType;
        var url;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return (0, _utils.getDownloadUrl)({
                            resourceUrl: (0, _downloadConstants.generateUrlStudentCertsForType)(userProfileId),
                            paramData: paramData
                        });

                    case 2:
                        url = _context2.sent;
                        return _context2.abrupt('return', function (dispatch, getState) {
                            downloadServiceIsActive({
                                isActive: true,
                                downloadType: downloadType,
                                dispatch: dispatch
                            });
                            (0, _fetcher2.default)(url, filename + '_PAST').then(function () {
                                dispatch({ type: actionType });
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            }).catch(function (err) {
                                (0, _resourceHandlers.handleResourceError)(dispatch, err, 'downloadAllStudentPastCertsForType');
                                showFailDownloadToastMessage(dispatch, getState);
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            });
                        });

                    case 4:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function downloadAllStudentPastCertsForType(_x2) {
        return _ref6.apply(this, arguments);
    };
}();

/**
 * Downloads pdf Past Certificates for the entire class by type
 */


var downloadClassPastCertsForType = function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref9) {
        var certificateType = _ref9.certificateType,
            paramData = _ref9.paramData,
            filename = _ref9.filename,
            downloadType = _ref9.downloadType;
        var url;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return (0, _utils.getDownloadUrl)({
                            resourceUrl: (0, _downloadConstants.generateUrlAllStudentsCertsForType)(certificateType),
                            paramData: paramData
                        });

                    case 2:
                        url = _context3.sent;
                        return _context3.abrupt('return', function (dispatch, getState) {
                            downloadServiceIsActive({
                                isActive: true,
                                downloadType: downloadType,
                                dispatch: dispatch
                            });
                            (0, _fetcher2.default)(url, filename + '_PAST').then(function () {
                                dispatch({ type: CERTIFICATES_DOWNLOADED_FOR_TYPE });
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            }).catch(function (err) {
                                (0, _resourceHandlers.handleResourceError)(dispatch, err, 'downloadClassPastCertsForType');
                                showFailDownloadToastMessage(dispatch, getState);
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            });
                        });

                    case 4:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function downloadClassPastCertsForType(_x3) {
        return _ref8.apply(this, arguments);
    };
}();

/**
 * Downloads pdf Certificates for all types (gold, silver, bronze) in one file
 *
 */


/**
 * Downloads pdf New Certificates for the entire class
 */
var downloadAllClassNewCerts = function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref14) {
        var paramData = _ref14.paramData,
            filename = _ref14.filename,
            downloadType = _ref14.downloadType,
            gemTypes = _ref14.gemTypes;
        var url;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return (0, _utils.getDownloadUrl)({
                            resourceUrl: _downloadConstants.DOWNLOAD_URL_ALL_STUDENTS_ALL_NEW_CERTS,
                            paramData: paramData
                        });

                    case 2:
                        url = _context4.sent;


                        if (gemTypes) {
                            url = url.concat('&').concat(gemTypes.replace(/: /g, '=').replace(/, /g, '&'));
                        }

                        return _context4.abrupt('return', function (dispatch, getState) {
                            downloadServiceIsActive({
                                isActive: true,
                                downloadType: downloadType,
                                dispatch: dispatch
                            });
                            return (0, _fetcher2.default)(url, filename + '_NEW').then(function () {
                                dispatch({ type: ALL_CERTIFICATES_DOWNLOADED });
                                closeModal(dispatch);
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            }).catch(function (err) {
                                (0, _resourceHandlers.handleResourceError)(dispatch, err, 'downloadAllClassNewCerts');
                                showFailDownloadToastMessage(dispatch, getState);
                                closeModal(dispatch);
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            });
                        });

                    case 5:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function downloadAllClassNewCerts(_x4) {
        return _ref13.apply(this, arguments);
    };
}();

/*
 * Download all pdf New Certificates for a students
 */


var downloadStudentNewCerts = function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref16) {
        var userId = _ref16.userId,
            paramData = _ref16.paramData,
            actionType = _ref16.actionType,
            filename = _ref16.filename,
            downloadType = _ref16.downloadType,
            gemTypes = _ref16.gemTypes;
        var url;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return (0, _utils.getDownloadUrl)({
                            resourceUrl: (0, _downloadConstants.generateUrlStudentNewCerts)(userId),
                            paramData: paramData
                        });

                    case 2:
                        url = _context5.sent;


                        if (gemTypes) {
                            url = url.concat('&').concat(gemTypes.replace(/: /g, '=').replace(/, /g, '&'));
                        }

                        return _context5.abrupt('return', function (dispatch, getState) {
                            downloadServiceIsActive({
                                isActive: true,
                                downloadType: downloadType,
                                dispatch: dispatch
                            });
                            return (0, _fetcher2.default)(url, filename + '_NEW').then(function () {
                                dispatch({ type: actionType });
                                closeModal(dispatch);
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            }).catch(function (err) {
                                (0, _resourceHandlers.handleResourceError)(dispatch, err, 'downloadStudentNewCerts');
                                showFailDownloadToastMessage(dispatch, getState);
                                closeModal(dispatch);
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            });
                        });

                    case 5:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function downloadStudentNewCerts(_x5) {
        return _ref15.apply(this, arguments);
    };
}();

/*
* Downloads pdf New Certificates for the entire class by type
*
*/


var downloadClassNewCertsForType = function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref18) {
        var certificateRank = _ref18.certificateRank,
            paramData = _ref18.paramData,
            filename = _ref18.filename,
            downloadType = _ref18.downloadType,
            gemTypes = _ref18.gemTypes;
        var url;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        _context6.next = 2;
                        return (0, _utils.getDownloadUrl)({
                            resourceUrl: (0, _downloadConstants.generateUrlAllStudentsNewCertsForType)(certificateRank),
                            paramData: paramData
                        });

                    case 2:
                        url = _context6.sent;


                        if (gemTypes) {
                            url = url.concat('&').concat(gemTypes.replace(/: /g, '=').replace(/, /g, '&'));
                        }

                        return _context6.abrupt('return', function (dispatch, getState) {
                            downloadServiceIsActive({
                                isActive: true,
                                downloadType: downloadType,
                                dispatch: dispatch
                            });
                            (0, _fetcher2.default)(url, filename + '_NEW').then(function () {
                                dispatch({ type: CERTIFICATES_DOWNLOADED_FOR_TYPE });
                                closeModal(dispatch);
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            }).catch(function (err) {
                                (0, _resourceHandlers.handleResourceError)(dispatch, err, 'downloadClassNewCertsForType');
                                showFailDownloadToastMessage(dispatch, getState);
                                closeModal(dispatch);
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            });
                        });

                    case 5:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function downloadClassNewCertsForType(_x6) {
        return _ref17.apply(this, arguments);
    };
}();

/*
 * Download pdf New Certificates for a student by type
 *
 */


var downloadStudentNewCertsForType = function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref20) {
        var userId = _ref20.userId,
            certificateRank = _ref20.certificateRank,
            downloadType = _ref20.downloadType,
            paramData = _ref20.paramData,
            filename = _ref20.filename,
            gemTypes = _ref20.gemTypes;
        var url;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.next = 2;
                        return (0, _utils.getDownloadUrl)({
                            resourceUrl: (0, _downloadConstants.generateUrlStudentNewCertsForType)({ userId: userId, type: certificateRank }),
                            paramData: paramData
                        });

                    case 2:
                        url = _context7.sent;


                        if (gemTypes) {
                            url = url.concat('&').concat(gemTypes.replace(/: /g, '=').replace(/, /g, '&'));
                        }

                        return _context7.abrupt('return', function (dispatch, getState) {
                            downloadServiceIsActive({
                                isActive: true,
                                downloadType: downloadType,
                                dispatch: dispatch
                            });
                            (0, _fetcher2.default)(url, filename + '_NEW').then(function () {
                                dispatch({ type: CERTIFICATES_DOWNLOADED_FOR_TYPE });
                                closeModal(dispatch);
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            }).catch(function (err) {
                                (0, _resourceHandlers.handleResourceError)(dispatch, err, 'downloadStudentNewCertsForType');
                                showFailDownloadToastMessage(dispatch, getState);
                                closeModal(dispatch);
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            });
                        });

                    case 5:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, this);
    }));

    return function downloadStudentNewCertsForType(_x7) {
        return _ref19.apply(this, arguments);
    };
}();

/**
 * Downloads pdf of Certificates for the entire school/class based on type
 */


var downloadAllCerts = function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref22) {
        var paramData = _ref22.paramData,
            downloadType = _ref22.downloadType;
        var url;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        _context8.next = 2;
                        return (0, _utils.getDownloadUrl)({
                            resourceUrl: _downloadConstants.DOWNLOAD_URL_ALL_STUDENTS_ALL_CERTS,
                            paramData: paramData,
                            dateFormat: 'MM-DD-YYYY'
                        });

                    case 2:
                        url = _context8.sent;
                        return _context8.abrupt('return', function (dispatch, getState) {
                            downloadServiceIsActive({
                                isActive: true,
                                downloadType: downloadType,
                                dispatch: dispatch
                            });
                            closeModal(dispatch);

                            return (0, _fetcherZip2.default)(url).then(function () {
                                dispatch({ type: ALL_CERTIFICATES_DOWNLOADED });
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            }).catch(function (err) {
                                (0, _resourceHandlers.handleResourceError)(dispatch, err, 'downloadAllCerts');
                                showFailDownloadToastMessage(dispatch, getState);
                                closeModal(dispatch);
                                downloadServiceIsActive({
                                    isActive: false,
                                    downloadType: downloadType,
                                    dispatch: dispatch
                                });
                            });
                        });

                    case 4:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, this);
    }));

    return function downloadAllCerts(_x8) {
        return _ref21.apply(this, arguments);
    };
}();

var _certificatesConstants = __webpack_require__("J7W8");

var _downloadConstants = __webpack_require__("XrKD");

var _resourceHandlers = __webpack_require__("Qbfx");

var _fetcher = __webpack_require__("B+6S");

var _fetcher2 = _interopRequireDefault(_fetcher);

var _generateCertificateFilename = __webpack_require__("5F4+");

var _toastActions = __webpack_require__("l9Tw");

var _modalActions = __webpack_require__("P039");

var _utils = __webpack_require__("6QRH");

var _fetcherZip = __webpack_require__("B0Vz");

var _fetcherZip2 = _interopRequireDefault(_fetcherZip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Download Actions
 * Download certificates for one student or all students, by type (gold, silver, bronze)
 * or all in one
 */

var ALL_CERTIFICATES_DOWNLOADED = exports.ALL_CERTIFICATES_DOWNLOADED = 'ALL_CERTIFICATES_DOWNLOADED';
var CERTIFICATES_DOWNLOADED_FOR_TYPE = exports.CERTIFICATES_DOWNLOADED_FOR_TYPE = 'CERTIFICATES_DOWNLOADED_FOR_TYPE';
var DOWNLOAD_SERVICE_IS_ACTIVE = exports.DOWNLOAD_SERVICE_IS_ACTIVE = 'DOWNLOAD_SERVICE_IS_ACTIVE';

/**
 * Downloads pdf Past Certificates for all types (gold, silver, bronze) in one file
 * Use ALL_STUDENTS userProfileId to download for all students
 */
function downloadAllPastCerts(_ref) {
    var userProfileId = _ref.userProfileId,
        classroomId = _ref.classroomId,
        productId = _ref.productId,
        startDate = _ref.startDate,
        endDate = _ref.endDate,
        classroomName = _ref.classroomName,
        studentName = _ref.studentName,
        downloadType = _ref.downloadType;

    var filename = void 0;
    if (userProfileId === _certificatesConstants.ALL_STUDENTS) {
        filename = (0, _generateCertificateFilename.generateCertificateFilename)(_extends({
            classroomName: classroomName
        }, getDatesForFileName(startDate, endDate)));
        return downloadAllClassPastCerts({
            paramData: {
                classroomId: classroomId,
                productId: productId,
                startDate: startDate,
                endDate: endDate
            },
            filename: filename,
            downloadType: downloadType
        });
    }
    filename = (0, _generateCertificateFilename.generateCertificateFilename)(_extends({
        classroomName: classroomName,
        studentName: studentName
    }, getDatesForFileName(startDate, endDate)));
    return downloadAllStudentPastCertsForType({
        userProfileId: userProfileId,
        paramData: {
            classroomId: classroomId,
            groupId: 0,
            productId: productId,
            startDate: startDate,
            endDate: endDate,
            certificateType: _certificatesConstants.CERT_VALUES[_certificatesConstants.ALL_CERTS_TYPE]
        },
        actionType: ALL_CERTIFICATES_DOWNLOADED,
        filename: filename,
        downloadType: downloadType
    });
}

/**
 * Downloads pdf Past Certificates for a particular type (gold, silver, bronze)
 * Use ALL_STUDENTS userProfileId to download for all students
 */
function downloadPastCertsByType(_ref2) {
    var certificateType = _ref2.certificateType,
        _ref2$paramData = _ref2.paramData,
        userProfileId = _ref2$paramData.userProfileId,
        classroomId = _ref2$paramData.classroomId,
        productId = _ref2$paramData.productId,
        startDate = _ref2$paramData.startDate,
        endDate = _ref2$paramData.endDate,
        classroomName = _ref2$paramData.classroomName,
        studentName = _ref2$paramData.studentName,
        downloadType = _ref2.downloadType;

    var filename = void 0;
    if (userProfileId === _certificatesConstants.ALL_STUDENTS) {
        filename = (0, _generateCertificateFilename.generateCertificateFilename)(_extends({
            classroomName: classroomName
        }, getDatesForFileName(startDate, endDate)));
        return downloadClassPastCertsForType({
            certificateType: certificateType,
            paramData: {
                classroomId: classroomId,
                productId: productId,
                startDate: startDate,
                endDate: endDate
            },
            filename: filename,
            downloadType: downloadType
        });
    }
    filename = (0, _generateCertificateFilename.generateCertificateFilename)(_extends({
        classroomName: classroomName,
        studentName: studentName
    }, getDatesForFileName(startDate, endDate)));
    return downloadAllStudentPastCertsForType({
        userProfileId: userProfileId,
        paramData: {
            classroomId: classroomId,
            groupId: 0,
            productId: productId,
            startDate: startDate,
            endDate: endDate,
            certificateType: certificateType
        },
        actionType: CERTIFICATES_DOWNLOADED_FOR_TYPE,
        filename: filename,
        downloadType: downloadType
    });
}

function downloadServiceIsActive(_ref3) {
    var isActive = _ref3.isActive,
        downloadType = _ref3.downloadType,
        dispatch = _ref3.dispatch;

    dispatch({
        type: DOWNLOAD_SERVICE_IS_ACTIVE,
        payload: {
            isActive: isActive,
            downloadType: downloadType
        }
    });
}

function showFailDownloadToastMessage(dispatch, getState) {
    var message = getState().localeData['Toast - DownloadFail'];
    dispatch({
        type: _toastActions.SHOW_TOAST_MESSAGE,
        payload: {
            message: message,
            type: 'fail',
            hasClose: true
        }
    });
}

function closeModal(dispatch) {
    dispatch({ type: _modalActions.CLOSE_MODAL });
}function downloadAllSchoolOrClassCerts(_ref10) {
    var fullColor = _ref10.fullColor,
        classroomId = _ref10.classroomId,
        filterText = _ref10.filterText,
        startDate = _ref10.startDate,
        endDate = _ref10.endDate,
        downloadType = _ref10.downloadType;

    return downloadAllCerts({
        paramData: {
            classroomId: classroomId,
            startDate: startDate,
            endDate: endDate,
            fullColor: fullColor,
            nameFilter: (0, _utils.isUndefined)(filterText) ? '' : filterText
        },
        downloadType: downloadType
    });
}

/**
 * Downloads pdf New Certificates for all types (gold, silver, bronze) in one file
 * Use ALL_STUDENTS userProfileId to download for all students
 */
function downloadAllNewCerts(_ref11) {
    var classroomId = _ref11.classroomId,
        productId = _ref11.productId,
        startDate = _ref11.startDate,
        endDate = _ref11.endDate,
        _ref11$userId = _ref11.userId,
        userId = _ref11$userId === undefined ? null : _ref11$userId,
        downloadType = _ref11.downloadType,
        classroomName = _ref11.classroomName,
        studentName = _ref11.studentName,
        fullColor = _ref11.fullColor,
        isClassLevel = _ref11.isClassLevel,
        gemTypes = _ref11.gemTypes;

    var filename = void 0;

    if (isClassLevel) {
        filename = (0, _generateCertificateFilename.generateCertificateFilename)(_extends({
            classroomName: classroomName
        }, getDatesForFileName(startDate, endDate)));
        return downloadAllClassNewCerts({
            paramData: {
                classroomId: classroomId,
                productId: productId,
                startDate: startDate,
                endDate: endDate,
                fullColor: fullColor
            },
            gemTypes: gemTypes,
            filename: filename,
            downloadType: downloadType
        });
    }
    filename = (0, _generateCertificateFilename.generateCertificateFilename)(_extends({
        classroomName: classroomName,
        studentName: studentName
    }, getDatesForFileName(startDate, endDate)));
    return downloadStudentNewCerts({
        userId: userId,
        paramData: {
            classroomId: classroomId,
            groupId: 0,
            productId: productId,
            startDate: startDate,
            endDate: endDate,
            fullColor: fullColor
        },
        gemTypes: gemTypes,
        actionType: ALL_CERTIFICATES_DOWNLOADED,
        filename: filename,
        downloadType: downloadType
    });
}

/**
 * Downloads pdf New Certificates for a particular type (bronze, silver, gold, etc....)
 * Use ALL_STUDENTS userProfileId to download for all students
 */
function downloadNewCertsByType(_ref12) {
    var certificateRank = _ref12.certificateRank,
        userProfileId = _ref12.userProfileId,
        classroomId = _ref12.classroomId,
        productId = _ref12.productId,
        startDate = _ref12.startDate,
        endDate = _ref12.endDate,
        downloadType = _ref12.downloadType,
        userId = _ref12.userId,
        classroomName = _ref12.classroomName,
        studentName = _ref12.studentName,
        fullColor = _ref12.fullColor,
        gemTypes = _ref12.gemTypes;

    var filename = void 0;
    if (userProfileId === _certificatesConstants.ALL_STUDENTS) {
        filename = (0, _generateCertificateFilename.generateCertificateFilename)(_extends({
            classroomName: classroomName
        }, getDatesForFileName(startDate, endDate)));
        return downloadClassNewCertsForType({
            certificateRank: certificateRank,
            paramData: {
                classroomId: classroomId,
                productId: productId,
                startDate: startDate,
                endDate: endDate,
                fullColor: fullColor
            },
            gemTypes: gemTypes,
            filename: filename,
            downloadType: downloadType
        });
    }
    filename = (0, _generateCertificateFilename.generateCertificateFilename)(_extends({
        classroomName: classroomName
    }, getDatesForFileName(startDate, endDate), {
        studentName: studentName
    }));
    return downloadStudentNewCertsForType({
        userId: userId,
        certificateRank: certificateRank,
        paramData: {
            classroomId: classroomId,
            groupId: 0,
            productId: productId,
            startDate: startDate,
            endDate: endDate,
            fullColor: fullColor
        },
        gemTypes: gemTypes,
        downloadType: downloadType,
        filename: filename
    });
}

function getDatesForFileName(startDate, endDate) {
    return { startDate: (0, _generateCertificateFilename.formatDateForFilename)(startDate), endDate: (0, _generateCertificateFilename.formatDateForFilename)(endDate) };
}

exports.default = {
    downloadAllPastCerts: downloadAllPastCerts,
    downloadPastCertsByType: downloadPastCertsByType,
    downloadAllNewCerts: downloadAllNewCerts,
    downloadNewCertsByType: downloadNewCertsByType,
    downloadAllSchoolOrClassCerts: downloadAllSchoolOrClassCerts
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "Flem":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  primary: {
    light: '#6c7378',
    main: '#415667',
    dark: '#4e5c67',
    text: '#fff'
  },
  secondary: {
    light: '#1981c4',
    main: '#1576b4',
    dark: '#2f659c',
    text: '#fff'
  },
  error: {
    light: '#bf2c30',
    main: '#b01e22',
    dark: '#6f1315',
    text: '#fff'
  },
  warning: {
    light: '#ffcc00',
    main: '#ff9966',
    dark: '#da6b46',
    text: '#fff'
  },
  success: {
    light: '#81c784',
    main: '#4caf50',
    dark: '#2e7d32',
    text: '#fff'
  }
};

/***/ }),

/***/ "G4uc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!action) return state;

    switch (action.type) {
        case _selectedStudentActions.SELECT_STUDENT:
            return action.payload;

        default:
            return state;
    }
};

var _selectedStudentActions = __webpack_require__("1O84");

var defaultState = null;

/**
 * Selected student Reducer
 *
 * Consumes SELECT_STUDENT action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the selected student
 */

/***/ }),

/***/ "GC/L":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".certificates-wrapper---2MA3j {\n  margin-top: 15px;\n  border: 1px solid #dbe0e6;\n  border-radius: 20px;\n  padding: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  max-width: 100%;\n  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 25, 55, .16);\n          box-shadow: 0 1px 3px 0 rgba(0, 25, 55, .16); }\n  .certificates-wrapper---2MA3j .header---30mhD {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-bottom: 15px;\n    width: 100%;\n    height: 40px; }\n  .certificates-wrapper---2MA3j .header---30mhD .heading---3nhVv {\n      font-size: 20px;\n      font-weight: 500;\n      letter-spacing: 0.75px; }\n  .certificates-wrapper---2MA3j .header---30mhD .download-button---3tLTt {\n      background-image: linear-gradient(103.65deg, #00abe8 -2.03%, #007acc 43.7%, #0063a7 105.46%);\n      color: #fff;\n      font-size: 18px;\n      width: 214px;\n      height: 42px;\n      letter-spacing: 0.75px; }\n  .certificates-wrapper---2MA3j .header---30mhD .download-button---3tLTt:hover {\n        background: linear-gradient(102.49deg, #007acc 0%, #014b8b 100%); }\n  .certificates-wrapper---2MA3j .header---30mhD .download-button---3tLTt svg path {\n        fill: unset !important; }\n  .certificates-wrapper---2MA3j .header---30mhD .disabled---2cKxW {\n      background-image: unset;\n      background-color: #edf1f4;\n      color: #5c6c7f; }\n  .certificates-wrapper---2MA3j .header---30mhD .disabled---2cKxW:hover {\n        background-image: unset; }\n  .certificates-wrapper---2MA3j .header---30mhD .disabled---2cKxW svg path {\n        stroke: #5c6c7f; }\n  .certificates-wrapper---2MA3j .certificates---3TNog {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap; }\n", ""]);

// exports
exports.locals = {
	"certificates-wrapper": "certificates-wrapper---2MA3j",
	"header": "header---30mhD",
	"heading": "heading---3nhVv",
	"download-button": "download-button---3tLTt",
	"disabled": "disabled---2cKxW",
	"certificates": "certificates---3TNog"
};

/***/ }),

/***/ "GLqN":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---1nVCu {\n  position: fixed;\n  z-index: 2;\n  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, .2) inset;\n          box-shadow: 0 0 20px rgba(0, 0, 0, .2) inset;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, .2);\n  cursor: wait; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1nVCu"
};

/***/ }),

/***/ "GQck":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Icon = exports.ButtonWrapper = exports.Content = undefined;

var _reactEmotion = __webpack_require__("huvn");

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

var _themeHelper = __webpack_require__("Q7UM");

var _constants = __webpack_require__("rbvv");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultValues = function defaultValues(theme) {
    var typography = theme.typography,
        layout = theme.layout;

    return {
        size: {
            small: {
                icon: 12,
                deltaX: 1,
                deltaY: 0.75
            },
            medium: {
                icon: 20,
                deltaX: 2,
                deltaY: 1
            },
            large: {
                icon: 28,
                deltaX: 2.75,
                deltaY: 1.5
            }
        },
        fontSize: typography.size,
        lineHeight: typography.lineHeight,
        borderRadius: layout.borderRadius,
        spacing: layout.spacing,
        boxShadow: 'none',
        minWidth: 'auto' // applies to buttons with text only
    };
};

function getOverrides(theme) {
    return _themeHelper.ThemeHelper.getComponentOverrides(theme, 'button', defaultValues);
}

var getColours = function getColours(props, palette, typography, inverse) {
    var bgColour = '#fff';
    var borderColour = '#fff';
    var textColour = typography.colour;

    if (props.primary) {
        bgColour = palette.primary.main;
        borderColour = palette.primary.dark;
        textColour = palette.primary.text;
    } else if (props.danger) {
        bgColour = palette.error.light;
        borderColour = palette.error.main;
        textColour = palette.error.text;
    } else if (props.info) {
        bgColour = palette.secondary.light;
        borderColour = palette.secondary.main;
        textColour = palette.secondary.text;
    }

    if (inverse) {
        return {
            bgColour: textColour,
            borderColour: textColour,
            textColour: borderColour
        };
    }
    return { bgColour: bgColour, borderColour: borderColour, textColour: textColour };
};

var getSize = function getSize(buttonSize, theme, hasSpinner) {
    if (hasSpinner) {
        return '18px';
    }

    var _getOverrides = getOverrides(theme),
        size = _getOverrides.size;

    if (buttonSize === _constants.SMALL) {
        return size.small.icon + 'px';
    } else if (buttonSize === _constants.LARGE) {
        return size.large.icon + 'px';
    }
    return size.medium.icon + 'px';
};

var getPadding = function getPadding(buttonSize, buttonState, theme) {
    var _getOverrides2 = getOverrides(theme),
        size = _getOverrides2.size,
        spacing = _getOverrides2.spacing;

    var _size$medium = size.medium,
        deltaX = _size$medium.deltaX,
        deltaY = _size$medium.deltaY;

    if (buttonSize === _constants.SMALL) {
        var _size$small = size.small;
        deltaX = _size$small.deltaX;
        deltaY = _size$small.deltaY;
    } else if (buttonSize === _constants.LARGE) {
        var _size$large = size.large;
        deltaX = _size$large.deltaX;
        deltaY = _size$large.deltaY;
    }

    var padding = spacing * deltaY + 'px ' + spacing * deltaX + 'px';
    if (buttonState === _constants.ICON_ONLY) {
        padding = 0;
    } else if (buttonState === _constants.ICON_AND_TEXT) {
        padding = spacing * deltaY * 0.5 + 'px ' + spacing * deltaX + 'px';
    }

    return padding;
};

var getIconPadding = function getIconPadding(buttonSize, buttonState, alignIcon, hasSpinner) {
    if (hasSpinner) {
        return 0;
    }
    var delta = 1;
    if (buttonSize === _constants.SMALL) {
        delta = 0.75;
    } else if (buttonSize === _constants.LARGE) {
        delta = 1.5;
    }

    if (buttonState === _constants.ICON_ONLY) {
        return 4 * delta + 'px';
    }
    if (alignIcon === _constants.RIGHT) {
        return 4 * delta + 'px 0 ' + 4 * delta + 'px ' + 8 * delta + 'px';
    }
    return 4 * delta + 'px ' + 8 * delta + 'px ' + 4 * delta + 'px 0';
};

var getTextStyles = function getTextStyles(buttonSize, theme) {
    var _getOverrides3 = getOverrides(theme),
        fontSize = _getOverrides3.fontSize,
        lineHeight = _getOverrides3.lineHeight;

    if (buttonSize === _constants.SMALL) {
        fontSize = parseInt(fontSize, 10) - 2 + 'px';
        lineHeight = parseInt(fontSize, 10) - 2 + 'px';
    } else if (buttonSize === _constants.LARGE) {
        fontSize = parseInt(fontSize, 10) + 2 + 'px';
        lineHeight = parseInt(fontSize, 10) + 2 + 'px';
    }

    return { fontSize: fontSize, lineHeight: lineHeight };
};

var getMinWidth = function getMinWidth(buttonSize, baseMinWidth) {
    var minWidth = parseInt(baseMinWidth, 10);
    if (Number.isNaN(minWidth)) {
        return baseMinWidth;
    }

    if (buttonSize === _constants.SMALL) {
        minWidth *= 0.5;
    } else if (buttonSize === _constants.LARGE) {
        minWidth *= 1.25;
    }
    return minWidth + 'px';
};

var ButtonWrapper = (0, _reactEmotion2.default)('div')(function (props) {
    var theme = _themeHelper.ThemeHelper.getTheme(props);
    var palette = theme.palette,
        typography = theme.typography;

    var _getOverrides4 = getOverrides(theme),
        borderRadius = _getOverrides4.borderRadius,
        boxShadow = _getOverrides4.boxShadow,
        minWidth = _getOverrides4.minWidth;

    var buttonState = props.buttonState,
        size = props.size,
        hasSpinner = props.hasSpinner,
        disabled = props.disabled;

    var _getColours = getColours(props, palette, typography, props.inverse),
        bgColour = _getColours.bgColour,
        borderColour = _getColours.borderColour,
        textColour = _getColours.textColour;

    var padding = getPadding(size, buttonState, theme);

    var _getTextStyles = getTextStyles(size, theme),
        fontSize = _getTextStyles.fontSize,
        lineHeight = _getTextStyles.lineHeight;

    var btnBorderRadius = props.type === _constants.LOZENGE ? getSize(size, theme) : borderRadius;
    var btnMinWidth = props.buttonState !== _constants.ICON_ONLY ? 'min-width: ' + getMinWidth(size, minWidth) + ';' : '';
    return '\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-family: ' + typography.family + ';\n    font-size: ' + fontSize + ';\n    line-height: ' + lineHeight + ';\n    text-align: center;\n    border-radius: ' + btnBorderRadius + ';\n    background-color: ' + bgColour + ';\n    border: 2px solid ' + borderColour + ';\n    box-sizing: border-box;\n    color: ' + textColour + ';\n    padding: ' + padding + ';\n    box-shadow: ' + boxShadow + ';\n    transition: filter 0.2s;\n    ' + btnMinWidth + '\n\n    &:not(.disable):hover {\n      filter: brightness(1.1);\n    }\n\n    ' + ((disabled || hasSpinner) && 'cursor: not-allowed;\n      box-shadow: none;\n      opacity: 0.65;\n\n      &:focus {\n          outline: 0;\n      }\n\n      &:hover {\n        filter: none;\n      }\n    ') + '\n  ';
});

var Content = exports.Content = (0, _reactEmotion2.default)('div')(function (props) {
    var hasSpinner = props.hasSpinner;

    var margin = hasSpinner ? 'margin: 0 10px;' : '';
    return '\n        display: flex;\n        align-items: center;\n        ' + margin + '\n    ';
});

var Icon = (0, _reactEmotion2.default)('div')(function (props) {
    var theme = _themeHelper.ThemeHelper.getTheme(props);
    var size = props.size,
        buttonState = props.buttonState,
        alignIcon = props.alignIcon,
        hasSpinner = props.hasSpinner;

    var iconSize = getSize(size, theme, hasSpinner);
    // const pathFill = hasSpinner ? 'unset !important' : 'currentColor !important';
    var spinAnimation = hasSpinner ? '\n    animation-name: spin;\n    animation-duration: 1000ms;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n\n    @keyframes spin {\n    from {\n        transform:rotate(0deg);\n    }\n    to {\n        transform:rotate(360deg);\n    }\n  ' : '';
    return '\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: ' + iconSize + ';\n    width: ' + iconSize + ';\n    padding: ' + getIconPadding(size, buttonState, alignIcon, hasSpinner) + ';\n\n    > span {\n        height: ' + iconSize + ' !important;\n        width: ' + iconSize + ' !important;\n    }\n    ' + spinAnimation + '\n  ';
});

exports.ButtonWrapper = ButtonWrapper;
exports.Icon = Icon;

/***/ }),

/***/ "Gkxh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!action) return state;
    var type = action.type,
        payload = action.payload;


    switch (type) {
        case _toastActions.SHOW_TOAST_MESSAGE:
            {
                return {
                    messageData: payload
                };
            }
        case _toastActions.CLEAR_TOAST_DATA:
            {
                return { defaultState: defaultState };
            }
        default:
            return state;
    }
};

var _toastActions = __webpack_require__("l9Tw");

var defaultState = {
    messageData: undefined
};

/***/ }),

/***/ "Gylf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__("2KeS");

var _modalReducer = __webpack_require__("pc5E");

var _modalReducer2 = _interopRequireDefault(_modalReducer);

var _errorsReducer = __webpack_require__("cjTm");

var _errorsReducer2 = _interopRequireDefault(_errorsReducer);

var _busyIndicatorReducer = __webpack_require__("i0Ya");

var _busyIndicatorReducer2 = _interopRequireDefault(_busyIndicatorReducer);

var _classDetailsReducer = __webpack_require__("+sYB");

var _classDetailsReducer2 = _interopRequireDefault(_classDetailsReducer);

var _academicYearReducer = __webpack_require__("k6Km");

var _academicYearReducer2 = _interopRequireDefault(_academicYearReducer);

var _datePickerReducer = __webpack_require__("HaVC");

var _datePickerReducer2 = _interopRequireDefault(_datePickerReducer);

var _overviewReducer = __webpack_require__("AeEc");

var _overviewReducer2 = _interopRequireDefault(_overviewReducer);

var _selectedClassReducer = __webpack_require__("p6pg");

var _selectedClassReducer2 = _interopRequireDefault(_selectedClassReducer);

var _productIdReducer = __webpack_require__("IbEk");

var _productIdReducer2 = _interopRequireDefault(_productIdReducer);

var _schoolIdReducer = __webpack_require__("n+MJ");

var _schoolIdReducer2 = _interopRequireDefault(_schoolIdReducer);

var _participationReportReducer = __webpack_require__("OrIt");

var _participationReportReducer2 = _interopRequireDefault(_participationReportReducer);

var _selectedStudentReducer = __webpack_require__("G4uc");

var _selectedStudentReducer2 = _interopRequireDefault(_selectedStudentReducer);

var _studentCertificatesReducer = __webpack_require__("AgGf");

var _studentCertificatesReducer2 = _interopRequireDefault(_studentCertificatesReducer);

var _studentCertificatesGemCountReducer = __webpack_require__("vSiG");

var _studentCertificatesGemCountReducer2 = _interopRequireDefault(_studentCertificatesGemCountReducer);

var _localeReducer = __webpack_require__("3Q3o");

var _localeReducer2 = _interopRequireDefault(_localeReducer);

var _toastReducer = __webpack_require__("Gkxh");

var _toastReducer2 = _interopRequireDefault(_toastReducer);

var _downloadCertificatesReducer = __webpack_require__("+vlH");

var _downloadCertificatesReducer2 = _interopRequireDefault(_downloadCertificatesReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CombinedReducers = (0, _redux.combineReducers)({
    modalMessages: _modalReducer2.default,
    errors: _errorsReducer2.default,
    busyIndicatorCount: _busyIndicatorReducer2.default,
    classDetailsData: _classDetailsReducer2.default,
    academicYear: _academicYearReducer2.default,
    selectedDateRange: _datePickerReducer2.default,
    classOverviewData: _overviewReducer2.default,
    selectedClass: _selectedClassReducer2.default,
    productId: _productIdReducer2.default,
    schoolId: _schoolIdReducer2.default,
    participationReport: _participationReportReducer2.default,
    selectedStudent: _selectedStudentReducer2.default,
    studentCertificates: _studentCertificatesReducer2.default,
    studentCertificatesGemCount: _studentCertificatesGemCountReducer2.default,
    localeData: _localeReducer2.default,
    toastData: _toastReducer2.default,
    downloadCertificatesState: _downloadCertificatesReducer2.default
});

exports.default = CombinedReducers;

/***/ }),

/***/ "HENK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("4n+p");

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _button = __webpack_require__("rAoZ");

var _button2 = _interopRequireDefault(_button);

var _newModal = __webpack_require__("RP0/");

var _newModal2 = _interopRequireDefault(_newModal);

var _closeButton = __webpack_require__("uvI+");

var _closeButton2 = _interopRequireDefault(_closeButton);

var _rankDropdown = __webpack_require__("Quvw");

var _rankDropdown2 = _interopRequireDefault(_rankDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewModal = function NewModal(_ref) {
    var message = _ref.message,
        onClose = _ref.onClose,
        downloadCertificatesState = _ref.downloadCertificatesState,
        localeData = _ref.localeData,
        studentCertificatesGemCount = _ref.studentCertificatesGemCount;
    var isActive = downloadCertificatesState.isActive,
        downloadType = downloadCertificatesState.downloadType;
    var title = message.title,
        buttons = message.buttons,
        content = message.content,
        label = message.label,
        dateRange = message.dateRange,
        certificatesCount = message.certificatesCount,
        retrievedGems = message.retrievedGems,
        certificateType = message.certificateType,
        isDownloadCertificateType = message.isDownloadCertificateType;

    var count = certificatesCount;
    var disableButton = false;

    if (studentCertificatesGemCount.selectedGems !== null) {
        count = studentCertificatesGemCount.selectedGems.resultCount;
        disableButton = count === 0;
    }

    return _react2.default.createElement(
        'div',
        { className: _newModal2.default.component },
        _react2.default.createElement('div', {
            className: _newModal2.default.overlay,
            onClick: onClose,
            role: 'button',
            tabIndex: '0'
        }),
        _react2.default.createElement(
            'div',
            { className: _newModal2.default.container },
            isDownloadCertificateType ? _react2.default.createElement(
                'div',
                { className: _newModal2.default.certificateTypeHeader },
                _react2.default.createElement(
                    'h1',
                    null,
                    localeData['Label - Download'],
                    ' ',
                    certificateType,
                    ' ',
                    localeData['Label - Certificates']
                ),
                _react2.default.createElement(_closeButton2.default, { onClose: onClose, className: _newModal2.default['close-button'] })
            ) : _react2.default.createElement(
                'div',
                { className: _newModal2.default.header },
                title && _react2.default.createElement(
                    'h1',
                    null,
                    title
                ),
                _react2.default.createElement(_closeButton2.default, { onClose: onClose, className: _newModal2.default['close-button'] })
            ),
            _react2.default.createElement(
                'div',
                { className: _newModal2.default.content },
                _react2.default.createElement(
                    'div',
                    { className: _newModal2.default.message },
                    content
                ),
                isDownloadCertificateType && _react2.default.createElement(
                    'div',
                    { className: _newModal2.default['rank-dropdown-container'] },
                    _react2.default.createElement(
                        'div',
                        { className: _newModal2.default.dateRange },
                        label,
                        ' | ',
                        dateRange
                    ),
                    _react2.default.createElement(_rankDropdown2.default, {
                        certificatesCount: certificatesCount,
                        retrievedGems: retrievedGems,
                        localeData: localeData
                    })
                ),
                buttons && _react2.default.createElement(
                    'div',
                    { className: _newModal2.default.buttons },
                    buttons.map(function (item) {
                        var btnTitle = item.title,
                            icon = item.icon,
                            btnType = item.btnType,
                            handler = item.handler;

                        return _react2.default.createElement(_button2.default, {
                            key: _lodash2.default.uniqueId(),
                            className: _newModal2.default.button,
                            text: btnTitle + ' (' + count + ')',
                            type: _button2.default.LOZENGE,
                            icon: icon || '',
                            alignIcon: _button2.default.LEFT,
                            hasSpinner: isActive && btnType === downloadType,
                            btnType: btnType,
                            disabled: disableButton || isActive && btnType !== downloadType,
                            onClick: function onClick() {
                                if (handler) {
                                    handler();
                                } else {
                                    onClose();
                                }
                            }
                        }); /* end Button */
                    }) /* end buttons.map */

                )
            )
        )
    );
};

NewModal.propTypes = {
    onClose: _propTypes2.default.func,
    message: _propTypes2.default.shape({
        id: _propTypes2.default.number,
        content: _propTypes2.default.string,
        label: _propTypes2.default.string,
        dateRange: _propTypes2.default.string,
        certificatesCount: _propTypes2.default.number,
        isDownloadCertificateType: _propTypes2.default.bool,
        retrievedGems: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            gem: _propTypes2.default.number,
            count: _propTypes2.default.number
        })),
        buttons: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            title: _propTypes2.default.string,
            handler: _propTypes2.default.func,
            disabled: _propTypes2.default.bool,
            icon: _propTypes2.default.string
        }))
    }),
    downloadCertificatesState: _propTypes2.default.object,
    localeData: _propTypes2.default.object,
    studentCertificatesGemCount: _propTypes2.default.object
};

function mapStateToProps(state) {
    return {
        downloadCertificatesState: state.downloadCertificatesState,
        localeData: state.localeData,
        studentCertificatesGemCount: state.studentCertificatesGemCount
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(NewModal);

/***/ }),

/***/ "HaVC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (!action) return state;
    var type = action.type,
        payload = action.payload;

    switch (type) {
        case _datePickerActions.UPDATE_SELECTED_DATE_RANGE:
            return _extends({}, payload);

        default:
            return state;
    }
};

var _datePickerConstants = __webpack_require__("p2pT");

var _datePickerActions = __webpack_require__("qFO3");

var currentDateRangeAndType = {
    type: _datePickerConstants.THIS_SCHOOL_YEAR,
    startDate: null,
    endDate: null
};
var initialState = _extends({}, currentDateRangeAndType);

/**
 * DatePicker Reducer
 *
 * Consumes UPDATE_SELECTED_DATE_RANGE action
 * Consumes UPDATE_CLASS_DETAILS_DATE_RANGE action
 * Consumes UPDATE_CERTIFICATES_DATE_RANGE action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - date type, start and end dates of selected range for each page
 */

/***/ }),

/***/ "HnjT":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/47e163e68e2a95c3286097cd25b2c053.svg";

/***/ }),

/***/ "HsVg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ACTIVITIES_POINTS_INFO = exports.ACTIVITIES_POINTS_INFO = 'ReportInfo - ActivityPoints';
var DOWNLOAD_PARTICIPATION_REPORT_URL = exports.DOWNLOAD_PARTICIPATION_REPORT_URL = '@SchoolUsageReportsGatewayBaseUrl/' + 'School/Download/Classroom/ParticipationReport';
var DOWNLOAD_SERVICE_IS_ACTIVE = exports.DOWNLOAD_SERVICE_IS_ACTIVE = 'DOWNLOAD_SERVICE_IS_ACTIVE';

var LIVE_MATHS_HEADER = exports.LIVE_MATHS_HEADER = 'Header - LiveMaths';

var LIVE_MATHS_INFO = exports.LIVE_MATHS_INFO = 'ReportInfo - LiveMaths';

var WEEKLY_POINTS_INFO = exports.WEEKLY_POINTS_INFO = 'ReportInfo - PointsInfo';

var SKILL_QUEST_POINTS_INFO = exports.SKILL_QUEST_POINTS_INFO = 'ReportInfo - SkillQuestInfo';
var NEW_COURSES_POINTS_INFO = exports.NEW_COURSES_POINTS_INFO = 'ReportInfo - NewCoursesInfo';
var CHALLENGES_POINTS_INFO = exports.CHALLENGES_POINTS_INFO = 'ReportInfo - ChallengesInfo';

var WEEKLY_POINTS = exports.WEEKLY_POINTS = 'ReportInfo - WeeklyPoints';

var ACTIVITIES_TABLE_CONFIG = exports.ACTIVITIES_TABLE_CONFIG = {
    cols: [{
        id: 'name',
        name: 'Activity',
        trans: 'Label - Activity'
    }, {
        id: 'result',
        name: 'Results',
        classes: 'text-center',
        trans: 'Label - Results'
    }, {
        id: 'points',
        name: 'Points',
        classes: 'text-center',
        trans: 'Label - Points'
    }, {
        id: 'completionDate',
        name: 'Date completed',
        classes: 'text-center',
        trans: 'Label - DateCompleted'
    }],
    footer: {
        cols: [{ id: 'result', footerDataId: 'averageResult' }, { id: 'points', footerDataId: 'totalPoints' }]
    },
    emptyDataMessage: 'Empty - NoActivities'
};

var LIVE_MATHS_TABLE_CONFIG = exports.LIVE_MATHS_TABLE_CONFIG = {
    cols: [{
        id: 'level',
        name: 'Level',
        trans: 'Label - Level'
    }, {
        id: 'correct',
        name: 'Correct',
        classes: 'text-center',
        trans: 'Label - Correct'
    }, {
        id: 'points',
        name: 'Points',
        classes: 'text-center',
        trans: 'Label - Points'
    }, {
        id: 'accuracy',
        name: 'Accuracy',
        classes: 'text-center',
        trans: 'Label - Accuracy'
    }],
    footer: {
        cols: [{ id: 'level', footerDataId: 'maxLiveMathsLevels' }, { id: 'correct', footerDataId: 'averageCorrect' }, { id: 'points', footerDataId: 'totalPoints' }]
    },
    emptyDataMessage: 'Empty - LevelsWithResults'
};

var NEW_COURSES_TABLE_CONFIG = exports.NEW_COURSES_TABLE_CONFIG = {
    cols: [{
        id: 'name',
        name: 'Activity',
        trans: 'Label - Activity'
    }, {
        id: 'accuracy',
        name: 'Results',
        classes: 'text-center',
        trans: 'Label - Results'
    }, {
        id: 'points',
        name: 'Points',
        classes: 'text-center',
        trans: 'Label - Points'
    }, {
        id: 'completionDate',
        name: 'Date completed',
        classes: 'text-center',
        trans: 'Label - DateCompleted'
    }],
    footer: {
        cols: [{ id: 'accuracy', footerDataId: 'averageResult' }, { id: 'points', footerDataId: 'totalPoints' }]
    },
    emptyDataMessage: 'EmptyMessage - NewCourses'
};

var SKILL_QUEST_TABLE_CONFIG = exports.SKILL_QUEST_TABLE_CONFIG = {
    cols: [{
        id: 'name',
        name: 'Activity',
        trans: 'Label - Activity'
    }, {
        id: 'accuracy',
        name: 'Results',
        classes: 'text-center',
        trans: 'Label - Results'
    }, {
        id: 'completionDate',
        name: 'Date completed',
        classes: 'text-center',
        trans: 'Label - DateCompleted'
    }],
    footer: {
        cols: [{ id: 'accuracy', footerDataId: 'averageAccuracy' }]
    },
    emptyDataMessage: 'Empty - LevelsWithResults'
};
var CHALLENGES_TABLE_CONFIG = exports.CHALLENGES_TABLE_CONFIG = {
    cols: [{
        id: 'name',
        name: 'Activity',
        trans: 'Label - Activity'
    }, {
        id: 'accuracy',
        name: 'Results',
        classes: 'text-center',
        trans: 'Label - Results'
    }, {
        id: 'points',
        name: 'Points',
        classes: 'text-center',
        trans: 'Label - Points'
    }, {
        id: 'completionDate',
        name: 'Date completed',
        classes: 'text-center',
        trans: 'Label - DateCompleted'
    }],
    footer: {
        cols: [{ id: 'accuracy', footerDataId: 'averageResult' }, { id: 'points', footerDataId: 'totalChallengesPoints' }]
    },
    emptyDataMessage: 'EmptyMessage - Challenges'
};

/***/ }),

/***/ "Hy9S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("4n+p");

__webpack_require__("nIya");

var _loginInfo = __webpack_require__("8FUX");

var _loginInfo2 = _interopRequireDefault(_loginInfo);

var _loginInfoDisplay = __webpack_require__("NbUB");

var _loginInfoDisplay2 = _interopRequireDefault(_loginInfoDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Login Information Component
 * Displays Total sign ins and time spent by a
 * student for a selected time period
 */
var LoginInfo = (_temp = _class = function (_Component) {
    _inherits(LoginInfo, _Component);

    function LoginInfo(props) {
        _classCallCheck(this, LoginInfo);

        var _this = _possibleConstructorReturn(this, (LoginInfo.__proto__ || Object.getPrototypeOf(LoginInfo)).call(this, props));

        var logInInfo = props.logInInfo,
            localeData = props.localeData;


        _this.state = {
            loginInfo: [{ title: localeData['Time  - SignIn'],
                text: logInInfo.totalSignIns
            }, {
                title: localeData['Time  - Total'],
                text: logInInfo.totalTime.hours + 'h  ' + logInInfo.totalTime.minutes + 'min'
            }]
        };
        return _this;
    }

    _createClass(LoginInfo, [{
        key: 'render',
        value: function render() {
            var loginInfo = this.state.loginInfo;


            return _react2.default.createElement(
                'div',
                { className: _loginInfo2.default.component },
                loginInfo.map(function (info) {
                    return _react2.default.createElement(_loginInfoDisplay2.default, { key: info.title, title: info.title, text: '' + info.text });
                })
            );
        }
    }]);

    return LoginInfo;
}(_react.Component), _class.propTypes = {
    logInInfo: _propTypes2.default.shape({
        totalSignIns: _propTypes2.default.number,
        totalTime: _propTypes2.default.shape({
            hours: _propTypes2.default.number,
            minutes: _propTypes2.default.number
        })
    }),
    localeData: _propTypes2.default.object
}, _temp);


function mapStateToProps(state) {
    return {
        localeData: state.localeData
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactStyleable2.default)(_loginInfo2.default)(LoginInfo));

/***/ }),

/***/ "IG3/":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/c1be915a20e877ebc5196d385393e5c8.svg";

/***/ }),

/***/ "IbEk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!action) return state;

    switch (action.type) {
        case _productIdActions.SET_PRODUCT_ID:
            return action.payload;

        default:
            return state;
    }
};

var _productIdActions = __webpack_require__("CW1h");

var _backendConstantsContract = __webpack_require__("vmQ6");

var defaultState = _backendConstantsContract.MATHLETICS_PRODUCT_ID;

/**
 * Product ID Reducer
 *
 * Consumes SET_PRODUCT_ID action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {string} - the product id
 */

/***/ }),

/***/ "J7W8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CERT_VALUES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ALL_STUDENTS = exports.ALL_STUDENTS = 0;

var BRONZE_CERT_TYPE = exports.BRONZE_CERT_TYPE = 'bronze';
var SILVER_CERT_TYPE = exports.SILVER_CERT_TYPE = 'silver';
var GOLD_CERT_TYPE = exports.GOLD_CERT_TYPE = 'gold';
var PLATINUM_CERT_TYPE = exports.PLATINUM_CERT_TYPE = 'platinum';
var EMERALD_CERT_TYPE = exports.EMERALD_CERT_TYPE = 'emerald';
var DIAMOND_CERT_TYPE = exports.DIAMOND_CERT_TYPE = 'diamond';
var EPIC_CERT_TYPE = exports.EPIC_CERT_TYPE = 'epic';
var LEGEND_CERT_TYPE = exports.LEGEND_CERT_TYPE = 'legend';

var BRONZE_CERT_TYPE_PAST = exports.BRONZE_CERT_TYPE_PAST = 'bronzePast';
var SILVER_CERT_TYPE_PAST = exports.SILVER_CERT_TYPE_PAST = 'silverPast';
var GOLD_CERT_TYPE_PAST = exports.GOLD_CERT_TYPE_PAST = 'goldPast';
var ALL_CERTS_TYPE = exports.ALL_CERTS_TYPE = 'All';

var CERT_VALUES = exports.CERT_VALUES = (_CERT_VALUES = {}, _defineProperty(_CERT_VALUES, BRONZE_CERT_TYPE, 1), _defineProperty(_CERT_VALUES, SILVER_CERT_TYPE, 2), _defineProperty(_CERT_VALUES, GOLD_CERT_TYPE, 3), _defineProperty(_CERT_VALUES, PLATINUM_CERT_TYPE, 4), _defineProperty(_CERT_VALUES, EMERALD_CERT_TYPE, 5), _defineProperty(_CERT_VALUES, DIAMOND_CERT_TYPE, 6), _defineProperty(_CERT_VALUES, EPIC_CERT_TYPE, 7), _defineProperty(_CERT_VALUES, LEGEND_CERT_TYPE, 8), _defineProperty(_CERT_VALUES, GOLD_CERT_TYPE_PAST, 3), _defineProperty(_CERT_VALUES, SILVER_CERT_TYPE_PAST, 2), _defineProperty(_CERT_VALUES, BRONZE_CERT_TYPE_PAST, 1), _defineProperty(_CERT_VALUES, ALL_CERTS_TYPE, 0), _CERT_VALUES);

/***/ }),

/***/ "JW4b":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, "/* React Core CSS */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block; }\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline; }\naudio:not([controls]) {\n  display: none;\n  height: 0; }\n[hidden],\ntemplate {\n  display: none; }\na {\n  background-color: transparent; }\na:active,\na:hover {\n  outline: 0; }\nabbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted; }\nb,\nstrong {\n  font-weight: inherit; }\nb,\nstrong {\n  font-weight: bolder; }\ndfn {\n  font-style: italic; }\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0; }\nmark {\n  background-color: #ff0;\n  color: #000; }\nsmall {\n  font-size: 80%; }\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline; }\nsup {\n  top: -0.5em; }\nsub {\n  bottom: -0.25em; }\nimg {\n  border: 0; }\nsvg:not(:root) {\n  overflow: hidden; }\nfigure {\n  margin: 1em 40px; }\nhr {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  height: 0;\n  overflow: visible; }\npre {\n  overflow: auto; }\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace;\n  font-size: 1em; }\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit;\n  margin: 0; }\nbutton {\n  overflow: visible; }\nbutton,\nselect {\n  text-transform: none; }\nbutton,\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer; }\nbutton[disabled] {\n  cursor: default; }\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0; }\nbutton:-moz-focusring,\ninput:-moz-focusring {\n  outline: 1px dotted ButtonText; }\ninput {\n  line-height: normal; }\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0; }\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; }\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em; }\nlegend {\n  border: 0;\n  padding: 0; }\ntextarea {\n  overflow: auto; }\noptgroup {\n  font-weight: bold; }\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font-family: inherit;\n  vertical-align: baseline; }\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block; }\nol,\nul {\n  list-style: none; }\nblockquote,\nq {\n  quotes: none; }\nblockquote::before,\nblockquote::after,\nq::before,\nq::after {\n  content: '';\n  content: none; }\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\nbody {\n  font-family: poppins, Arial, sans-serif;\n  font-size: 16px;\n  line-height: 1.42857143;\n  color: #484848;\n  background-color: #e7e9ea;\n  margin: 0;\n  padding: 0; }\nbutton:focus,\n[role=\"button\"]:focus,\ninput:focus {\n  outline: 0; }\n.text-center---2Uqae {\n  text-align: center; }\nh1 {\n  font-size: 30px;\n  font-weight: 500; }\n.version-number---1i3Lf {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  z-index: 10;\n  color: #aaa;\n  font-size: 9px; }\n/*\n// Enable use bootstrap\n// npm install bootstrap-sass --save\n$icon-font-path: '~bootstrap-sass/assets/fonts/bootstrap/';\n@import '~bootstrap-sass/assets/stylesheets/bootstrap';\n@import '~bootstrap-sass/assets/stylesheets/bootstrap/theme';\n*/\n/*\n// Enable use fontawesome\n// npm install font-awesome-sass --save\n$fa-font-path: \"~font-awesome-sass/assets/fonts/font-awesome/\";\n@import \"~font-awesome-sass/assets/stylesheets/font-awesome\";\n*/\n.close-button---3WqO2 {\n  border-radius: 50%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: end;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 30px;\n  width: 30px;\n  background-color: #f2f5f7;\n  cursor: pointer; }\n", ""]);

// exports
exports.locals = {
	"text-center": "text-center---2Uqae",
	"version-number": "version-number---1i3Lf",
	"close-button": "close-button---3WqO2"
};

/***/ }),

/***/ "JZ7m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CLASS_OVERVIEW_DATA_RETRIEVED = undefined;

var _lodash = __webpack_require__("M4fF");

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _resourceHandlers = __webpack_require__("Qbfx");

var _schoolIdActions = __webpack_require__("zs5o");

var _schoolIdActions2 = _interopRequireDefault(_schoolIdActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_OVERVIEW_DATA_RETRIEVED = exports.CLASS_OVERVIEW_DATA_RETRIEVED = 'CLASS_OVERVIEW_DATA_RETRIEVED';

function getClassOverviewData(startDate, endDate, productId) {
    return function (dispatch) {
        return _resources2.default.classOverview.get().withParams({ productId: productId, startDate: startDate, endDate: endDate }).send().then(function (payload) {
            if (payload.data) {
                var _payload$data = payload.data,
                    classroomsUsageInfo = _payload$data.classroomsUsageInfo,
                    schoolId = _payload$data.schoolId;


                if (classroomsUsageInfo) {
                    dispatch(_schoolIdActions2.default.setSchoolId(schoolId));

                    return (0, _resourceHandlers.handleResourceSuccess)(dispatch, payload, {
                        type: CLASS_OVERVIEW_DATA_RETRIEVED,
                        payload: {
                            data: classroomsUsageInfo.map(function (item) {
                                return {
                                    id: item.classId,
                                    class: item.className,
                                    teacher: mapTeachers(item.teachers),
                                    course: item.courseName,
                                    total: item.totalCertificates
                                };
                            })
                        }
                    });
                }
            }

            return (0, _resourceHandlers.handleResourceError)(dispatch, payload.message);
        }, function (error) {
            return (0, _resourceHandlers.handleResourceError)(dispatch, error);
        });
    };
}

function mapTeachers(teachers) {
    var teacherNames = teachers.map(function (teacher) {
        return teacher.teacherName;
    });
    var sortedTeacherNames = (0, _lodash.orderBy)(teacherNames, function (teacherName) {
        var names = teacherName.split(' ');
        return names[names.length - 1];
    });
    return sortedTeacherNames.join('\n');
}

exports.default = {
    getClassOverviewData: getClassOverviewData
};

/***/ }),

/***/ "KHn4":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/76efdd2e29c4d2bd9b1dbb6b7ae8634b.svg";

/***/ }),

/***/ "KRbp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("lj70");

__webpack_require__("DTuZ");

var _DateRangePicker = __webpack_require__("32hK");

var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);

var _constants = __webpack_require__("QoJ3");

var _momentWithLocales = __webpack_require__("e7tE");

var _momentWithLocales2 = _interopRequireDefault(_momentWithLocales);

var _calendarConstants = __webpack_require__("o+QR");

var _dateHelper = __webpack_require__("BiE+");

var _dateHelper2 = _interopRequireDefault(_dateHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Calendar component
 * Renders a calendar using react-dates library https://github.com/airbnb/react-dates
 * Limits what dates a user can select to meet business rules
 * Calls onDatesPicked prop when user selects both a start and end date, calls onClose prop
 * when the react-dates calendar component is closed for any reason
 */
var Calendar = (_temp = _class = function (_Component) {
    _inherits(Calendar, _Component);

    function Calendar(props) {
        _classCallCheck(this, Calendar);

        var _this = _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));

        _this.isOutsideRange = function (date) {
            var _this$state = _this.state,
                focusedInput = _this$state.focusedInput,
                range = _this$state.range;
            var localeData = _this.props.localeData;

            if (date.isAfter(range.startDate) && date.isBefore(range.endDate)) {
                var allowedDay = void 0;
                if (focusedInput === _calendarConstants.START_DATE) {
                    allowedDay = localeData['Label - Monday'];
                } else {
                    allowedDay = localeData['Label - Sunday'];
                }
                return date.format('dddd') !== allowedDay;
            }

            return true;
        };

        _this.onDatesChange = function (_ref) {
            var startDate = _ref.startDate,
                endDate = _ref.endDate;

            if (_this.state.focusedInput === _calendarConstants.END_DATE && !endDate) {
                // user has selected an end date earlier than the start date,
                // auto select the prev Monday as the start date and set the end date as
                // they chose
                endDate = startDate;
                startDate = (0, _momentWithLocales2.default)(_dateHelper2.default.getPreviousMonday(startDate));
            }
            _this.setState({ startDate: startDate, endDate: endDate });
            if (startDate && endDate) {
                _this.props.onDatesPicked(startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'));
            }
        };

        _this.onFocusChange = function (elementId) {
            _this.setState({ focusedInput: elementId });
        };

        _this.state = {
            focusedInput: _calendarConstants.START_DATE,
            startDate: null,
            endDate: null,
            range: {
                startDate: (0, _momentWithLocales2.default)(props.range.startDate),
                endDate: (0, _momentWithLocales2.default)(props.range.endDate)
            }
        };
        return _this;
    }

    /**
     * Limit what days users can select in the calendar
     * Start date has to be a Monday and end date a Sunday, both dates have to be within
     * the range provided via props
     * @param date - moment date object
     */


    _createClass(Calendar, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                startDate = _state.startDate,
                endDate = _state.endDate,
                focusedInput = _state.focusedInput;
            var _props = this.props,
                localeData = _props.localeData,
                isLeft = _props.isLeft;

            var startDateLabel = localeData['Label - StartDate'];
            var endDateLabel = localeData['Label - EndDate'];
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_DateRangePicker2.default, {
                    displayFormat: 'DD MMM YYYY',
                    isOutsideRange: this.isOutsideRange,
                    startDate: startDate,
                    startDateId: _calendarConstants.START_DATE,
                    startDatePlaceholderText: startDateLabel,
                    endDate: endDate,
                    endDateId: _calendarConstants.END_DATE,
                    endDatePlaceholderText: endDateLabel,
                    onDatesChange: this.onDatesChange,
                    focusedInput: focusedInput,
                    onFocusChange: this.onFocusChange,
                    firstDayOfWeek: 1,
                    hideKeyboardShortcutsPanel: true,
                    minimumNights: 0,
                    anchorDirection: isLeft ? _constants.ANCHOR_LEFT : _constants.ANCHOR_RIGHT,
                    onClose: this.props.onClose,
                    readOnly: true
                })
            );
        }
    }]);

    return Calendar;
}(_react.Component), _class.propTypes = {
    /** Range to limit the date selection to */
    range: _propTypes2.default.shape({
        startDate: _propTypes2.default.string,
        endDate: _propTypes2.default.string
    }).isRequired,

    /** Callback prop when dates are selected */
    onDatesPicked: _propTypes2.default.func.isRequired,

    /** Callback prop when calendar is closed, either from selecting dates or cancelling date selection */
    onClose: _propTypes2.default.func.isRequired,

    /**
     * Locale Data
     */
    localeData: _propTypes2.default.object,
    /**
     * Direction of picker
    * */
    isLeft: _propTypes2.default.bool
}, _temp);


Calendar.START_DATE = _calendarConstants.START_DATE;
Calendar.END_DATE = _calendarConstants.END_DATE;

exports.default = Calendar;

/***/ }),

/***/ "LMoJ":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/1b8e87bc9f65b5e61bbaa4b7b5fa9916.svg";

/***/ }),

/***/ "LlfG":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".dropdown-container---wAP1s {\n  width: 100%;\n  margin: 12px 0; }\n  .dropdown-container---wAP1s .dropdown-trigger---195EK {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    border-radius: 6px;\n    border: 1px solid #dbe0e6;\n    background: #fff;\n    padding: 6px 10px;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between; }\n  .dropdown-container---wAP1s .dropdown-trigger---195EK:hover {\n      border: 1px solid #4dc4ef; }\n  .dropdown-container---wAP1s .dropdown-trigger---195EK:focus {\n      border: 1px solid #00abe8; }\n  .dropdown-container---wAP1s .dropdown-options-container---1NTBE {\n    position: relative;\n    z-index: 100;\n    padding: 10px;\n    border: 1px solid #ccc;\n    background: #fff;\n    border-radius: 12px;\n    max-height: 265px;\n    overflow-y: auto;\n    -webkit-transform: translateY(2px);\n            transform: translateY(2px);\n    -webkit-box-shadow: 0 4px 6px -1px rgba(0, 25, 55, .1), 0 2px 4px -1px rgba(0, 25, 55, .06);\n            box-shadow: 0 4px 6px -1px rgba(0, 25, 55, .1), 0 2px 4px -1px rgba(0, 25, 55, .06); }\n  .dropdown-container---wAP1s .dropdown-option---1v7Hg {\n    margin: 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-bottom: 1px solid #edf1f4; }\n  .dropdown-container---wAP1s .dropdown-option---1v7Hg .check-box---3UEmE {\n      margin: 0;\n      width: 20px;\n      height: 20px;\n      margin-right: 12px;\n      -webkit-transform: translateY(4px);\n              transform: translateY(4px); }\n", ""]);

// exports
exports.locals = {
	"dropdown-container": "dropdown-container---wAP1s",
	"dropdown-trigger": "dropdown-trigger---195EK",
	"dropdown-options-container": "dropdown-options-container---1NTBE",
	"dropdown-option": "dropdown-option---1v7Hg",
	"check-box": "check-box---3UEmE"
};

/***/ }),

/***/ "MGx+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getConfig = exports.checkForHeaderBtn = exports.addClickFn = exports.translateTableLabels = exports.locale = undefined;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactInlinesvg = __webpack_require__("h2Qy");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _lodash = __webpack_require__("M4fF");

var _icon_studentManagement = __webpack_require__("/p9h");

var _icon_studentManagement2 = _interopRequireDefault(_icon_studentManagement);

var _expand = __webpack_require__("IG3/");

var _expand2 = _interopRequireDefault(_expand);

var _minimize = __webpack_require__("KHn4");

var _minimize2 = _interopRequireDefault(_minimize);

var _classDetails = __webpack_require__("CzYQ");

var _classDetails2 = _interopRequireDefault(_classDetails);

var _classDetailsConstants = __webpack_require__("OVNq");

var _iconMessage = __webpack_require__("nOMl");

var _iconMessage2 = _interopRequireDefault(_iconMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* global window */


var locale = exports.locale = function locale() {
    var query = window.location.search.slice(1);
    var match = query.match(/\blocale=([-a-zA-Z]+)\b/);
    return match ? match[1] : 'en-AU';
};

var translateTableLabels = exports.translateTableLabels = function translateTableLabels(tableConfig, localeData) {
    var isUpperCase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var fullTotal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    function translateName(col) {
        if (col.trans) {
            var isNotUppercase = col.case === 'lower';
            var name = localeData[col.trans];
            if (name) {
                if (isNotUppercase) {
                    col.name = name;
                } else {
                    name = isUpperCase ? name.toUpperCase() : name;
                    col.name = name;
                }
            }
        }
    }
    var cols = tableConfig.cols,
        colGroups = tableConfig.colGroups;
    var emptyDataMessage = tableConfig.emptyDataMessage;

    cols.forEach(function (col) {
        return translateName(col);
    });

    if (colGroups) {
        colGroups[0].forEach(function (col) {
            translateName(col);
        });
    }
    var totalColConfig = tableConfig.cols.find(function (col) {
        return col.id === 'total';
    });
    if (totalColConfig) {
        totalColConfig.name = fullTotal ? totalColConfig.name + ' (' + fullTotal + ')' : totalColConfig.name;
    }

    if (emptyDataMessage) {
        tableConfig.emptyDataMessage = localeData[emptyDataMessage];
    }
    return tableConfig;
};

var addClickFn = exports.addClickFn = function addClickFn(col, manageCertificateTypeDisplay) {
    var isExpanded = col.expanded;
    var btnText = isExpanded ? 'Collapse' : 'Expand';
    col.headerTransform = function () {
        return _react2.default.createElement(
            'div',
            {
                className: _classDetails2.default['header-content'],
                onClick: function onClick() {
                    return manageCertificateTypeDisplay(col);
                },
                role: 'button',
                tabIndex: -1
            },
            col.name,
            _react2.default.createElement(
                'div',
                { className: _classDetails2.default['header-btn'] },
                _react2.default.createElement(
                    'div',
                    { className: _classDetails2.default.content },
                    isExpanded && _react2.default.createElement(_reactInlinesvg2.default, { src: _minimize2.default, cacheGetRequests: true }),
                    btnText,
                    !isExpanded && _react2.default.createElement(_reactInlinesvg2.default, { src: _expand2.default, cacheGetRequests: true })
                )
            )
        );
    };
};

var checkForHeaderBtn = exports.checkForHeaderBtn = function checkForHeaderBtn(tableConfig, manageCertificateTypeDisplay) {
    var colGroups = tableConfig.colGroups;

    if (colGroups) {
        colGroups[0].forEach(function (col) {
            if (col.hasHeaderBtn) {
                addClickFn(col, manageCertificateTypeDisplay);
            }
        });
    }

    return tableConfig;
};

var getConfig = exports.getConfig = function getConfig(_ref) {
    var newCertExpanded = _ref.newCertExpanded,
        pastCertExpanded = _ref.pastCertExpanded,
        localeData = _ref.localeData,
        callback = _ref.callback,
        emptyDataText = _ref.emptyDataText;

    var newCertCols = newCertExpanded ? _classDetailsConstants.NEW_CERT_COL_EXPANDED : _classDetailsConstants.NEW_CERT_COL;
    var pastCertCols = pastCertExpanded ? _classDetailsConstants.PAST_CERT_COL_EXPANDED : _classDetailsConstants.PAST_CERT_COL;
    var newCertColGroups = newCertExpanded ? _classDetailsConstants.NEW_CERT_COL_GROUP_EXPANDED : _classDetailsConstants.NEW_CERT_COL_GROUP;
    var pastCertColGroups = pastCertExpanded ? _classDetailsConstants.PAST_CERT_COL_GROUP_EXPANDED : _classDetailsConstants.PAST_CERT_COL_GROUP;
    var tableConfig = {
        cols: [].concat(_toConsumableArray((0, _lodash.cloneDeep)(_classDetailsConstants.BASE_COL_CONFIG)), _toConsumableArray((0, _lodash.cloneDeep)(newCertCols)), _toConsumableArray((0, _lodash.cloneDeep)(pastCertCols)), _toConsumableArray((0, _lodash.cloneDeep)(_classDetailsConstants.BASE_TOTAL_CERTIFICATES_COL))),
        colGroups: [[].concat(_toConsumableArray((0, _lodash.cloneDeep)(_classDetailsConstants.BASE_COL_GROUP)), _toConsumableArray((0, _lodash.cloneDeep)(newCertColGroups)), _toConsumableArray((0, _lodash.cloneDeep)(pastCertColGroups)), _toConsumableArray((0, _lodash.cloneDeep)(_classDetailsConstants.BASE_TOTAL_CERTIFICATES_COLGROUP)))]
    };
    var isUpperCase = true;
    tableConfig = translateTableLabels(tableConfig, localeData, isUpperCase);
    tableConfig = checkForHeaderBtn(tableConfig, callback);
    tableConfig.emptyDataMessage = _react2.default.createElement(_iconMessage2.default, { iconSrc: _icon_studentManagement2.default, message: emptyDataText });
    return tableConfig;
};

/***/ }),

/***/ "MdXx":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("tijh");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./report-table.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./report-table.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "N5/L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    // The application name, to be used when asking the configuration system for settings
    appName: 'SchoolUsageReportHost',
    // These applications are referenced by the project in an unbuilt state, and require babel to also be run over them
    childApplications: []
};

/***/ }),

/***/ "NVqf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ZDX+");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./icon-message.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./icon-message.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "NbUB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("nIya");

var _loginInfoDisplay = __webpack_require__("y18N");

var _loginInfoDisplay2 = _interopRequireDefault(_loginInfoDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Login Information Display Component
 * Displays Total sign ins and time spent by a 
 * student for a selected time period 
 */
var LoginInfoDisplay = function LoginInfoDisplay(_ref) {
    var title = _ref.title,
        text = _ref.text;
    return _react2.default.createElement(
        'div',
        { className: _loginInfoDisplay2.default.component },
        _react2.default.createElement(
            'div',
            { className: _loginInfoDisplay2.default.logininfo },
            _react2.default.createElement(
                'div',
                { className: _loginInfoDisplay2.default.title },
                title
            ),
            _react2.default.createElement(
                'div',
                { className: _loginInfoDisplay2.default.text },
                text
            )
        )
    );
};

LoginInfoDisplay.propTypes = {
    title: _propTypes2.default.string,
    text: _propTypes2.default.string
};

exports.default = (0, _reactStyleable2.default)(_loginInfoDisplay2.default)(LoginInfoDisplay);

/***/ }),

/***/ "NcRG":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("oEFU");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./certificate-count.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./certificate-count.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "O7Sl":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---3-iBQ {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  height: 100vh; }\n  .component---3-iBQ > div {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto; }\n  .component---3-iBQ h1 {\n    font-weight: normal; }\n  .component---3-iBQ .main-content---2E-aU {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 100%;\n            flex: 1 1 100%;\n    overflow: hidden;\n    margin: 20px;\n    padding: 20px;\n    border-radius: 5px;\n    background-color: #fff;\n    -webkit-box-shadow: 5px 5px rgba(0, 0, 0, .07);\n            box-shadow: 5px 5px rgba(0, 0, 0, .07); }\n  @media print {\n      .component---3-iBQ .main-content---2E-aU {\n        -webkit-box-shadow: none;\n                box-shadow: none; } }\n  .component---3-iBQ .header---3r0kA {\n    margin-bottom: 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between; }\n  .component---3-iBQ .header---3r0kA h2 {\n      margin: 0 16px;\n      color: #415667;\n      font-size: 25px;\n      font-weight: 600;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden; }\n  .component---3-iBQ .header---3r0kA .filter-container---3p1uv {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      width: 640px; }\n  .component---3-iBQ .header---3r0kA .filter-container---3p1uv > div {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between; }\n  .component---3-iBQ .header---3r0kA .filter-container---3p1uv > div:last-of-type {\n          margin-right: 0; }\n  .component---3-iBQ .header---3r0kA .filter-container---3p1uv .export-button---327u4 {\n        background: white;\n        border-radius: 28px;\n        border: 1px solid #bceafd;\n        color: #007acc;\n        font-size: 12.6px;\n        letter-spacing: 0.75px;\n        margin-right: 16px; }\n  .component---3-iBQ .header---3r0kA .filter-container---3p1uv .export-button---327u4:hover {\n          border: 1px solid #99ddf6;\n          background: #dcf4fd;\n          color: #007acc; }\n  .component---3-iBQ .header---3r0kA .filter-container---3p1uv .export-button---327u4 svg path {\n          fill: unset !important; }\n  .component---3-iBQ .header---3r0kA .filter-container---3p1uv .download-button---1XrDT {\n        background-image: linear-gradient(103.65deg, #00abe8 -2.03%, #007acc 43.7%, #0063a7 105.46%);\n        color: #fff;\n        font-size: 12.6px;\n        width: 132px;\n        height: 44px;\n        letter-spacing: 0.75px;\n        border-radius: 28px;\n        border: none; }\n  .component---3-iBQ .header---3r0kA .filter-container---3p1uv .download-button---1XrDT:hover {\n          background: linear-gradient(102.49deg, #007acc 0%, #014b8b 100%); }\n  .component---3-iBQ .header---3r0kA .filter-container---3p1uv .download-button---1XrDT svg {\n          width: 16.8px;\n          height: 16.8px; }\n  .component---3-iBQ .header---3r0kA .filter-container---3p1uv .download-button---1XrDT svg path {\n            fill: unset !important; }\n  .component---3-iBQ .header---3r0kA .filter-container---3p1uv .disabled---3yvAo {\n        background-image: unset;\n        background-color: #edf1f4;\n        color: #5c6c7f; }\n  .component---3-iBQ .header---3r0kA .filter-container---3p1uv .disabled---3yvAo:hover {\n          background-image: unset; }\n  .component---3-iBQ .header---3r0kA .filter-container---3p1uv .disabled---3yvAo svg path {\n          stroke: #5c6c7f; }\n  .component---3-iBQ .table-container---17Aj4 {\n    height: calc(100% - 40px);\n    overflow: auto; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H table {\n      table-layout: auto;\n      color: #484848;\n      text-align: left; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead {\n      /*  top row is for column groups ie. Certificates */\n      /* second row is for actual column headers */ }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead th {\n        font-size: 12px;\n        background-color: #1a304b;\n        color: #fff; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead th svg path {\n          fill: #777 !important; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead tr:first-of-type th {\n        padding-top: 8px;\n        border-bottom: none; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead tr:first-of-type th > div {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead tr:nth-of-type(2) th {\n        padding: 16px 20px;\n        border-top: none; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H tbody.empty-data---2oVwM {\n      text-align: center; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H tbody td {\n      font-size: 13px;\n      border-left: 1px solid #e1e1e1;\n      border-bottom: 1px solid #e1e1e1;\n      padding: 8px 20px; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H tbody td:first-of-type {\n        width: 30%; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H tbody td:last-of-type {\n        border-right: 1px solid #e1e1e1; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H tbody .selected---lHkoB {\n      color: #fff;\n      background-color: #415667; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H tbody .cursor-pointer---2tIS4 {\n      cursor: pointer; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H tfoot {\n      background-color: #415667;\n      color: #fff; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead .first-group---3HPa_,\n    .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead .total-group---16ip3 {\n      background-color: #e8e9eb;\n      color: #415667; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead .past-group---2U4Sa {\n      background-color: #33475f;\n      color: #fff; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead tr:first-of-type th > div {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead th .header-content---Za1i- {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      width: 100%;\n      cursor: pointer; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead th .header-content---Za1i- .header-btn---3heyO {\n        background: #557086;\n        margin-left: 20px;\n        border: none;\n        border-radius: 56px;\n        color: #fff;\n        font-size: 11px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead th .header-content---Za1i- .header-btn---3heyO .content---1cCcX {\n          padding: 0 5px;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead th .header-content---Za1i- .header-btn---3heyO .content---1cCcX svg {\n            height: 100%;\n            margin: 0 8px; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H thead th .header-content---Za1i- .header-btn---3heyO .content---1cCcX svg path {\n              fill: white !important; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H .icon-container---1u8zP {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      position: relative; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H .icon-container---1u8zP .icon---3gc6X {\n        position: absolute;\n        right: -12px;\n        height: 24px;\n        width: 40px; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H .icon-container---1u8zP .icon---3gc6X .isvg {\n          height: 24px;\n          width: 40px; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H .icon-container---1u8zP .icon---3gc6X:hover {\n          border-color: #dbe0e6; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H .icon-container---1u8zP .icon---3gc6X:hover .isvg rect {\n            fill: #dbe0e6 !important; }\n  .component---3-iBQ .table-container---17Aj4 .data-table---S0k9H .icon-container---1u8zP .icon---3gc6X:hover .isvg path {\n            fill: #33475f !important; }\n", ""]);

// exports
exports.locals = {
	"component": "component---3-iBQ",
	"main-content": "main-content---2E-aU",
	"header": "header---3r0kA",
	"filter-container": "filter-container---3p1uv",
	"export-button": "export-button---327u4",
	"download-button": "download-button---1XrDT",
	"disabled": "disabled---3yvAo",
	"table-container": "table-container---17Aj4",
	"data-table": "data-table---S0k9H",
	"empty-data": "empty-data---2oVwM",
	"selected": "selected---lHkoB",
	"cursor-pointer": "cursor-pointer---2tIS4",
	"first-group": "first-group---3HPa_",
	"total-group": "total-group---16ip3",
	"past-group": "past-group---2U4Sa",
	"header-content": "header-content---Za1i-",
	"header-btn": "header-btn---3heyO",
	"content": "content---1cCcX",
	"icon-container": "icon-container---1u8zP",
	"icon": "icon---3gc6X"
};

/***/ }),

/***/ "OVNq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NO_STUDENTS_FOUND_SEARCH = exports.NO_STUDENTS_FOUND_LOAD = exports.PAST_CERT_COL_EXPANDED = exports.PAST_CERT_COL = exports.PAST_CERT_COL_GROUP_EXPANDED = exports.PAST_CERT_COL_GROUP = exports.NEW_CERT_COL_EXPANDED = exports.NEW_CERT_COL = exports.NEW_CERT_COL_GROUP_EXPANDED = exports.NEW_CERT_COL_GROUP = exports.BASE_TOTAL_CERTIFICATES_COL = exports.BASE_TOTAL_CERTIFICATES_COLGROUP = exports.BASE_COL_GROUP = exports.BASE_COL_CONFIG = undefined;

var _classDetails = __webpack_require__("CzYQ");

var _classDetails2 = _interopRequireDefault(_classDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BASE_COL_CONFIG = exports.BASE_COL_CONFIG = [{
    id: 'student',
    name: 'STUDENT',
    sort: { sortAs: function sortAs(student) {
            return student.lastName;
        } },
    trans: 'Label - Student'
}, {
    id: 'participationPoints',
    name: 'PARTICIPATION POINTS',
    trans: 'Label - ParticipationPoints'
}, {
    id: 'liveMathsPoints',
    name: 'LIVE MATHLETICS POINTS',
    trans: 'Label - LiveMathPoints'
}];
var BASE_COL_GROUP = exports.BASE_COL_GROUP = [{
    name: '',
    colIds: ['student', 'participationPoints', 'liveMathsPoints'],
    classes: _classDetails2.default['first-group']
}];
var BASE_TOTAL_CERTIFICATES_COLGROUP = exports.BASE_TOTAL_CERTIFICATES_COLGROUP = [{
    name: 'TOTAL',
    colIds: ['totalCertificates'],
    classes: _classDetails2.default['total-group']
}];
var BASE_TOTAL_CERTIFICATES_COL = exports.BASE_TOTAL_CERTIFICATES_COL = [{
    id: 'totalCertificates',
    name: 'TOTAL CERTIFICATES',
    trans: 'Label - Certificates'
}];
var NEW_CERT_COL_GROUP = exports.NEW_CERT_COL_GROUP = [{
    name: 'NEW CERTIFICATES',
    colIds: ['totalNew'],
    trans: 'Label - NewCertificates',
    certType: 'new',
    hasHeaderBtn: true,
    expanded: false
}];
var NEW_CERT_COL_GROUP_EXPANDED = exports.NEW_CERT_COL_GROUP_EXPANDED = [{
    name: 'NEW CERTIFICATES',
    colIds: ['bronze', 'silver', 'gold', 'platinum', 'emerald', 'diamond', 'epic', 'legend'],
    trans: 'Label - NewCertificates',
    certType: 'new',
    hasHeaderBtn: true,
    expanded: true
}];
var NEW_CERT_COL = exports.NEW_CERT_COL = [{
    id: 'totalNew',
    name: 'TOTAL NEW',
    trans: 'Label - TotalNew'
}];
var NEW_CERT_COL_EXPANDED = exports.NEW_CERT_COL_EXPANDED = [{
    id: 'bronze',
    name: 'BRONZE',
    trans: 'Label - Bronze',
    case: 'lower'
}, {
    id: 'silver',
    name: 'SILVER',
    trans: 'Label - Silver',
    case: 'lower'
}, {
    id: 'gold',
    name: 'GOLD',
    trans: 'Label - Gold',
    case: 'lower'
}, {
    id: 'platinum',
    name: 'PLATINUM',
    trans: 'Label - Platinum',
    case: 'lower'
}, {
    id: 'emerald',
    name: 'EMERALD',
    trans: 'Label - Emerald',
    case: 'lower'
}, {
    id: 'diamond',
    name: 'DIAMOND',
    trans: 'Label - Diamond',
    case: 'lower'
}, {
    id: 'epic',
    name: 'EPIC',
    trans: 'Label - Epic',
    case: 'lower'
}, {
    id: 'legend',
    name: 'Legend',
    trans: 'Label - Legend',
    case: 'lower'
}];
var PAST_CERT_COL_GROUP = exports.PAST_CERT_COL_GROUP = [{
    name: 'PAST CERTIFICATES',
    colIds: ['totalPast'],
    trans: 'Label - PastCertificates',
    certType: 'past',
    hasHeaderBtn: true,
    expanded: false,
    classes: _classDetails2.default['past-group']
}];
var PAST_CERT_COL_GROUP_EXPANDED = exports.PAST_CERT_COL_GROUP_EXPANDED = [{
    name: 'PAST CERTIFICATES',
    colIds: ['bronzePast', 'silverPast', 'goldPast'],
    trans: 'Label - PastCertificates',
    certType: 'past',
    hasHeaderBtn: true,
    expanded: true,
    classes: _classDetails2.default['past-group']
}];

var PAST_CERT_COL = exports.PAST_CERT_COL = [{
    id: 'totalPast',
    name: 'TOTAL PAST',
    trans: 'Label - TotalPast'
}];
var PAST_CERT_COL_EXPANDED = exports.PAST_CERT_COL_EXPANDED = [{
    id: 'bronzePast',
    name: 'BRONZE',
    trans: 'Label - Bronze',
    case: 'lower'
}, {
    id: 'silverPast',
    name: 'SILVER',
    trans: 'Label - Silver',
    case: 'lower'
}, {
    id: 'goldPast',
    name: 'GOLD',
    trans: 'Label - Gold',
    case: 'lower'
}];

var NO_STUDENTS_FOUND_LOAD = exports.NO_STUDENTS_FOUND_LOAD = 'No students available';
var NO_STUDENTS_FOUND_SEARCH = exports.NO_STUDENTS_FOUND_SEARCH = 'No students found';

/***/ }),

/***/ "Oe6b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("bD7D");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./modal.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./modal.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Op+y":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/a95d21c632f7eeb5900578919918ddc8.svg";

/***/ }),

/***/ "OrIt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!action) return state;

    switch (action.type) {
        case _participationReportActions.PARTICIPATION_REPORT_RETRIEVED:
            /*
                * {
            "studentProfileId": 100009676,
            "studentCertificateInfo": {
                "gold": 0,
                "silver": 0,
                "bronze": 0,
                "studentCertificateDetails": []
            },
            "participationInfo": {
                "liveMathsPoints": 0,
                "activityPoints": 0,
                "skillQuestsPoints": 0
            },
            "logInInfo": {
                "totalSignIns": 0,
                "totalTime": {
                    "hours": 0,
                    "minutes": 0
                }
            },
            "courseResult": {
                "totalCappedPoints": 0,
                "goldBars": 0,
                "courseResults": []
            },
            "liveMathsResult": {
                "maxLiveMathsLevels": 10,
                "liveMathsInfo": [],
                "averageCorrect": 0.0,
                "totalPoints": 0
            },
            "newCertificateSummary": {
                "bronze": 5,
                "silver": 2,
                "gold": 0,
                "platinum": 0,
                "emerald": 0,
                "diamond": 0,
                "epic": 0,
                "legend": 0,
                "total": 7
            },
            newCoursesResult = [
                {
                    courseId: 0,
                    courseName: 'courseName',
                    averageAccuracy: 30,
                    allActivities: [
                        {
                            accuracy: 0,
                            completionDate: '2023-11-28T11:31:43.134Z',
                            id: 0,
                            name: 'name'
                        }
                    ]
                  }
                ],
            questCourseResult = [
                {
                    courseId: 0,
                    courseName: 'courseName',
                    averageAccuracy: 30,
                    allActivities: [
                        {
                            accuracy: 0,
                            completionDate: '2023-11-28T11:31:43.134Z',
                            id: 0,
                            name: 'name'
                        }
                    ]
                  }
                ];
            } */
            return action.payload;

        case _downloadCertificatesActions.DOWNLOAD_SERVICE_IS_ACTIVE:
            {
                var isActive = action.payload.isActive;

                return { isActive: isActive };
            }

        default:
            return state;
    }
};

var _participationReportActions = __webpack_require__("Ci4y");

var _downloadCertificatesActions = __webpack_require__("EzKo");

var defaultState = null;

/**
 * Participation Report Reducer
 *
 * Consumes PARTICIPATION_REPORT_RETRIEVED action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - current participation report info
 */

/***/ }),

/***/ "P039":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CLOSE_MODAL = exports.OPEN_MODAL = undefined;

var _reduxActions = __webpack_require__("sTbe");

var OPEN_MODAL = exports.OPEN_MODAL = 'OPEN_MODAL';
var CLOSE_MODAL = exports.CLOSE_MODAL = 'CLOSE_MODAL';

var openModal = (0, _reduxActions.createAction)(OPEN_MODAL);
var closeModal = (0, _reduxActions.createAction)(CLOSE_MODAL);

exports.default = {
    openModal: openModal,
    closeModal: closeModal
};

/***/ }),

/***/ "P2FU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var PRIMARY = exports.PRIMARY = 'PRIMARY';
var SECONDARY = exports.SECONDARY = 'SECONDARY';

var CERTIFICATE_URLS = exports.CERTIFICATE_URLS = {
    PRIMARY: {
        BRONZE: '//west.cdn.mathletics.com/certificate-images/v1/primary-background-bronze.png',
        SILVER: '//west.cdn.mathletics.com/certificate-images/v1/primary-background-silver.png',
        GOLD: '//west.cdn.mathletics.com/certificate-images/v1/primary-background-gold.png'
    },
    SECONDARY: {
        BRONZE: '//west.cdn.mathletics.com/certificate-images/v1/secondary-background-bronze.png',
        SILVER: '//west.cdn.mathletics.com/certificate-images/v1/secondary-background-silver.png',
        GOLD: '//west.cdn.mathletics.com/certificate-images/v1/secondary-background-gold.png'
    }
};

/***/ }),

/***/ "P6IG":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/95b26a94ecab58e033e9f8d22f355b55.svg";

/***/ }),

/***/ "PXvo":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/e21490edd078b4f80815b1ddc1d821a1.svg";

/***/ }),

/***/ "Phym":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/5ac06e6f192e9f78b113cebc26f1fa9b.svg";

/***/ }),

/***/ "PlEc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("JW4b");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./close-button.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./close-button.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Q7UM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeHelper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge = __webpack_require__("HN2V");

var _merge2 = _interopRequireDefault(_merge);

var _defaultTheme = __webpack_require__("Xm2K");

var _defaultTheme2 = _interopRequireDefault(_defaultTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ThemeHelper = exports.ThemeHelper = function () {
  function ThemeHelper() {
    _classCallCheck(this, ThemeHelper);
  }

  _createClass(ThemeHelper, null, [{
    key: 'getTheme',

    /**
     * If props contains no theme object or the theme object is empty, returns the base theme
     * Otherwise recursively merges props.theme on top of base theme
     */
    value: function getTheme(props) {
      if (props.theme && Object.keys(props.theme).length > 0) {
        return (0, _merge2.default)({}, _defaultTheme2.default, props.theme);
      }
      return _defaultTheme2.default;
    }
  }, {
    key: 'getDefaultTheme',
    value: function getDefaultTheme() {
      return _defaultTheme2.default;
    }

    /* Calculate any theme overrides of the default values for this component */

  }, {
    key: 'getComponentOverrides',
    value: function getComponentOverrides(theme, component, defaultValues) {
      return (0, _merge2.default)({}, defaultValues(theme), theme.overrides[component]);
    }
  }]);

  return ThemeHelper;
}();

/***/ }),

/***/ "QFxx":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, "@media print {\n  @page {\n    size: A4 portrait;\n    margin: 15mm 10mm;\n    padding: 0; }\n  @-moz-document url-prefix() {\n    @page {\n      margin: 15mm 10mm; } }\n  body,\n  html {\n    width: 1000px;\n    -webkit-print-color-adjust: exact;\n    color-adjust: exact; } }\n\n.component---cKyZM {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 100%;\n          flex: 1 1 100%;\n  overflow: hidden;\n  margin: 20px;\n  padding: 20px;\n  border-radius: 5px;\n  background-color: #fff;\n  -webkit-box-shadow: 5px 5px rgba(0, 0, 0, .07);\n          box-shadow: 5px 5px rgba(0, 0, 0, .07);\n  color: #4e5c67;\n  max-width: 1000px;\n  margin-left: auto;\n  margin-right: auto;\n  min-height: calc(100vh - 80px); }\n\n@media print {\n    .component---cKyZM {\n      -webkit-box-shadow: none;\n              box-shadow: none; } }\n\n.component---cKyZM .header---1s9NW {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center; }\n\n.component---cKyZM .header---1s9NW .logo---1h5mQ {\n      width: 150px; }\n\n.component---cKyZM .header---1s9NW h1 {\n      font-size: 24px;\n      letter-spacing: 1px;\n      color: #4e5c67; }\n\n.component---cKyZM .selection-info---1drYy {\n    background: #e4eaef;\n    border-radius: 5px;\n    padding: 20px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    margin-top: 10px; }\n\n.component---cKyZM .selection-info---1drYy .student-name---4tUmG {\n      font-weight: normal;\n      font-size: 18px;\n      line-height: 24px; }\n\n.component---cKyZM .selection-info---1drYy .selected-date---o8nx6 {\n      color: #6c7378;\n      font-size: 16px;\n      font-weight: normal;\n      line-height: 24px; }\n\n.component---cKyZM .section---3bvEx {\n    border-radius: 20px;\n    border: 1px solid #dbe0e6;\n    background: #fff;\n    /* base */\n    -webkit-box-shadow: 0 1px 2px 0 rgba(0, 25, 55, .06), 0 1px 3px 0 rgba(0, 25, 55, .16);\n            box-shadow: 0 1px 2px 0 rgba(0, 25, 55, .06), 0 1px 3px 0 rgba(0, 25, 55, .16);\n    width: 100%;\n    min-height: 100px;\n    margin: 10px 0; }\n\n.component---cKyZM .section---3bvEx .heading---3VZHq {\n      width: 100%;\n      color: #33475f;\n      text-align: center;\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      margin-top: 24px; }\n\n.component---cKyZM .section---3bvEx .info---3fKdN {\n      width: 100%;\n      text-align: center;\n      margin: 24px 0; }\n\n.component---cKyZM .activities---kU5lQ {\n    margin: 16px 0; }\n\n.component---cKyZM .live-maths---2IPrX,\n  .component---cKyZM .skill-quest---3tSlf,\n  .component---cKyZM .new-courses---2enm4,\n  .component---cKyZM .challenges---1WTLB {\n    margin-top: 35px; }\n\n.component---cKyZM .new-certificate-info---3FCV5 {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin: 12px 0 20px; }\n\n.component---cKyZM .student-certificate-info---1D3M_ {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin-top: 15px; }\n\n.component---cKyZM .weekly-points-info---wxiGr {\n    font-size: 12px;\n    margin: 20px 0 30px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---cKyZM",
	"header": "header---1s9NW",
	"logo": "logo---1h5mQ",
	"selection-info": "selection-info---1drYy",
	"student-name": "student-name---4tUmG",
	"selected-date": "selected-date---o8nx6",
	"section": "section---3bvEx",
	"heading": "heading---3VZHq",
	"info": "info---3fKdN",
	"activities": "activities---kU5lQ",
	"live-maths": "live-maths---2IPrX",
	"skill-quest": "skill-quest---3tSlf",
	"new-courses": "new-courses---2enm4",
	"challenges": "challenges---1WTLB",
	"new-certificate-info": "new-certificate-info---3FCV5",
	"student-certificate-info": "student-certificate-info---1D3M_",
	"weekly-points-info": "weekly-points-info---wxiGr"
};

/***/ }),

/***/ "QXFs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("4n+p");

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _certificateIcon = __webpack_require__("05XZ");

var _certificateIcon2 = _interopRequireDefault(_certificateIcon);

var _rankTiles = __webpack_require__("7L7O");

var _rankTiles2 = _interopRequireDefault(_rankTiles);

var _utils = __webpack_require__("6QRH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tile = function Tile(_ref) {
    var total = _ref.total,
        rank = _ref.rank,
        localeData = _ref.localeData;

    var classes = total > 0 ? _rankTiles2.default.tile : _rankTiles2.default.tile + ' ' + _rankTiles2.default['no-certificates'];
    var totalScore = total > 0 ? total.toString() : '-';
    var rankLabel = (0, _utils.capitalise)(rank);
    var rankTrans = localeData['Label - ' + rankLabel];
    return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
            'div',
            { className: _rankTiles2.default.content },
            _react2.default.createElement(_certificateIcon2.default, { rank: rank, className: _rankTiles2.default['rank-icon'], total: total }),
            _react2.default.createElement(
                'div',
                { className: _rankTiles2.default.rank },
                rankTrans
            ),
            _react2.default.createElement(
                'div',
                { className: _rankTiles2.default.total },
                totalScore
            )
        )
    );
};

Tile.propTypes = {
    total: _propTypes2.default.number,
    rank: _propTypes2.default.string,
    localeData: _propTypes2.default.object
};

function mapStateToProps(state) {
    return {
        localeData: state.localeData
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)((0, _reactStyleable2.default)(_rankTiles2.default)(Tile));

/***/ }),

/***/ "Qbfx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var NETWORK_ERROR = exports.NETWORK_ERROR = 'NETWORK_ERROR';
var httpSuccessCodes = [200, 201, 202, 203, 204];

function handleResourceSuccess(dispatch, payload, action, errorAction) {
    if (httpSuccessCodes.includes(payload.status) && payload.data != null) {
        return dispatch(action);
    }

    if (!errorAction) {
        errorAction = { type: NETWORK_ERROR, error: payload.message };
    }
    return dispatch(errorAction);
}

function handleResourceError(dispatch, error, info) {
    // eslint-disable-next-line no-console
    console.error(info ? info + ' - ' + error : error);
    return dispatch({ type: NETWORK_ERROR, error: error });
}

exports.handleResourceSuccess = handleResourceSuccess;
exports.handleResourceError = handleResourceError;

/***/ }),

/***/ "QcyW":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/c55628a5359b46566d724090941ab88a.svg";

/***/ }),

/***/ "Quvw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("4n+p");

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = __webpack_require__("h2Qy");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _dropdownUp = __webpack_require__("wfBL");

var _dropdownUp2 = _interopRequireDefault(_dropdownUp);

var _dropdownDown = __webpack_require__("pIOt");

var _dropdownDown2 = _interopRequireDefault(_dropdownDown);

var _rankDropdown = __webpack_require__("AlNc");

var _rankDropdown2 = _interopRequireDefault(_rankDropdown);

var _studentCertificatesGemCountActions = __webpack_require__("WElh");

var _studentCertificatesGemCountActions2 = _interopRequireDefault(_studentCertificatesGemCountActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RankDropdown = (_temp = _class = function (_Component) {
    _inherits(RankDropdown, _Component);

    function RankDropdown(props) {
        _classCallCheck(this, RankDropdown);

        var _this = _possibleConstructorReturn(this, (RankDropdown.__proto__ || Object.getPrototypeOf(RankDropdown)).call(this, props));

        _initialiseProps.call(_this);

        var retrievedGems = props.retrievedGems,
            certificatesCount = props.certificatesCount,
            localeData = props.localeData;

        _this.state = {
            dropdownTriggered: false,
            show: false,
            isAllSelected: true,
            selectedOptions: retrievedGems.map(function () {
                return true;
            }),
            title: localeData['Label - All'],
            downloadCount: certificatesCount
        };
        _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
        return _this;
    }

    _createClass(RankDropdown, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('click', this.handleOutsideClick);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this.handleOutsideClick);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var localeData = this.props.localeData;


            return _react2.default.createElement(
                'div',
                { className: _rankDropdown2.default['dropdown-container'] },
                _react2.default.createElement(
                    'div',
                    {
                        role: 'button',
                        className: _rankDropdown2.default['dropdown-trigger'],
                        tabIndex: 0,
                        onClick: this.handleToggle
                    },
                    this.getButtonText(),
                    _react2.default.createElement(_reactInlinesvg2.default, { src: this.state.show ? _dropdownUp2.default : _dropdownDown2.default })
                ),
                this.state.show && _react2.default.createElement(
                    'div',
                    { ref: function ref(node) {
                            _this2.dropdownRef = node;
                        }, className: _rankDropdown2.default['dropdown-options-container'] },
                    _react2.default.createElement(
                        'div',
                        { className: _rankDropdown2.default['dropdown-option'] },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement('input', {
                                className: _rankDropdown2.default['check-box'],
                                id: 'All',
                                name: 'All',
                                type: 'checkbox',
                                checked: this.state.isAllSelected,
                                onChange: function onChange() {
                                    return _this2.toggleSelectAll();
                                }
                            }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'All' },
                                localeData['Label - All']
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            this.props.certificatesCount
                        )
                    ),
                    this.props.retrievedGems.map(function (option, index) {
                        return _react2.default.createElement(
                            'div',
                            {
                                className: _rankDropdown2.default['dropdown-option'],
                                key: option.gem
                            },
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement('input', {
                                    className: _rankDropdown2.default['check-box'],
                                    id: option.gem,
                                    name: option.gem,
                                    type: 'checkbox',
                                    checked: _this2.state.selectedOptions[option.gem - 1],
                                    disabled: option.count === 0,
                                    onChange: function onChange(e) {
                                        return _this2.selectOption(e.target.checked, index);
                                    }
                                }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: option.gem },
                                    _this2.convertToRoman(option.gem)
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                option.count
                            )
                        );
                    })
                )
            );
        }
    }]);

    return RankDropdown;
}(_react.Component), _class.propTypes = {
    certificatesCount: _propTypes2.default.number.isRequired,
    retrievedGems: _propTypes2.default.array,
    localeData: _propTypes2.default.object,
    downloadCertificatesByGem: _propTypes2.default.func
}, _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleOutsideClick = function (event) {
        if (_this3.dropdownRef && _this3.dropdownRef.contains && !_this3.dropdownRef.contains(event.target)) {
            if (_this3.state.show && !_this3.state.dropdownTriggered) {
                _this3.setState({ show: false });
                event.stopPropagation();
            }
            _this3.setState({
                dropdownTriggered: false
            });
        }
    };

    this.handleToggle = function () {
        var toggleState = !_this3.state.show;
        _this3.setState({
            show: toggleState,
            dropdownTriggered: toggleState
        });
    };

    this.getButtonText = function () {
        return _react2.default.createElement(
            'div',
            { key: 'rank-button', title: _this3.state.title },
            _this3.state.title,
            ' (',
            _this3.state.downloadCount,
            ')'
        );
    };

    this.toggleSelectAll = function () {
        var updatedSelect = !_this3.state.isAllSelected;
        _this3.setState({
            isAllSelected: updatedSelect
        });

        if (updatedSelect) {
            _this3.setState({
                selectedOptions: _this3.props.retrievedGems.map(function () {
                    return true;
                }),
                downloadCount: _this3.props.certificatesCount
            });
        } else {
            _this3.setState({
                selectedOptions: _this3.props.retrievedGems.map(function () {
                    return false;
                }),
                downloadCount: 0
            });
        }

        var result = '';

        _this3.setState({
            title: _this3.props.localeData['Label - All']
        });

        var resultCount = updatedSelect ? _this3.props.certificatesCount : 0;
        _this3.props.downloadCertificatesByGem({
            payload: {
                selectedGems: { result: result, resultCount: resultCount }
            }
        });
    };

    this.convertToRoman = function (num) {
        if (num === 16) {
            return '∞';
        }
        var numberArr = [10, 9, 5, 4, 1];
        var RomanArr = ['X', 'IX', 'V', 'IV', 'I'];
        var result = [];

        var findElement = function findElement(e) {
            return e <= num;
        };

        while (num > 0) {
            var nextHighest = numberArr.find(findElement);

            if (nextHighest) {
                result.push(RomanArr[numberArr.indexOf(nextHighest)]);
                num -= nextHighest;
            }
        }
        return result.join('');
    };

    this.selectOption = function (isChecked, index) {
        var selectedOptions = _this3.state.selectedOptions;
        var retrievedGems = _this3.props.retrievedGems;

        // Update the selected options

        var updatedOptions = [].concat(_toConsumableArray(selectedOptions.slice(0, index)), [isChecked], _toConsumableArray(selectedOptions.slice(index + 1)));

        // Determine if all options are selected
        var isAllSelected = isChecked ? updatedOptions.every(function (value) {
            return value;
        }) : false;

        // Filter the selected gems
        var selectedGems = updatedOptions.map(function (value, selectedIndex) {
            return value ? selectedIndex : -1;
        }).filter(function (selectedIndex) {
            return selectedIndex !== -1;
        });

        // Filter the retrieved gems based on updated options
        var newArray = retrievedGems.filter(function (_, optIndex) {
            return updatedOptions[optIndex];
        });

        _this3.setState({
            selectedOptions: updatedOptions,
            isAllSelected: isAllSelected,
            downloadCount: newArray.reduce(function (acc, item) {
                return acc + item.count;
            }, 0),
            title: isAllSelected ? _this3.props.localeData['Label - All'] : newArray.map(function (item) {
                return _this3.convertToRoman(item.gem);
            }).join(', ')
        });

        // Prepare the result string and set it in store
        var result = selectedGems.map(function (gemType) {
            return 'gemTypes: ' + (gemType + 1);
        }).join(', ');

        var resultCount = newArray.reduce(function (acc, item) {
            return acc + item.count;
        }, 0);
        _this3.props.downloadCertificatesByGem({
            payload: {
                selectedGems: { result: result, resultCount: resultCount }
            }
        });
    };
}, _temp);


function mapStateToProps(state) {
    return {
        studentCertificatesGemCount: state.studentCertificatesGemCount
    };
}

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getStudentCertificatesGemCount: _studentCertificatesGemCountActions2.default.getStudentCertificatesGemCount,
        downloadCertificatesByGem: _studentCertificatesGemCountActions2.default.downloadCertificatesByGem
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable2.default)(_rankDropdown2.default)(RankDropdown));

/***/ }),

/***/ "R1VL":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/e31f45cbb53e98ce053f50e2dfc864fa.svg";

/***/ }),

/***/ "RP0/":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("cY7Y");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./new-modal.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./new-modal.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "RRAm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  grey: {
    100: '#e7e9ea',
    200: '#e1e1e1',
    300: '#d6d6d6',
    400: '#cfd2d4',
    500: '#999b9d',
    600: '#808080',
    700: '#777',
    800: '#595959',
    900: '#484848',
    1000: '#757575'
  },
  blue: {
    100: '#7ca2bb',
    200: '#c3d5e1'
  }
};

/***/ }),

/***/ "RYvy":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/c095368fe13af007098add0337226c01.svg";

/***/ }),

/***/ "RkUy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ClassDetails = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp; /* global window */


var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("4n+p");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactComponents = __webpack_require__("fmgT");

var _viewIcon = __webpack_require__("gQpM");

var _viewIcon2 = _interopRequireDefault(_viewIcon);

var _classDetails = __webpack_require__("CzYQ");

var _classDetails2 = _interopRequireDefault(_classDetails);

var _modalActions = __webpack_require__("P039");

var _modalActions2 = _interopRequireDefault(_modalActions);

var _classDetailsActions = __webpack_require__("CXkR");

var _classDetailsActions2 = _interopRequireDefault(_classDetailsActions);

var _classDetailsConstants = __webpack_require__("OVNq");

var _datePickerActions = __webpack_require__("qFO3");

var _datePickerActions2 = _interopRequireDefault(_datePickerActions);

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _urlHelper = __webpack_require__("uOny");

var _urlHelper2 = _interopRequireDefault(_urlHelper);

var _selectedStudentActions = __webpack_require__("1O84");

var _selectedStudentActions2 = _interopRequireDefault(_selectedStudentActions);

var _datePicker = __webpack_require__("9PoH");

var _datePickerConstants = __webpack_require__("p2pT");

var _localeUtils = __webpack_require__("MGx+");

var _button = __webpack_require__("rAoZ");

var _button2 = _interopRequireDefault(_button);

var _utils = __webpack_require__("6QRH");

var _downloadConstants = __webpack_require__("XrKD");

var _downloadIcon = __webpack_require__("vGvd");

var _downloadIcon2 = _interopRequireDefault(_downloadIcon);

var _popupMenu = __webpack_require__("4dSe");

var _popupMenu2 = _interopRequireDefault(_popupMenu);

var _downloadCertificatesActions = __webpack_require__("EzKo");

var _downloadCertificatesActions2 = _interopRequireDefault(_downloadCertificatesActions);

var _toastContainer = __webpack_require__("9L0d");

var _participationReportActions = __webpack_require__("Ci4y");

var _participationReportActions2 = _interopRequireDefault(_participationReportActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Class Details Redux component
 * Receives data via 'props'
 * Base component for Class Details page, displaying data table, search bar, date picker, etc.
 */
var ClassDetails = exports.ClassDetails = (_temp = _class = function (_Component) {
    _inherits(ClassDetails, _Component);

    function ClassDetails(props) {
        _classCallCheck(this, ClassDetails);

        var _this = _possibleConstructorReturn(this, (ClassDetails.__proto__ || Object.getPrototypeOf(ClassDetails)).call(this, props));

        _this.filterStudents = function (data, filterText) {
            filterText = filterText.toLowerCase();
            return data.filter(function (c) {
                return c.student.toLowerCase().indexOf(filterText) > -1;
            });
        };

        _this.onBackClick = function () {
            var history = _this.context.router.history;

            history.goBack();
        };

        _this.displayError = function (error) {
            var localeData = _this.props.localeData;

            _this.props.openModal({
                title: localeData['Modal - Oops'],
                content: _react2.default.createElement(
                    'p',
                    null,
                    error
                ),
                buttons: [{ title: localeData['Modal - TryAgain'], primary: true }]
            });
        };

        _this.renderTextWithViewIcon = function (fieldName, studentData, clickHandler) {
            return _react2.default.createElement(
                'div',
                { className: fieldName + ' ' + _classDetails2.default['icon-container'] },
                _react2.default.createElement(
                    'div',
                    { className: _classDetails2.default.text },
                    studentData[fieldName]
                ),
                _react2.default.createElement(_reactComponents.Button, {
                    icon: _viewIcon2.default,
                    primary: true,
                    type: _reactComponents.Button.LOZENGE,
                    className: _classDetails2.default.icon,
                    onClick: clickHandler
                })
            );
        };

        _this.manageCertificateTypeDisplay = function (colSelected) {
            colSelected.expanded = !colSelected.expanded;
            var isNewCertType = colSelected.certType === 'new';
            var _this$state = _this.state,
                newCertExpanded = _this$state.newCertExpanded,
                pastCertExpanded = _this$state.pastCertExpanded;

            var newCertExpand = isNewCertType ? colSelected.expanded : newCertExpanded;
            var pastCertExpand = !isNewCertType ? colSelected.expanded : pastCertExpanded;
            _this.setTableConfig({ newCertExpanded: newCertExpand, pastCertExpanded: pastCertExpand });
        };

        _this.showPrintModal = function (_ref) {
            var total = _ref.total,
                selectedDateRange = _ref.selectedDateRange,
                localeData = _ref.localeData,
                classroomId = _ref.classroomId,
                downloadAllSchoolOrClassCerts = _ref.downloadAllSchoolOrClassCerts,
                searchFieldText = _ref.searchFieldText;

            _this.props.openModal({
                title: total + ' ' + (total === 1 ? localeData['Label - Certificate'] : localeData['Label - Certificates']),
                content: '' + localeData['PrintModal - SelectVersion'],
                certificatesCount: total,
                buttons: [{
                    title: '' + localeData['Label - FullColour'],
                    primary: true,
                    icon: _downloadIcon2.default,
                    btnType: _downloadConstants.FULL_COLOR,
                    handler: function handler() {
                        return downloadAllSchoolOrClassCerts({
                            fullColor: true,
                            classroomId: classroomId,
                            filterText: searchFieldText,
                            startDate: selectedDateRange.startDate,
                            endDate: selectedDateRange.endDate,
                            downloadType: _downloadConstants.FULL_COLOR
                        });
                    }

                }, {
                    title: '' + localeData['Label - PrintFriendly'],
                    primary: true,
                    icon: _downloadIcon2.default,
                    btnType: _downloadConstants.PRINT_FRIENDLY,
                    handler: function handler() {
                        return downloadAllSchoolOrClassCerts({
                            fullColor: false,
                            classroomId: classroomId,
                            filterText: searchFieldText,
                            startDate: selectedDateRange.startDate,
                            endDate: selectedDateRange.endDate,
                            downloadType: _downloadConstants.PRINT_FRIENDLY
                        });
                    }
                }],
                useNewModal: true
            });
        };

        _this.downloadCertificateOrReports = function (event) {
            var _this$state2 = _this.state,
                classDetailsData = _this$state2.classDetailsData,
                searchFieldText = _this$state2.searchFieldText;
            var _this$props = _this.props,
                selectedClassroom = _this$props.selectedClassroom,
                selectedDateRange = _this$props.selectedDateRange,
                localeData = _this$props.localeData,
                downloadAllSchoolOrClassCerts = _this$props.downloadAllSchoolOrClassCerts;

            var totalCertificates = (0, _utils.calculateClassTotal)(classDetailsData);

            _this.setState(_extends({}, _this.state, {
                shouldDisplayDropdown: false
            }));

            if (event.target.id === '0') {
                if (totalCertificates > _utils.CERTIFICATE_DOWNLOAD_LIMIT) {
                    _this.setState(_extends({}, _this.state, {
                        shouldDisplayDropdown: false,
                        showToast: true
                    }));
                } else {
                    _this.showPrintModal({
                        total: totalCertificates,
                        selectedDateRange: selectedDateRange,
                        localeData: localeData,
                        classroomId: selectedClassroom.id,
                        searchFieldText: searchFieldText,
                        downloadAllSchoolOrClassCerts: downloadAllSchoolOrClassCerts
                    });
                }
            }
            // TODO uncomment this when participation report is needed
            // else {
            //     downloadParticipationReport({
            //         paramData: {
            //             locale: locale(),
            //             classroomId: selectedClassroom.id,
            //             startDate: selectedDateRange.startDate,
            //             endDate: selectedDateRange.endDate,
            //             nameFilter: searchFieldText
            //         }
            //     });
            // }

            var showToastTimer = setTimeout(function () {
                _this.setState(_extends({}, _this.state, {
                    showToast: false
                }));
                clearTimeout(showToastTimer);
            }, 3000);
        };

        _this.handleOutsideClick = function (event) {
            if (_this.state.shouldDisplayDropdown && !_this.state.dropdownTriggered) {
                _this.setState({ shouldDisplayDropdown: false });
                event.stopPropagation();
            }
            _this.setState({
                dropdownTriggered: false
            });
        };

        _this.state = {
            searchFieldText: '',
            classDetailsData: [],
            options: _datePickerConstants.DEFAULT_DATE_OPTIONS_OBJ,
            newCertExpanded: false,
            pastCertExpanded: false,
            shouldDisplayDropdown: false,
            showToast: false,
            dropdownTriggered: false
        };
        return _this;
    }

    _createClass(ClassDetails, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var history = this.context.router.history;
            var _props = this.props,
                selectedDateRange = _props.selectedDateRange,
                selectedClassroom = _props.selectedClassroom;
            var startDate = selectedDateRange.startDate,
                endDate = selectedDateRange.endDate;


            if (!selectedClassroom || !startDate) {
                history.push('/home');
            } else {
                this.getClassDetailsData(startDate, endDate);
            }
            document.addEventListener('click', this.handleOutsideClick);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this.handleOutsideClick);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var selectedDateRange = this.props.selectedDateRange;


            if (selectedDateRange !== nextProps.selectedDateRange) {
                var _nextProps$selectedDa = nextProps.selectedDateRange,
                    startDate = _nextProps$selectedDa.startDate,
                    endDate = _nextProps$selectedDa.endDate;

                this.getClassDetailsData(startDate, endDate);
            }
        }
    }, {
        key: 'getClassDetailsData',
        value: function getClassDetailsData(startDate, endDate) {
            var _this2 = this;

            var classroomId = this.props.selectedClassroom.id;
            this.props.getClassDetailsData(classroomId, startDate, endDate).then(function (action) {
                if (action.type === _classDetailsActions.CLASS_DETAILS_DATA_RETRIEVED) {
                    _this2.setClassDetailsData(action.payload);
                } else {
                    _this2.displayError(action.error);
                }
            }, function (error) {
                return _this2.displayError(error);
            });
        }
    }, {
        key: 'setClassDetailsData',
        value: function setClassDetailsData(classDetailsData) {
            var filterText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.filterText;

            var emptyDataText = _classDetailsConstants.NO_STUDENTS_FOUND_LOAD;
            if (filterText) {
                classDetailsData = this.filterStudents(classDetailsData, filterText);
                emptyDataText = _classDetailsConstants.NO_STUDENTS_FOUND_SEARCH;
            }
            classDetailsData = this.addViewIcons(classDetailsData);
            classDetailsData.emptyDataText = emptyDataText;
            var _state = this.state,
                newCertExpanded = _state.newCertExpanded,
                pastCertExpanded = _state.pastCertExpanded;
            var localeData = this.props.localeData;

            var tableConfig = (0, _localeUtils.getConfig)({
                newCertExpanded: newCertExpanded,
                pastCertExpanded: pastCertExpanded,
                localeData: localeData,
                callback: this.manageCertificateTypeDisplay,
                emptyDataText: emptyDataText
            });
            this.setState({ classDetailsData: classDetailsData, searchFieldText: filterText, tableConfig: tableConfig });
        }
    }, {
        key: 'addViewIcons',


        /**
         * Updates data in class details array, adding view icons to participation points and total certs fields
         */
        value: function addViewIcons(classDetailsData) {
            var _this3 = this;

            return classDetailsData.map(function (item) {
                return _extends({}, item, {
                    participationPoints: _this3.renderTextWithViewIcon('participationPoints', item, function () {
                        return _this3.loadParticipationReport(item);
                    }),
                    totalCertificates: _this3.renderTextWithViewIcon('totalCertificates', item, function () {
                        return _this3.loadCertificatesPage(item);
                    })
                });
            });
        }

        /**
         * Loads participation report for a particular student in a new tab
         */

    }, {
        key: 'loadParticipationReport',
        value: function loadParticipationReport(studentData) {
            var _props2 = this.props,
                selectedClassroom = _props2.selectedClassroom,
                selectedDateRange = _props2.selectedDateRange,
                productId = _props2.productId,
                academicYear = _props2.academicYear,
                schoolId = _props2.schoolId;

            var authToken = _resources2.default.env.authToken;

            var queryParams = ['profileId=' + studentData.id, 'studentName=' + studentData.student, 'schoolId=' + schoolId, 'classroomId=' + selectedClassroom.id, 'startDate=' + selectedDateRange.startDate, 'endDate=' + selectedDateRange.endDate, 'academicYear=' + academicYear.year, 'productId=' + productId, 'authToken=' + authToken, 'locale=' + (0, _localeUtils.locale)()];

            var url = '';
            if (_urlHelper2.default.isRunningOnDeveloperMachine()) {
                queryParams.push('env=' + _resources2.default.env.name);
            } else {
                // eslint-disable-next-line no-underscore-dangle
                var appConfig = window._env_;
                url = appConfig ? appConfig.ReportsUrl : '';
            }

            url += '/participation-report?' + queryParams.join('&');

            window.open(encodeURI(url), '_blank');
        }
    }, {
        key: 'loadCertificatesPage',
        value: function loadCertificatesPage(student) {
            var history = this.context.router.history;


            this.props.selectStudent(student);
            history.push('/certificates');
        }

        /**
         * Renders td content, adding view icon button to right hand side
         */

        /**
         * Manage new and old certificates display
         * */

    }, {
        key: 'setTableConfig',
        value: function setTableConfig(_ref2) {
            var newCertExpanded = _ref2.newCertExpanded,
                pastCertExpanded = _ref2.pastCertExpanded;
            var emptyDataText = this.state.classDetailsData.emptyDataText;
            var localeData = this.props.localeData;

            var tableConfig = (0, _localeUtils.getConfig)({
                newCertExpanded: newCertExpanded,
                pastCertExpanded: pastCertExpanded,
                localeData: localeData,
                callback: this.manageCertificateTypeDisplay,
                emptyDataText: emptyDataText
            });
            this.setState({ tableConfig: tableConfig, newCertExpanded: newCertExpanded, pastCertExpanded: pastCertExpanded });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _state2 = this.state,
                classDetailsData = _state2.classDetailsData,
                tableConfig = _state2.tableConfig,
                shouldDisplayDropdown = _state2.shouldDisplayDropdown,
                showToast = _state2.showToast;
            var _props3 = this.props,
                selectedClassroom = _props3.selectedClassroom,
                academicYear = _props3.academicYear,
                selectedDateRange = _props3.selectedDateRange,
                updateClassDetailsDateRange = _props3.updateClassDetailsDateRange,
                localeData = _props3.localeData,
                downloadCertificatesState = _props3.downloadCertificatesState;

            if (!selectedClassroom) {
                return null;
            }
            var isDownloadActive = downloadCertificatesState.isActive;
            var totalCertificatesInAllClasses = (0, _utils.calculateClassTotal)(classDetailsData);
            var downloadDisabled = totalCertificatesInAllClasses === 0;
            var options = [{ label: 'certificate', value: localeData['DropDown - All Certificates']
                // TODO uncomment when participation option is needed
                // { label: 'participation', value: localeData['DropDown - All Participation & awards reports'] }
            }];
            var toastData = {
                messageData: {
                    message: localeData['Toast - Too Many Certificate Error Message'],
                    type: 'fail',
                    hasClose: true
                }
            };

            return _react2.default.createElement(
                'div',
                { className: _classDetails2.default.component },
                _react2.default.createElement(_reactComponents.Header, { title: localeData['Header - ClassDetails'] }),
                _react2.default.createElement(
                    'div',
                    { className: _classDetails2.default['main-content'] },
                    _react2.default.createElement(
                        'div',
                        { className: _classDetails2.default.header },
                        _react2.default.createElement(
                            'h2',
                            null,
                            selectedClassroom.class
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _classDetails2.default['filter-container'] },
                            showToast && _react2.default.createElement(_toastContainer.ToastContainer, { toastData: toastData }),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(_button2.default, {
                                    className: _classDetails2.default['export-button'],
                                    text: localeData['Label - Export'],
                                    primary: false,
                                    type: _button2.default.LOZENGE,
                                    size: _button2.default.LARGE,
                                    disabled: downloadDisabled,
                                    onClick: function onClick() {
                                        // eslint-disable-next-line max-len
                                        (0, _utils.exportStudentCertificates)(selectedClassroom.id, _this4.state.searchFieldText, selectedDateRange);
                                    }
                                }),
                                _react2.default.createElement(_button2.default, {
                                    className: _classDetails2.default['download-button'],
                                    text: isDownloadActive ? localeData['Label - Preparing download'] : localeData['Label - Download'],
                                    primary: false,
                                    type: _button2.default.LOZENGE,
                                    size: _button2.default.SMALL,
                                    icon: isDownloadActive ? null : _downloadIcon2.default,
                                    alignIcon: _button2.default.RIGHT,
                                    btnType: _downloadConstants.ALL_NEW,
                                    disabled: isDownloadActive,
                                    onClick: function onClick() {
                                        _this4.setState(_extends({}, _this4.state, {
                                            shouldDisplayDropdown: !_this4.state.shouldDisplayDropdown,
                                            dropdownTriggered: !_this4.state.shouldDisplayDropdown
                                        }));
                                    }
                                })
                            ),
                            shouldDisplayDropdown && _react2.default.createElement(_popupMenu2.default, {
                                downloadDisabled: downloadDisabled,
                                isClassLevel: true,
                                options: options,
                                downloadCertificateOrReports: this.downloadCertificateOrReports
                            }),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(_reactComponents.Search, {
                                    onType: function onType(filterText) {
                                        _this4.setClassDetailsData(_this4.props.classDetailsData, filterText);
                                    },
                                    placeholder: localeData['Label- StudentName']
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(_datePicker.DatePicker, {
                                    currentDate: selectedDateRange,
                                    academicYear: academicYear,
                                    onDateChange: updateClassDetailsDateRange,
                                    localeData: localeData
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _classDetails2.default['table-container'] },
                        _react2.default.createElement(_reactComponents.DataTable, {
                            className: _classDetails2.default['data-table'],
                            config: tableConfig,
                            data: classDetailsData
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactComponents.Footer,
                    null,
                    _react2.default.createElement(_reactComponents.Button, {
                        text: localeData['Label - Back'],
                        type: _reactComponents.Button.LOZENGE,
                        size: _reactComponents.Button.LARGE,
                        primary: true,
                        onClick: this.onBackClick
                    })
                )
            );
        }
    }]);

    return ClassDetails;
}(_react.Component), _class.contextTypes = {
    router: _propTypes2.default.object
}, _class.propTypes = {
    selectedClassroom: _propTypes2.default.shape({
        id: _propTypes2.default.number,
        class: _propTypes2.default.string
    }),
    getClassDetailsData: _propTypes2.default.func,
    selectedDateRange: _propTypes2.default.shape({
        type: _propTypes2.default.string,
        startDate: _propTypes2.default.string,
        endDate: _propTypes2.default.string
    }),
    classDetailsData: _propTypes2.default.array,
    openModal: _propTypes2.default.func,
    updateClassDetailsDateRange: _propTypes2.default.func,
    productId: _propTypes2.default.string,
    academicYear: _propTypes2.default.shape({
        startDate: _propTypes2.default.string,
        endDate: _propTypes2.default.string
    }),
    schoolId: _propTypes2.default.number,
    localeData: _propTypes2.default.object,
    selectStudent: _propTypes2.default.func,
    downloadAllSchoolOrClassCerts: _propTypes2.default.func,
    downloadCertificatesState: _propTypes2.default.object
}, _temp);

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */

function mapStateToProps(state) {
    return {
        localeData: state.localeData,
        selectedClassroom: state.selectedClass,
        selectedDateRange: state.selectedDateRange,
        classDetailsData: state.classDetailsData,
        productId: state.productId,
        academicYear: state.academicYear,
        schoolId: state.schoolId,
        downloadCertificatesState: state.downloadCertificatesState
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getClassDetailsData: _classDetailsActions2.default.getClassDetailsData,
        openModal: _modalActions2.default.openModal,
        updateClassDetailsDateRange: _datePickerActions2.default.updateSelectedDateRange,
        selectStudent: _selectedStudentActions2.default.selectStudent,
        downloadAllSchoolOrClassCerts: _downloadCertificatesActions2.default.downloadAllSchoolOrClassCerts,
        downloadParticipationReport: _participationReportActions2.default.downloadParticipationReport
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ClassDetails);

/***/ }),

/***/ "SCGg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.STUDENT_CERTIFICATES_RETRIEVED = undefined;

var _lodash = __webpack_require__("M4fF");

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _resourceHandlers = __webpack_require__("Qbfx");

var _certificateTemplateConstants = __webpack_require__("P2FU");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STUDENT_CERTIFICATES_RETRIEVED = exports.STUDENT_CERTIFICATES_RETRIEVED = 'STUDENT_CERTIFICATES_RETRIEVED';

function getStudentCertificates(_ref) {
    var startDate = _ref.startDate,
        endDate = _ref.endDate,
        classroomId = _ref.classroomId,
        productId = _ref.productId;

    return function (dispatch) {
        return _resources2.default.studentCertificates.get({ classroomId: classroomId }).withParams({ productId: productId, startDate: startDate, endDate: endDate }).send().then(function (payload) {
            var data = payload.data;
            if (data && data.studentsCertificatesSummary) {
                var mappedStudentList = data.studentsCertificatesSummary.map(function (studentData) {
                    return {
                        id: studentData.userProfileId,
                        userId: studentData.userId,
                        firstName: studentData.firstName,
                        lastName: studentData.lastName,
                        pastCertificates: studentData.pastCertificates,
                        certificates: studentData.certificates
                    };
                });
                mappedStudentList = (0, _lodash.sortBy)(mappedStudentList, ['lastName', 'firstName']);
                var mappedData = {
                    schoolType: data.isPrimary ? _certificateTemplateConstants.PRIMARY : _certificateTemplateConstants.SECONDARY,
                    allStudents: {
                        pastCertificates: data.classPastCertificates,
                        certificates: data.classCertificates,
                        total: data.total
                    },
                    studentList: mappedStudentList
                };
                return (0, _resourceHandlers.handleResourceSuccess)(dispatch, payload, {
                    type: STUDENT_CERTIFICATES_RETRIEVED,
                    payload: mappedData
                });
            }

            return (0, _resourceHandlers.handleResourceError)(dispatch, payload.message);
        }, function (error) {
            return (0, _resourceHandlers.handleResourceError)(dispatch, error);
        });
    };
}

exports.default = {
    getStudentCertificates: getStudentCertificates
};

/***/ }),

/***/ "SgkA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global window document */
/* eslint-disable no-console */

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxThunk = __webpack_require__("bEzl");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxPromise = __webpack_require__("po9w");

var _reduxPromise2 = _interopRequireDefault(_reduxPromise);

var _querystring = __webpack_require__("1nuA");

var _querystring2 = _interopRequireDefault(_querystring);

var _redux = __webpack_require__("2KeS");

var _utils = __webpack_require__("6QRH");

var _combinedReducers = __webpack_require__("Gylf");

var _combinedReducers2 = _interopRequireDefault(_combinedReducers);

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _urlHelper = __webpack_require__("uOny");

var _urlHelper2 = _interopRequireDefault(_urlHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var createStoreWithMiddleware = (0, _redux.applyMiddleware)(_reduxThunk2.default, _reduxPromise2.default)(_redux.createStore);

var BasicApp = function () {
    function BasicApp(element, dynamicOptions) {
        _classCallCheck(this, BasicApp);

        BasicApp.configure();

        this.element = element;
        this.options = (0, _utils.handleDefaults)({}, dynamicOptions);

        this.renderElement();
    }

    _createClass(BasicApp, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'h1',
                null,
                'You should define a render() method for your subclass of BasicApp'
            );
        }

        // Implementation details.  You should not need to change any code past this point.

    }, {
        key: 'renderElement',
        value: function renderElement() {
            var store = createStoreWithMiddleware(_combinedReducers2.default,
            // eslint-disable-next-line no-underscore-dangle
            window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
                return f;
            });

            _reactDom2.default.render(this.render(store), document.querySelector(this.element));
        }
    }], [{
        key: 'configure',
        value: function configure() {
            // How we want to configure things depends on where this app is running,
            // and where the services we want to access live.
            //
            // 1. When running on a developer's machine, using a mock server, we want
            //    to use a hard-coded config from
            //
            //       helpers/local-resource-config.js
            //
            // 2. When running on a developer's machine, but we want to use back-end
            //    services on demo, QA or live, we want to get the configuration from
            //    the configuration of the host app.
            //
            // 3. When running on demo, QA or live, the configuration will be injected
            //    based on the host app's configuration, but can be overridden by query
            //    parameters.
            //
            // We determine which situation we have by looking at the window location
            // URL and the query parameters, and whether there is a pppAppConfig property
            // on the window object.

            var location = window.location;
            var runningOnDeveloperMachine = _urlHelper2.default.isRunningOnDeveloperMachine();
            var queryParams = location.search;
            var query = queryParams.replace('?', '');
            var params = _querystring2.default.parse(query);

            if (runningOnDeveloperMachine) {
                BasicApp.configureForDeveloperMachine(params);
            } else {
                BasicApp.configureForRemoteHost(params);
            }
        }
    }, {
        key: 'configureForDeveloperMachine',
        value: function configureForDeveloperMachine(params) {
            var envName = params.env;

            if (!envName) {
                console.log('BasicApp.configureForDeveloperMachine() - you did not provide an "env" query' + ' parameter, so I am assuming you want to talk to live.');

                envName = 'live';
            }

            var credentials = BasicApp.getCredentials(params);

            if (envName === 'local' || BasicApp.weHaveUsableCredentials(credentials)) {
                _resources2.default.initialise(envName, credentials);
            }
        }
    }, {
        key: 'configureForRemoteHost',
        value: function configureForRemoteHost(params) {
            // eslint-disable-next-line no-underscore-dangle
            var config = window._env_;
            var envName = config.env || 'live';
            var credentials = BasicApp.getCredentials(params);

            console.log('config', config);
            if (!config.BaseName) {
                console.log('BasicApp.configureForRemoteHost() - your env config does not' + ' include a BaseName item; we will assume it should be blank.');

                config.BaseName = '';
            }

            if (BasicApp.weHaveUsableCredentials(credentials)) {
                _resources2.default.initialise(envName, credentials);
                _resources2.default.env.setConfiguration(config);
            }
        }
    }, {
        key: 'getCredentials',
        value: function getCredentials(params) {
            var credentials = {};
            var items = ['authToken', 'username', 'password'];

            for (var paramName in params) {
                var value = params[paramName];

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;

                        if (paramName.toLowerCase() === item.toLowerCase()) {
                            credentials[item] = value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            return credentials;
        }
    }, {
        key: 'weHaveUsableCredentials',
        value: function weHaveUsableCredentials(credentials) {
            var usableCredentials = false;

            if (credentials.authToken) {
                usableCredentials = true;
            } else if (credentials.username && credentials.password) {
                usableCredentials = true;
            }

            if (!usableCredentials) {
                console.error('EntryApp.configureForDeveloperMachine() - to execute, we need either an authToken or' + ' a username/password pair.  After combining data from window._env_ and the query' + ' parameters, I still do not have what I need. The app will probably not function correctly if' + ' it requires any 3P resources.');
            }

            return usableCredentials;
        }
    }]);

    return BasicApp;
}();

exports.default = BasicApp;

/***/ }),

/***/ "ShFx":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/fa2cfffe42543a5aa862fb8e0d46e2da.svg";

/***/ }),

/***/ "TFxc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9wCx");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./points-display.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./points-display.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Ticr":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, "/* React Core CSS */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block; }\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline; }\naudio:not([controls]) {\n  display: none;\n  height: 0; }\n[hidden],\ntemplate {\n  display: none; }\na {\n  background-color: transparent; }\na:active,\na:hover {\n  outline: 0; }\nabbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted; }\nb,\nstrong {\n  font-weight: inherit; }\nb,\nstrong {\n  font-weight: bolder; }\ndfn {\n  font-style: italic; }\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0; }\nmark {\n  background-color: #ff0;\n  color: #000; }\nsmall {\n  font-size: 80%; }\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline; }\nsup {\n  top: -0.5em; }\nsub {\n  bottom: -0.25em; }\nimg {\n  border: 0; }\nsvg:not(:root) {\n  overflow: hidden; }\nfigure {\n  margin: 1em 40px; }\nhr {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  height: 0;\n  overflow: visible; }\npre {\n  overflow: auto; }\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace;\n  font-size: 1em; }\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit;\n  margin: 0; }\nbutton {\n  overflow: visible; }\nbutton,\nselect {\n  text-transform: none; }\nbutton,\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer; }\nbutton[disabled] {\n  cursor: default; }\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0; }\nbutton:-moz-focusring,\ninput:-moz-focusring {\n  outline: 1px dotted ButtonText; }\ninput {\n  line-height: normal; }\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0; }\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; }\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em; }\nlegend {\n  border: 0;\n  padding: 0; }\ntextarea {\n  overflow: auto; }\noptgroup {\n  font-weight: bold; }\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font-family: inherit;\n  vertical-align: baseline; }\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block; }\nol,\nul {\n  list-style: none; }\nblockquote,\nq {\n  quotes: none; }\nblockquote::before,\nblockquote::after,\nq::before,\nq::after {\n  content: '';\n  content: none; }\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\nbody {\n  font-family: poppins, Arial, sans-serif;\n  font-size: 16px;\n  line-height: 1.42857143;\n  color: #484848;\n  background-color: #e7e9ea;\n  margin: 0;\n  padding: 0; }\nbutton:focus,\n[role=\"button\"]:focus,\ninput:focus {\n  outline: 0; }\n.text-center---274eX {\n  text-align: center; }\nh1 {\n  font-size: 30px;\n  font-weight: 500; }\n.version-number---1UPSd {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  z-index: 10;\n  color: #aaa;\n  font-size: 9px; }\n/*\n// Enable use bootstrap\n// npm install bootstrap-sass --save\n$icon-font-path: '~bootstrap-sass/assets/fonts/bootstrap/';\n@import '~bootstrap-sass/assets/stylesheets/bootstrap';\n@import '~bootstrap-sass/assets/stylesheets/bootstrap/theme';\n*/\n/*\n// Enable use fontawesome\n// npm install font-awesome-sass --save\n$fa-font-path: \"~font-awesome-sass/assets/fonts/font-awesome/\";\n@import \"~font-awesome-sass/assets/stylesheets/font-awesome\";\n*/\n.toast-holder---5Xv1v {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: column nowrap;\n          flex-flow: column nowrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: absolute;\n  top: 120px;\n  left: -50px;\n  width: 100%; }\n.toast---2yvXl {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: relative;\n  top: -4px;\n  opacity: 0;\n  width: 710px;\n  min-width: 480px;\n  min-height: 64px;\n  border-radius: 12px;\n  border: 2px solid #fef6f7;\n  -webkit-transition: all 1s;\n  transition: all 1s;\n  -webkit-transition-delay: 500ms;\n          transition-delay: 500ms;\n  -webkit-box-shadow: 0 2px 4px -1px rgba(0, 25, 55, .06), 0 4px 6px -1px rgba(0, 25, 55, .1);\n          box-shadow: 0 2px 4px -1px rgba(0, 25, 55, .06), 0 4px 6px -1px rgba(0, 25, 55, .1); }\n@media (max-width: 992px) {\n    .toast---2yvXl {\n      width: 650px; } }\n@media (max-width: 768px) {\n    .toast---2yvXl {\n      width: calc(100% - 30px);\n      margin-left: 15px; } }\n.toast---2yvXl.show---lkFnt {\n    top: 0;\n    opacity: 1; }\n.toast---2yvXl.hide---2LYxK {\n    top: 0;\n    opacity: 0; }\n.toast---2yvXl.success---oZWHC {\n    background: #1d9b37; }\n.toast---2yvXl.fail---hKdc6 {\n    background: #f0939b; }\n.toast---2yvXl .message---3YPQ8 {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    width: 100%;\n    position: relative;\n    padding: 0 24px; }\n.toast---2yvXl .message---3YPQ8 .icon---133Ec {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      margin: 0 12px;\n      border-radius: 50%;\n      background: linear-gradient(136deg, #fa7e46 -2.12%, #cc461b 104.17%); }\n.toast---2yvXl .message---3YPQ8 .text---1y9ZY {\n      color: #430006;\n      text-align: center;\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 140%;\n      /* 25.2px */\n      max-width: 625px;\n      width: 100%; }\n.toast---2yvXl .message---3YPQ8 .close-button---1W_Mc {\n      background: none;\n      height: auto;\n      width: auto; }\n.toast---2yvXl .message---3YPQ8 .close-button---1W_Mc span {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex; }\n.toast---2yvXl .message---3YPQ8 .close-button---1W_Mc:hover svg path {\n        stroke: #f00; }\n", ""]);

// exports
exports.locals = {
	"text-center": "text-center---274eX",
	"version-number": "version-number---1UPSd",
	"toast-holder": "toast-holder---5Xv1v",
	"toast": "toast---2yvXl",
	"show": "show---lkFnt",
	"hide": "hide---2LYxK",
	"success": "success---oZWHC",
	"fail": "fail---hKdc6",
	"message": "message---3YPQ8",
	"icon": "icon---133Ec",
	"text": "text---1y9ZY",
	"close-button": "close-button---1W_Mc"
};

/***/ }),

/***/ "Tj2k":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, "/* React Core CSS */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block; }\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline; }\naudio:not([controls]) {\n  display: none;\n  height: 0; }\n[hidden],\ntemplate {\n  display: none; }\na {\n  background-color: transparent; }\na:active,\na:hover {\n  outline: 0; }\nabbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted; }\nb,\nstrong {\n  font-weight: inherit; }\nb,\nstrong {\n  font-weight: bolder; }\ndfn {\n  font-style: italic; }\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0; }\nmark {\n  background-color: #ff0;\n  color: #000; }\nsmall {\n  font-size: 80%; }\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline; }\nsup {\n  top: -0.5em; }\nsub {\n  bottom: -0.25em; }\nimg {\n  border: 0; }\nsvg:not(:root) {\n  overflow: hidden; }\nfigure {\n  margin: 1em 40px; }\nhr {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  height: 0;\n  overflow: visible; }\npre {\n  overflow: auto; }\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace;\n  font-size: 1em; }\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit;\n  margin: 0; }\nbutton {\n  overflow: visible; }\nbutton,\nselect {\n  text-transform: none; }\nbutton,\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer; }\nbutton[disabled] {\n  cursor: default; }\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0; }\nbutton:-moz-focusring,\ninput:-moz-focusring {\n  outline: 1px dotted ButtonText; }\ninput {\n  line-height: normal; }\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0; }\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; }\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em; }\nlegend {\n  border: 0;\n  padding: 0; }\ntextarea {\n  overflow: auto; }\noptgroup {\n  font-weight: bold; }\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font-family: inherit;\n  vertical-align: baseline; }\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block; }\nol,\nul {\n  list-style: none; }\nblockquote,\nq {\n  quotes: none; }\nblockquote::before,\nblockquote::after,\nq::before,\nq::after {\n  content: '';\n  content: none; }\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\nbody {\n  font-family: poppins, Arial, sans-serif;\n  font-size: 16px;\n  line-height: 1.42857143;\n  color: #484848;\n  background-color: #e7e9ea;\n  margin: 0;\n  padding: 0; }\nbutton:focus,\n[role=\"button\"]:focus,\ninput:focus {\n  outline: 0; }\n.text-center {\n  text-align: center; }\nh1 {\n  font-size: 30px;\n  font-weight: 500; }\n.version-number {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  z-index: 10;\n  color: #aaa;\n  font-size: 9px; }\n/*\n// Enable use bootstrap\n// npm install bootstrap-sass --save\n$icon-font-path: '~bootstrap-sass/assets/fonts/bootstrap/';\n@import '~bootstrap-sass/assets/stylesheets/bootstrap';\n@import '~bootstrap-sass/assets/stylesheets/bootstrap/theme';\n*/\n/*\n// Enable use fontawesome\n// npm install font-awesome-sass --save\n$fa-font-path: \"~font-awesome-sass/assets/fonts/font-awesome/\";\n@import \"~font-awesome-sass/assets/stylesheets/font-awesome\";\n*/\n", ""]);

// exports


/***/ }),

/***/ "UIQG":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/299f16fedb6ad60258ddb6be6c972f41.svg";

/***/ }),

/***/ "VJOB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NO_CLASSES_FOUND_SEARCH = exports.NO_CLASSES_FOUND_LOAD = exports.TABLE_CONFIG = undefined;

var _overview = __webpack_require__("4kNV");

var _overview2 = _interopRequireDefault(_overview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TABLE_CONFIG = exports.TABLE_CONFIG = {
    cols: [{ id: 'class', name: 'MATHLETICS CLASS', sort: { sortAs: 'string' }, trans: 'Label - MathleticsClass' }, { id: 'teacher', name: 'TEACHER', trans: 'Label - Teacher' }, { id: 'course', name: 'COURSE', sort: { sortAs: 'string' }, trans: 'Label - Course' }, { id: 'total', name: 'TOTAL', trans: 'Label - Total' }],
    colGroups: [[{
        name: '',
        colIds: ['class', 'teacher', 'course'],
        classes: _overview2.default['first-group']
    }, {
        name: 'CERTIFICATES',
        colIds: ['total'],
        classes: 'text-center',
        trans: 'Label - Certificates'
    }]],
    defaultSort: 'class',
    onSelectRow: function onSelectRow() {
        return null;
    } // this will get populated in Overview component
};

var NO_CLASSES_FOUND_LOAD = exports.NO_CLASSES_FOUND_LOAD = 'Empty - NoClasses';
var NO_CLASSES_FOUND_SEARCH = exports.NO_CLASSES_FOUND_SEARCH = 'Empty - NoClassesFound';

/***/ }),

/***/ "Vnjy":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Ticr");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./toast.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./toast.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "W7lP":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/8e8d4feac8f8d40612e2bc3629a14a3b.svg";

/***/ }),

/***/ "WElh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.STUDENT_CERTIFICATES_GEM_COUNT_SELECTED = exports.STUDENT_CERTIFICATES_GEM_COUNT_RETRIEVED = undefined;

var getStudentCertificatesGemCount = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var startDate = _ref2.startDate,
            endDate = _ref2.endDate,
            classroomId = _ref2.classroomId,
            groupId = _ref2.groupId,
            studentUserProfileId = _ref2.studentUserProfileId,
            certificateType = _ref2.certificateType;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', function (dispatch) {
                            return _resources2.default.studentCertificatesGemCount.get().withParams({ type: certificateType, startDate: startDate, endDate: endDate, classroomId: classroomId, groupId: groupId, studentUserProfileId: studentUserProfileId }).send().then(function (payload) {
                                return (0, _resourceHandlers.handleResourceSuccess)(dispatch, payload, {
                                    type: STUDENT_CERTIFICATES_GEM_COUNT_RETRIEVED,
                                    payload: {
                                        retrievedGems: payload.data
                                    }
                                });
                            }, function (error) {
                                return (0, _resourceHandlers.handleResourceError)(dispatch, error);
                            });
                        });

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getStudentCertificatesGemCount(_x) {
        return _ref.apply(this, arguments);
    };
}();

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _resourceHandlers = __webpack_require__("Qbfx");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var STUDENT_CERTIFICATES_GEM_COUNT_RETRIEVED = exports.STUDENT_CERTIFICATES_GEM_COUNT_RETRIEVED = 'STUDENT_CERTIFICATES_GEM_COUNT_RETRIEVED';
var STUDENT_CERTIFICATES_GEM_COUNT_SELECTED = exports.STUDENT_CERTIFICATES_GEM_COUNT_SELECTED = 'STUDENT_CERTIFICATES_GEM_COUNT_SELECTED';

function downloadCertificatesByGem(_ref3) {
    var payload = _ref3.payload;

    return function (dispatch) {
        dispatch({
            type: STUDENT_CERTIFICATES_GEM_COUNT_SELECTED,
            payload: payload
        });
    };
}

exports.default = {
    getStudentCertificatesGemCount: getStudentCertificatesGemCount,
    downloadCertificatesByGem: downloadCertificatesByGem
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "WZai":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/77f651e9ceade21d357055660c7fe8ba.svg";

/***/ }),

/***/ "XAH4":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("vtwl");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./certificates.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./certificates.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Xm2K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _palette = __webpack_require__("Flem");

var _palette2 = _interopRequireDefault(_palette);

var _colours = __webpack_require__("RRAm");

var _colours2 = _interopRequireDefault(_colours);

var _shadows = __webpack_require__("vrRF");

var _shadows2 = _interopRequireDefault(_shadows);

var _layout = __webpack_require__("8P8H");

var _layout2 = _interopRequireDefault(_layout);

var _typography = __webpack_require__("rnUz");

var _typography2 = _interopRequireDefault(_typography);

var _zIndex = __webpack_require__("w8LL");

var _zIndex2 = _interopRequireDefault(_zIndex);

var _overrides = __webpack_require__("5/Ko");

var _overrides2 = _interopRequireDefault(_overrides);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  palette: _palette2.default,
  colours: _colours2.default,
  shadows: _shadows2.default,
  layout: _layout2.default,
  typography: _typography2.default,
  zIndex: _zIndex2.default,
  overrides: _overrides2.default
};

/***/ }),

/***/ "Xotz":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/206cb8cbe47d0d7fb13df3dbf3c84fac.svg";

/***/ }),

/***/ "XrKD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ALL_NEW = exports.ALL_PAST = exports.PRINT_FRIENDLY = exports.FULL_COLOR = exports.DOWNLOAD_URL_ALL_STUDENTS_BRONZE_CERTS = exports.DOWNLOAD_URL_ALL_STUDENTS_SILVER_CERTS = exports.DOWNLOAD_URL_ALL_STUDENTS_GOLD_CERTS = exports.DOWNLOAD_URL_ALL_STUDENTS_ALL_NEW_CERTS = exports.DOWNLOAD_URL_ALL_STUDENTS_ALL_CERTS = undefined;
exports.generateUrlAllStudentsCertsForType = generateUrlAllStudentsCertsForType;
exports.generateUrlStudentCertsForType = generateUrlStudentCertsForType;
exports.generateUrlStudentNewCerts = generateUrlStudentNewCerts;
exports.generateUrlAllStudentsNewCertsForType = generateUrlAllStudentsNewCertsForType;
exports.generateUrlStudentNewCertsForType = generateUrlStudentNewCertsForType;

var _certificatesConstants = __webpack_require__("J7W8");

// eslint-disable-next-line max-len
var DOWNLOAD_URL_ALL_STUDENTS_ALL_CERTS = exports.DOWNLOAD_URL_ALL_STUDENTS_ALL_CERTS = '@SchoolUsageReportsGatewayBaseUrl/School/Download/Classroom/Certificates';
var DOWNLOAD_URL_ALL_STUDENTS_ALL_NEW_CERTS = exports.DOWNLOAD_URL_ALL_STUDENTS_ALL_NEW_CERTS = '@CertificateGatewayBaseUrl/new-certificates/export';
var DOWNLOAD_URL_ALL_STUDENTS_GOLD_CERTS = exports.DOWNLOAD_URL_ALL_STUDENTS_GOLD_CERTS = generateUrlAllStudentsCertsForType(_certificatesConstants.CERT_VALUES[_certificatesConstants.GOLD_CERT_TYPE_PAST]);
var DOWNLOAD_URL_ALL_STUDENTS_SILVER_CERTS = exports.DOWNLOAD_URL_ALL_STUDENTS_SILVER_CERTS = generateUrlAllStudentsCertsForType(_certificatesConstants.CERT_VALUES[_certificatesConstants.SILVER_CERT_TYPE_PAST]);
var DOWNLOAD_URL_ALL_STUDENTS_BRONZE_CERTS = exports.DOWNLOAD_URL_ALL_STUDENTS_BRONZE_CERTS = generateUrlAllStudentsCertsForType(_certificatesConstants.CERT_VALUES[_certificatesConstants.BRONZE_CERT_TYPE_PAST]);

function generateUrlAllStudentsCertsForType(type) {
    return '@CertificateGatewayBaseUrl/certificates/types/' + type + '/export';
}

function generateUrlStudentCertsForType(userProfileId) {
    return '@CertificateGatewayBaseUrl/certificates/students/' + userProfileId + '/export';
}

function generateUrlStudentNewCerts(userId) {
    return '@CertificateGatewayBaseUrl/new-certificates/students/' + userId + '/export';
}

function generateUrlAllStudentsNewCertsForType(type) {
    return '@CertificateGatewayBaseUrl/new-certificates/types/' + type + '/export';
}

function generateUrlStudentNewCertsForType(_ref) {
    var userId = _ref.userId,
        type = _ref.type;

    return '@CertificateGatewayBaseUrl/new-certificates/students/' + userId + '/types/' + type + '/export';
}

var FULL_COLOR = exports.FULL_COLOR = 'fullColor';
var PRINT_FRIENDLY = exports.PRINT_FRIENDLY = 'printFriendly';
var ALL_PAST = exports.ALL_PAST = 'allPast';
var ALL_NEW = exports.ALL_NEW = 'allNew';

/***/ }),

/***/ "YAlp":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("eqXO");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./live-points.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./live-points.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Z5LP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---2jVKb {\n  padding: 0 40px;\n  text-align: left; }\n  .component---2jVKb .text---25-TU {\n    color: #1981c4;\n    font-size: 28px; }\n  @media (min-width: 992px) {\n      .component---2jVKb .text---25-TU {\n        font-size: 45px; } }\n  .component---2jVKb .title---2pQuu {\n    color: #595959;\n    font-size: 16px; }\n  @media (min-width: 992px) {\n      .component---2jVKb .title---2pQuu {\n        font-size: 18px; } }\n", ""]);

// exports
exports.locals = {
	"component": "component---2jVKb",
	"text": "text---25-TU",
	"title": "title---2pQuu"
};

/***/ }),

/***/ "Z6mg":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/05f519c617524c6958c6f2c97b68a9b2.svg";

/***/ }),

/***/ "ZDX+":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---1pwvo {\n  padding: 50px 0; }\n  .component---1pwvo .icon-container---3zMWn {\n    width: 180px;\n    height: 180px;\n    background: #d6d6d6;\n    border-radius: 50%;\n    margin: auto; }\n  .component---1pwvo .icon-container---3zMWn > span {\n      display: block;\n      width: 100%;\n      height: 100%; }\n  .component---1pwvo .icon-container---3zMWn svg {\n      display: block;\n      width: calc(100% - 50px);\n      height: calc(100% - 50px);\n      margin-left: 25px;\n      margin-top: -10px; }\n  .component---1pwvo .icon-container---3zMWn svg path {\n        fill: #fff !important; }\n  .component---1pwvo p {\n    font-size: 26px;\n    color: #415667;\n    margin-top: 25px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1pwvo",
	"icon-container": "icon-container---3zMWn"
};

/***/ }),

/***/ "aAV2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+lTj");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./header-with-academic-year.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./header-with-academic-year.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "akZC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("4n+p");

__webpack_require__("nIya");

var _livePoints = __webpack_require__("YAlp");

var _livePoints2 = _interopRequireDefault(_livePoints);

var _pointsDisplay = __webpack_require__("u5Xn");

var _pointsDisplay2 = _interopRequireDefault(_pointsDisplay);

var _icon_activity_points = __webpack_require__("dsjG");

var _icon_activity_points2 = _interopRequireDefault(_icon_activity_points);

var _icon_livemaths_points = __webpack_require__("QcyW");

var _icon_livemaths_points2 = _interopRequireDefault(_icon_livemaths_points);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Points Component for Live Maths and Activity
 * Displays points earned by the student for a selected date
 */
var LivePoints = (_temp = _class = function (_Component) {
    _inherits(LivePoints, _Component);

    function LivePoints(props) {
        _classCallCheck(this, LivePoints);

        var _this = _possibleConstructorReturn(this, (LivePoints.__proto__ || Object.getPrototypeOf(LivePoints)).call(this, props));

        var localeData = props.localeData;
        var liveMathsPoints = _this.props.participationInfo.liveMathsPoints;
        var totalCappedPoints = _this.props.courseResult.totalCappedPoints;

        _this.state = {
            livePoints: [{
                title: localeData['Points - LiveMaths'],
                points: liveMathsPoints,
                imageSrc: _icon_livemaths_points2.default,
                elementStyle: 'logo-tulip-background'
            }, {
                title: localeData['Points - Activity'],
                points: totalCappedPoints,
                imageSrc: _icon_activity_points2.default,
                elementStyle: 'logo-denim-background'
            }]
        };
        return _this;
    }

    _createClass(LivePoints, [{
        key: 'render',
        value: function render() {
            var livePoints = this.state.livePoints;


            return _react2.default.createElement(
                'div',
                { className: _livePoints2.default.component },
                livePoints.map(function (points) {
                    return _react2.default.createElement(_pointsDisplay2.default, {
                        key: points.title,
                        elementStyle: points.elementStyle,
                        imgSrc: points.imageSrc,
                        title: points.title,
                        points: points.points });
                })
            );
        }
    }]);

    return LivePoints;
}(_react.Component), _class.propTypes = {
    participationInfo: _propTypes2.default.shape({
        activityPoints: _propTypes2.default.number,
        liveMathsPoints: _propTypes2.default.number,
        skillQuestsPoints: _propTypes2.default.number
    }),
    courseResult: _propTypes2.default.shape({
        totalCappedPoints: _propTypes2.default.number,
        goldBars: _propTypes2.default.number
    }),
    localeData: _propTypes2.default.object
}, _temp);


function mapStateToProps(state) {
    return {
        localeData: state.localeData
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactStyleable2.default)(_livePoints2.default)(LivePoints));

/***/ }),

/***/ "ao7Y":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/c9e6b50f9d6b580e73194f471340f0c0.svg";

/***/ }),

/***/ "bD7D":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---2uCFs {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, .7);\n  z-index: 1; }\n  .component---2uCFs h2 {\n    font-size: 20px;\n    padding-bottom: 16px;\n    margin-bottom: 16px;\n    border-bottom: 1px solid #415667;\n    font-weight: normal; }\n  .component---2uCFs .content---3-zHv {\n    text-align: center;\n    position: absolute;\n    -webkit-box-shadow: 4px 4px rgba(0, 0, 0, .2);\n            box-shadow: 4px 4px rgba(0, 0, 0, .2);\n    left: 50%;\n    top: 50%;\n    padding: 32px;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    background: #fff;\n    width: 40%;\n    max-width: 500px;\n    border-radius: 8px;\n    word-break: break-word; }\n  .component---2uCFs .actions---2HEjx {\n    text-align: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin-top: 16px; }\n  .component---2uCFs .actions---2HEjx > div {\n      margin: 0 8px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2uCFs",
	"content": "content---3-zHv",
	"actions": "actions---2HEjx"
};

/***/ }),

/***/ "bDPi":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("GC/L");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./certificates-wrapper.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./certificates-wrapper.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "bKWa":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---Du4oh {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  height: 100vh; }\n  .component---Du4oh > div {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto; }\n  .component---Du4oh h1 {\n    font-weight: normal; }\n  .component---Du4oh .main-content---2cpxq {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 100%;\n            flex: 1 1 100%;\n    overflow: hidden;\n    margin: 20px;\n    padding: 20px;\n    border-radius: 5px;\n    background-color: #fff;\n    -webkit-box-shadow: 5px 5px rgba(0, 0, 0, .07);\n            box-shadow: 5px 5px rgba(0, 0, 0, .07); }\n  @media print {\n      .component---Du4oh .main-content---2cpxq {\n        -webkit-box-shadow: none;\n                box-shadow: none; } }\n  .component---Du4oh .header-container---3x2Si {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    margin-bottom: 10px; }\n  .component---Du4oh .header-container---3x2Si .search-container---1y6rS {\n      width: 220px; }\n  .component---Du4oh .header-container---3x2Si .download-search-container---2gA-z {\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: row;\n              flex-direction: row;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      width: 400px; }\n  .component---Du4oh .header-container---3x2Si .download-search-container---2gA-z .export-button---TXNVs {\n        background: white;\n        border-radius: 28px;\n        border: 1px solid #bceafd;\n        color: #007acc;\n        font-size: 12.6px;\n        font-weight: bold;\n        letter-spacing: 0.75px;\n        margin: 0 4px; }\n  .component---Du4oh .header-container---3x2Si .download-search-container---2gA-z .export-button---TXNVs:hover {\n          border: 1px solid #99ddf6;\n          background: #dcf4fd;\n          color: #007acc; }\n  .component---Du4oh .header-container---3x2Si .download-search-container---2gA-z .export-button---TXNVs svg path {\n          fill: unset !important; }\n  .component---Du4oh .header-container---3x2Si .download-search-container---2gA-z .download-button---t5fdT {\n        background-image: linear-gradient(103.65deg, #00abe8 -2.03%, #007acc 43.7%, #0063a7 105.46%);\n        color: #fff;\n        font-size: 12.6px;\n        width: 145px;\n        height: 44px;\n        letter-spacing: 0.75px;\n        border-radius: 28px;\n        border: none;\n        margin: 0 4px; }\n  .component---Du4oh .header-container---3x2Si .download-search-container---2gA-z .download-button---t5fdT:hover {\n          background: linear-gradient(102.49deg, #007acc 0%, #014b8b 100%); }\n  .component---Du4oh .header-container---3x2Si .download-search-container---2gA-z .download-button---t5fdT div > div {\n          padding: 0 2px;\n          margin-bottom: 4px; }\n  .component---Du4oh .header-container---3x2Si .download-search-container---2gA-z .download-button---t5fdT svg {\n          width: 16.8px;\n          height: 16.8px; }\n  .component---Du4oh .header-container---3x2Si .download-search-container---2gA-z .download-button---t5fdT svg path {\n            fill: unset !important; }\n  .component---Du4oh .header-container---3x2Si .download-search-container---2gA-z .disabled---17PJI {\n        background-image: unset;\n        background-color: #edf1f4;\n        color: #5c6c7f; }\n  .component---Du4oh .header-container---3x2Si .download-search-container---2gA-z .disabled---17PJI:hover {\n          background-image: unset; }\n  .component---Du4oh .header-container---3x2Si .download-search-container---2gA-z .disabled---17PJI svg path {\n          stroke: #5c6c7f; }\n  .component---Du4oh .header-container---3x2Si .download-search-container---2gA-z .menu-popper---I-OeB {\n        position: absolute;\n        top: 52px;\n        right: 15px;\n        z-index: 1;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        width: 100px;\n        padding: 3px 0;\n        border-radius: 5px;\n        -webkit-box-shadow: 1px 1px 3px grey;\n                box-shadow: 1px 1px 3px grey;\n        background-color: white; }\n  .component---Du4oh .table-container---gxgsr {\n    height: calc(100% - 40px);\n    overflow: auto; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH table {\n      table-layout: auto;\n      color: #484848;\n      text-align: left; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH thead {\n      /*  top row is for column groups ie. Certificates */\n      /* second row is for actual column headers */ }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH thead th {\n        font-size: 12px;\n        background-color: #1a304b;\n        color: #fff; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH thead th svg path {\n          fill: #777 !important; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH thead tr:first-of-type th {\n        padding-top: 8px;\n        border-bottom: none; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH thead tr:first-of-type th > div {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH thead tr:nth-of-type(2) th {\n        padding: 16px 20px;\n        border-top: none; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH tbody.empty-data---3F8XW {\n      text-align: center; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH tbody td {\n      font-size: 13px;\n      border-left: 1px solid #e1e1e1;\n      border-bottom: 1px solid #e1e1e1;\n      padding: 8px 20px; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH tbody td:first-of-type {\n        width: 30%; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH tbody td:last-of-type {\n        border-right: 1px solid #e1e1e1; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH tbody .selected---Z5d3K {\n      color: #fff;\n      background-color: #415667; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH tbody .cursor-pointer---KDXd7 {\n      cursor: pointer; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH tfoot {\n      background-color: #415667;\n      color: #fff; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH thead .first-group---3EnKl {\n      background-color: #e7e9ea;\n      color: #415667; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH tbody tr.selected---Z5d3K {\n      color: #fff;\n      background-color: #415667; }\n  .component---Du4oh .table-container---gxgsr .data-table---1LpBH tbody td:nth-of-type(2) {\n      white-space: pre; }\n", ""]);

// exports
exports.locals = {
	"component": "component---Du4oh",
	"main-content": "main-content---2cpxq",
	"header-container": "header-container---3x2Si",
	"search-container": "search-container---1y6rS",
	"download-search-container": "download-search-container---2gA-z",
	"export-button": "export-button---TXNVs",
	"download-button": "download-button---t5fdT",
	"disabled": "disabled---17PJI",
	"menu-popper": "menu-popper---I-OeB",
	"table-container": "table-container---gxgsr",
	"data-table": "data-table---1LpBH",
	"empty-data": "empty-data---3F8XW",
	"selected": "selected---Z5d3K",
	"cursor-pointer": "cursor-pointer---KDXd7",
	"first-group": "first-group---3EnKl"
};

/***/ }),

/***/ "c7bk":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/2ccc6832176246d33114f67dd4fedd60.svg";

/***/ }),

/***/ "cEic":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp; /* eslint-disable no-unused-vars */


var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = __webpack_require__("h2Qy");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _reactRedux = __webpack_require__("4n+p");

var _redux = __webpack_require__("2KeS");

var _toast = __webpack_require__("Vnjy");

var _toast2 = _interopRequireDefault(_toast);

var _Ban = __webpack_require__("DDu0");

var _Ban2 = _interopRequireDefault(_Ban);

var _closeButton = __webpack_require__("uvI+");

var _closeButton2 = _interopRequireDefault(_closeButton);

var _toastActions = __webpack_require__("l9Tw");

var _toastActions2 = _interopRequireDefault(_toastActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toast = (_temp = _class = function (_Component) {
    _inherits(Toast, _Component);

    function Toast(props) {
        _classCallCheck(this, Toast);

        var _this = _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).call(this, props));

        _this.onClose = function () {
            _this.setState({
                toastSequence: 'close'
            });
        };

        var _props$messageData = props.messageData,
            message = _props$messageData.message,
            type = _props$messageData.type,
            hasClose = _props$messageData.hasClose;

        _this.state = {
            messageData: props.messageData,
            baseClass: 'toast',
            toastClasses: _toast2.default.toast,
            toastSequence: 'start',
            toastMessage: message,
            toastType: type,
            toastReady: false,
            hasClose: hasClose
        };
        return _this;
    }

    _createClass(Toast, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _state = this.state,
                toastSequence = _state.toastSequence,
                baseClass = _state.baseClass,
                toastType = _state.toastType;

            if (toastSequence === 'start') {
                var showToastTimer = setTimeout(function () {
                    _this2.setState({
                        toastClasses: _toast2.default[baseClass] + ' ' + _toast2.default[toastType] + ' ' + _toast2.default.show
                    });
                    clearTimeout(showToastTimer);
                    _this2.setState({
                        toastSequence: 'fade'
                    });
                }, 500);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _this3 = this;

            var _state2 = this.state,
                toastSequence = _state2.toastSequence,
                baseClass = _state2.baseClass,
                toastType = _state2.toastType;
            var clearToastData = this.props.clearToastData;


            if (toastSequence === 'fade') {
                var fadeToastTimer = setTimeout(function () {
                    _this3.setState({
                        toastClasses: _toast2.default[baseClass] + ' ' + _toast2.default[toastType] + ' ' + _toast2.default.hide
                    });
                    clearTimeout(fadeToastTimer);
                    _this3.setState({
                        toastSequence: 'remove'
                    });
                }, 3000);
            }
            if (toastSequence === 'close') {
                var _fadeToastTimer = setTimeout(function () {
                    _this3.setState({
                        toastClasses: _toast2.default[baseClass] + ' ' + _toast2.default[toastType] + ' ' + _toast2.default.hide
                    });
                    clearTimeout(_fadeToastTimer);
                    _this3.setState({
                        toastSequence: 'remove'
                    });
                }, 200);
            }
            if (toastSequence === 'remove') {
                var removeToastTimer = setTimeout(function () {
                    clearTimeout(removeToastTimer);
                    clearToastData();
                }, 3000);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state3 = this.state,
                toastClasses = _state3.toastClasses,
                toastMessage = _state3.toastMessage,
                hasClose = _state3.hasClose;


            return _react2.default.createElement(
                'div',
                { className: _toast2.default['toast-holder'] },
                _react2.default.createElement(
                    'div',
                    { className: toastClasses },
                    _react2.default.createElement(
                        'div',
                        { className: _toast2.default.message },
                        _react2.default.createElement(_reactInlinesvg2.default, { src: _Ban2.default, className: _toast2.default.icon }),
                        _react2.default.createElement(
                            'div',
                            { className: _toast2.default.text },
                            toastMessage
                        ),
                        hasClose && _react2.default.createElement(_closeButton2.default, { onClose: this.onClose, className: _toast2.default['close-button'] })
                    )
                )
            );
        }
    }]);

    return Toast;
}(_react.Component), _class.propTypes = {
    messageData: _propTypes2.default.shape({
        message: _propTypes2.default.string,
        type: _propTypes2.default.string,
        hasClose: _propTypes2.default.bool
    }),
    clearToastData: _propTypes2.default.func
}, _temp);


function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        clearToastData: _toastActions2.default.clearToastData
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(Toast);

/***/ }),

/***/ "cV31":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/71885311d0bcfa46682d5c653b9b33b0.svg";

/***/ }),

/***/ "cY7Y":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---36qYB .overlay---2nUAF {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 25, 55, .75); }\n\n.component---36qYB .container---3cnUK {\n  position: absolute;\n  left: 50%;\n  top: 30%;\n  outline: 8px solid rgba(255, 255, 255, .2);\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  background: #fff;\n  width: 100%;\n  max-width: 600px;\n  border-radius: 20px;\n  word-break: break-word; }\n\n.component---36qYB .container---3cnUK .header---3COom {\n    border-radius: 16px 16px 0 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    padding: 32px 32px 0; }\n\n.component---36qYB .container---3cnUK .certificateTypeHeader---2e_zW {\n    border-radius: 16px 16px 0 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    padding: 18px 32px;\n    background: #62d6f8; }\n\n.component---36qYB .container---3cnUK .close-button---3Xxrs {\n    position: relative;\n    top: 4px; }\n\n.component---36qYB .container---3cnUK h1 {\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 140%;\n    letter-spacing: -0.4px;\n    color: #001937; }\n\n.component---36qYB .container---3cnUK .content---2EL3W {\n    padding: 24px 32px 32px; }\n\n.component---36qYB .container---3cnUK .message---sIpyY {\n    color: #33475f;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 140%;\n    margin-bottom: 32px; }\n\n.component---36qYB .container---3cnUK .dateRange---3my0H {\n    width: 100%;\n    color: #001937;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 140%; }\n\n.component---36qYB .container---3cnUK .buttons---15ZvC {\n    text-align: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: space-evenly;\n        -ms-flex-pack: space-evenly;\n            justify-content: space-evenly; }\n\n.component---36qYB .container---3cnUK .button---1u8K_ {\n    height: 40px;\n    width: 47%;\n    max-width: 218px;\n    background-image: linear-gradient(103.65deg, #00abe8 -2.03%, #007acc 43.7%, #0063a7 105.46%);\n    color: #fff; }\n\n.component---36qYB .container---3cnUK .button---1u8K_:not(.disable---1fwSL):hover {\n      background-image: linear-gradient(102.49deg, #007acc 0%, #014b8b 100%); }\n\n.component---36qYB .container---3cnUK .button---1u8K_ .isvg {\n      height: 16px;\n      width: 16px; }\n\n.component---36qYB .container---3cnUK .button---1u8K_ svg {\n      width: 16px;\n      height: 16px; }\n\n.component---36qYB .container---3cnUK .rank-dropdown-container---3JCm0 {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 90px;\n    min-width: 80%;\n    -ms-flex-item-align: center;\n        align-self: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n        align-items: center;\n    margin-bottom: 24px;\n    padding: 20px 40px;\n    -webkit-box-shadow: rgba(0, 25, 55, .05) 0 1px 8px 0;\n            box-shadow: rgba(0, 25, 55, .05) 0 1px 8px 0;\n    border-radius: 15px;\n    font-size: 18px; }\n\n.component---36qYB .container---3cnUK .rank-dropdown-container---3JCm0:first-child {\n      display: block;\n      position: relative;\n      top: -30px;\n      width: 100%; }\n", ""]);

// exports
exports.locals = {
	"component": "component---36qYB",
	"overlay": "overlay---2nUAF",
	"container": "container---3cnUK",
	"header": "header---3COom",
	"certificateTypeHeader": "certificateTypeHeader---2e_zW",
	"close-button": "close-button---3Xxrs",
	"content": "content---2EL3W",
	"message": "message---sIpyY",
	"dateRange": "dateRange---3my0H",
	"buttons": "buttons---15ZvC",
	"button": "button---1u8K_",
	"disable": "disable---1fwSL",
	"rank-dropdown-container": "rank-dropdown-container---3JCm0"
};

/***/ }),

/***/ "cjTm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (!action) return state;

    switch (action.type) {
        case _errorsActions.ADD_ERROR:
            return _extends({}, state, _defineProperty({}, action.payload.id, action.payload.value));
        case _errorsActions.REMOVE_ERROR:
            {
                var newState = _extends({}, state);
                delete newState[action.payload.id];
                return newState;
            }
        default:
            return state;
    }
};

var _errorsActions = __webpack_require__("egHy");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {};

/**
 * Errors Reducer
 *
 * Consumes ADD_ERROR action
 * Consumes REMOVE_ERROR action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the new state
 */

/***/ }),

/***/ "dsjG":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/82f037fef9adc6a092b7c25801e46510.svg";

/***/ }),

/***/ "eKZK":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/2fddbf3b6b883bd96f85ed05cc1dc1a7.svg";

/***/ }),

/***/ "egHy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.REMOVE_ERROR = exports.ADD_ERROR = undefined;

var _reduxActions = __webpack_require__("sTbe");

var ADD_ERROR = exports.ADD_ERROR = 'ADD_ERROR';
var REMOVE_ERROR = exports.REMOVE_ERROR = 'REMOVE_ERROR';

// todo: add constants for different error types

var addError = (0, _reduxActions.createAction)(ADD_ERROR);
var removeError = (0, _reduxActions.createAction)(REMOVE_ERROR);

exports.default = {
    addError: addError,
    removeError: removeError
};

/***/ }),

/***/ "emqf":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/60e316b9b072e587bd2d17999d5e12d4.png";

/***/ }),

/***/ "ep4t":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/823870556f0ed6aef8c5d45ccb4e66cf.svg";

/***/ }),

/***/ "eqXO":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---c_-jl {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 0px;\n          flex: 1 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  padding: 16px 0;\n  border-radius: 8.649px;\n  background: #fff;\n  -webkit-box-shadow: 0 4px 5px 0 rgba(0, 102, 116, .25);\n          box-shadow: 0 4px 5px 0 rgba(0, 102, 116, .25);\n  text-align: center;\n  color: #595959;\n  margin-left: 10px; }\n  @media (min-width: 992px) {\n    .component---c_-jl {\n      padding: 24px 0; } }\n", ""]);

// exports
exports.locals = {
	"component": "component---c_-jl"
};

/***/ }),

/***/ "fBpJ":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/4cffb08fe0acf46af300e9c7c47a87b5.svg";

/***/ }),

/***/ "g5Dq":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/a0ce155c968c9ac96c51b20ed4bd3dfe.svg";

/***/ }),

/***/ "gQpM":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/8746be77d55517644e5df63cc465cc15.svg";

/***/ }),

/***/ "gaf5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---cY3Tm {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 0px;\n          flex: 1 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  padding: 16px 0;\n  border-radius: 8.649px;\n  background: #fff;\n  -webkit-box-shadow: 0 4px 5px 0 rgba(0, 102, 116, .25);\n          box-shadow: 0 4px 5px 0 rgba(0, 102, 116, .25);\n  text-align: center;\n  color: #595959;\n  margin-left: 10px; }\n  @media (min-width: 992px) {\n    .component---cY3Tm {\n      padding: 24px 0; } }\n", ""]);

// exports
exports.locals = {
	"component": "component---cY3Tm"
};

/***/ }),

/***/ "gxHR":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("GLqN");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./busy-indicator.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./busy-indicator.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "hHdG":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/5c94e107935f642337ffa5c7307ee4c7.svg";

/***/ }),

/***/ "i0Ya":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!action) return state;

    switch (action.type) {
        case _busyIndicatorActions.SHOW_BUSY:
            return state + 1;
        case _busyIndicatorActions.HIDE_BUSY:
            return state > 0 ? state - 1 : 0;
        default:
            return state;
    }
};

var _busyIndicatorActions = __webpack_require__("qS76");

var defaultState = 0;

/**
 * BusyIndicator Reducer
 *
 * Consumes HIDE_BUSY action
 * Consumes SHOW_BUSY action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type
 * @returns {number} the new state
 */

/***/ }),

/***/ "iV3T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-console */
/* global window */

var _resource = __webpack_require__("P7H2");

var _resource2 = _interopRequireDefault(_resource);

var _localResourceConfig = __webpack_require__("2z6x");

var _localResourceConfig2 = _interopRequireDefault(_localResourceConfig);

var _appConfig = __webpack_require__("N5/L");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BasicResources = function () {
    function BasicResources() {
        _classCallCheck(this, BasicResources);
    }

    _createClass(BasicResources, null, [{
        key: 'initialise',
        value: function initialise(envName, credentials) {
            var env = (0, _resource2.default)({
                name: envName,
                application: _appConfig.appName,
                // eslint-disable-next-line no-underscore-dangle
                config: window._env_
            });
            var location = window.location;
            var runningOnDeveloperMachine = /^https?:\/\/localhost/.test(location);

            if (runningOnDeveloperMachine) {
                if (envName === 'local') {
                    // This implies we'll be hitting the mock REST server,
                    // which does not require authentication.

                    env.bypassAuthentication();
                    env.setConfiguration(_localResourceConfig2.default);
                } else if (credentials.authToken) {
                    env.authToken = credentials.authToken;
                } else {
                    env.setCredentials(credentials.username, credentials.password);
                }
            } else if (credentials.authToken) {
                env.authToken = credentials.authToken;
            } else if (credentials.username && credentials.password) {
                env.username = credentials.username;
                env.password = credentials.password;
            } else {
                // The caller should have provided a valid set of credentials, so
                // hopefully this will never happen.

                console.log('BasicResources.initialise() - to execute, we need either an authToken or' + ' a username/password pair.  The credentials object that was provided does not' + ' contain either.  So, expect things to fail badly :-(.');
            }

            return env;
        }
    }]);

    return BasicResources;
}();

exports.default = BasicResources;

/***/ }),

/***/ "ixbo":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/a690978a344ca5b92167477bf5bb2027.svg";

/***/ }),

/***/ "jLtQ":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/52c8c981eac4f08825938bc2d8d929bc.svg";

/***/ }),

/***/ "jbqH":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/0b8922995dc031f3d524c75cde057f3d.svg";

/***/ }),

/***/ "jgMC":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".popup-menu---3p3-7 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  top: 170px;\n  right: 150px;\n  text-align: left;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 250px;\n  height: 48px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  z-index: 1;\n  border-radius: 16px;\n  background: #fff;\n  -webkit-box-shadow: 0 10px 10px -5px rgba(0, 0, 0, .04), 0 20px 25px -5px rgba(0, 0, 0, .1);\n          box-shadow: 0 10px 10px -5px rgba(0, 0, 0, .04), 0 20px 25px -5px rgba(0, 0, 0, .1);\n  border: 1px solid #edf1f4; }\n  .popup-menu---3p3-7 .popup-menu-item---2v85b {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    color: #001937;\n    text-align: justify;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    height: 100%;\n    width: 100%;\n    padding: 12px 24px;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    border: none;\n    background: white;\n    border-radius: 16px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    /**\n            &:first-child {\n                border-bottom: 1px solid $colour-grey03;\n                border-radius: 16px 16px 0 0;\n            }\n\n            &:last-child {\n                border-radius: 0 0 16px 16px;\n            }\n        */ }\n  .popup-menu---3p3-7 .popup-menu-item---2v85b:hover {\n      color: #007acc;\n      cursor: pointer; }\n  .popupDisabled---2w68- {\n  background: #edf1f4 !important;\n  width: 100% !important;\n  color: #5c6c7f !important; }\n  .moveLeft---317Ps {\n  top: 170px;\n  right: 350px !important; }\n  .popupMenuSingleItem---2EQE- {\n  height: 48px !important;\n  width: 250px !important; }\n  .popupMenuSingleItem---2EQE- .popupMenuItemSingleItem---3h8kY {\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    border-radius: 16px !important;\n    border-bottom: none !important; }\n", ""]);

// exports
exports.locals = {
	"popup-menu": "popup-menu---3p3-7",
	"popup-menu-item": "popup-menu-item---2v85b",
	"popupDisabled": "popupDisabled---2w68-",
	"moveLeft": "moveLeft---317Ps",
	"popupMenuSingleItem": "popupMenuSingleItem---2EQE-",
	"popupMenuItemSingleItem": "popupMenuItemSingleItem---3h8kY"
};

/***/ }),

/***/ "jq2L":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".date-picker-wrapper---1Jy4H {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 16px; }\n\n.DateRangePicker_picker {\n  position: absolute;\n  top: 34px !important;\n  right: 0 !important; }\n\n.DayPicker {\n  border: 1px solid #d6d6d6 !important;\n  -webkit-box-shadow: 3px 3px rgba(72, 72, 72, .5) !important;\n          box-shadow: 3px 3px rgba(72, 72, 72, .5) !important;\n  font-family: poppins, Arial, sans-serif !important;\n  color: #4e5c67 !important;\n  background-color: #fff;\n  border-radius: 3px; }\n\n.DateRangePickerInput {\n  border-color: #a2bdd3 !important;\n  border-top-left-radius: 3px !important;\n  border-bottom-left-radius: 3px !important;\n  height: inherit !important; }\n\n.DateInput {\n  width: 85px !important;\n  margin: 4px 15px 3px 8px !important; }\n\n.DateInput_input {\n  font-size: 14px !important;\n  font-family: poppins, Arial, sans-serif !important;\n  line-height: normal;\n  padding: 5px 0 !important;\n  text-align: center !important;\n  -webkit-box-sizing: border-box !important;\n          box-sizing: border-box !important;\n  border: 0 !important; }\n\n.DateInput_input__focused {\n  border: 1px solid #1981c4 !important; }\n\n.DateInput_fang {\n  display: none !important; }\n\n.CalendarMonth,\n.CalendarMonthGrid {\n  background-color: #fff; }\n\n.DayPickerNavigation_button__default {\n  background-color: #fff !important;\n  color: #4e5c67 !important;\n  border-color: #d6d6d6 !important; }\n\n.DayPickerNavigation_button__default svg path {\n    fill: currentColor !important; }\n\n.DayPickerNavigation_button__default:hover {\n    border-color: #4e5c67 !important; }\n\n.CalendarMonth_caption,\n.DayPicker_weekHeader {\n  color: #4e5c67 !important; }\n\n.CalendarDay {\n  -webkit-box-sizing: border-box !important;\n          box-sizing: border-box !important;\n  border: 1px solid #e7e9ea !important;\n  vertical-align: middle;\n  color: #757575; }\n\n.CalendarDay:not(.CalendarDay__blocked_out_of_range):not(.CalendarDay__selected) {\n    background-color: #cfd2d4 !important;\n    color: inherit !important; }\n\n.CalendarDay:not(.CalendarDay__blocked_out_of_range):not(.CalendarDay__selected):hover {\n      background-color: #999b9d !important;\n      color: #fff !important; }\n\n.CalendarDay__selected.CalendarDay__today {\n  background: none !important;\n  color: #757575 !important;\n  text-decoration: underline !important; }\n\n.CalendarDay__blocked_out_of_range,\n.CalendarDay__blocked_out_of_range:active,\n.CalendarDay__blocked_out_of_range:focus,\n.CalendarDay__blocked_out_of_range:hover {\n  color: #cacccd !important;\n  outline: 0;\n  border-color: #e7e9ea !important; }\n\n.CalendarDay__selected,\n.CalendarDay__selected:hover,\n.CalendarDay__selected:focus,\n.CalendarDay__selected.CalendarDay__blocked_out_of_range {\n  background: #4e5c67;\n  color: #fff;\n  outline: none; }\n\n.CalendarDay__selected_span,\n.CalendarDay__selected_span:hover,\n.CalendarDay__selected_span.CalendarDay__blocked_out_of_range {\n  background: #dae5ed;\n  color: #fff;\n  text-decoration: none; }\n\n.CalendarDay__selected_start,\n.CalendarDay__selected_end {\n  background: #4e5c67 !important;\n  color: #fff !important;\n  text-decoration: none; }\n\n.CalendarDay__hovered_span,\n.CalendarDay__hovered_span:hover,\n.CalendarDay__hovered_span.CalendarDay__blocked_out_of_range {\n  background-color: #dae5ed !important;\n  color: #4e5c67 !important; }\n\n.CalendarDay__selected_span:not(.CalendarDay__blocked_out_of_range:hover) {\n  background-color: #1981c4 !important;\n  color: #fff !important; }\n", ""]);

// exports
exports.locals = {
	"date-picker-wrapper": "date-picker-wrapper---1Jy4H"
};

/***/ }),

/***/ "k1kO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("4n+p");

var _button = __webpack_require__("rAoZ");

var _button2 = _interopRequireDefault(_button);

var _downloadIcon = __webpack_require__("vGvd");

var _downloadIcon2 = _interopRequireDefault(_downloadIcon);

var _certificatesWrapper = __webpack_require__("bDPi");

var _certificatesWrapper2 = _interopRequireDefault(_certificatesWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CertificatesWrapper = function CertificatesWrapper(props) {
    var children = props.children,
        heading = props.heading,
        onDownload = props.onDownload,
        downloadDisabled = props.downloadDisabled,
        downloadText = props.downloadText,
        _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        templateType = props.templateType,
        downloadCertificatesState = props.downloadCertificatesState;
    var isActive = downloadCertificatesState.isActive,
        downloadType = downloadCertificatesState.downloadType;

    var hasSpinner = isActive && templateType === downloadType;
    return _react2.default.createElement(
        'div',
        { className: _certificatesWrapper2.default['certificates-wrapper'] },
        _react2.default.createElement(
            'div',
            { className: _certificatesWrapper2.default.header },
            _react2.default.createElement(
                'div',
                { className: _certificatesWrapper2.default.heading },
                _react2.default.createElement(
                    'span',
                    null,
                    heading
                )
            ),
            _react2.default.createElement(_button2.default, {
                className: _certificatesWrapper2.default['download-button'] + ' ' + (downloadDisabled ? _certificatesWrapper2.default.disabled : ''),
                text: downloadText,
                type: _button2.default.LOZENGE,
                size: _button2.default.LARGE,
                icon: hasSpinner ? '' : _downloadIcon2.default,
                alignIcon: _button2.default.RIGHT,
                hasSpinner: hasSpinner,
                btnType: templateType,
                disabled: downloadDisabled,
                onClick: onDownload
            })
        ),
        _react2.default.createElement(
            'div',
            { className: _certificatesWrapper2.default.certificates + ' ' + className },
            children
        )
    );
};

CertificatesWrapper.propTypes = {
    children: _propTypes2.default.node,
    heading: _propTypes2.default.string,
    onDownload: _propTypes2.default.func,
    downloadDisabled: _propTypes2.default.bool,
    downloadText: _propTypes2.default.string,
    className: _propTypes2.default.string,
    templateType: _propTypes2.default.string,
    downloadCertificatesState: _propTypes2.default.object
};

function mapStateToProps(state) {
    return { downloadCertificatesState: state.downloadCertificatesState };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CertificatesWrapper);

/***/ }),

/***/ "k6Km":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (!action) return state;

    switch (action.type) {
        case _academicYearActions.ACADEMIC_YEAR_RETRIEVED:
            return action.payload;

        default:
            return state;
    }
};

var _academicYearActions = __webpack_require__("nRKh");

var initialState = {
    startDate: null,
    endDate: null,
    year: null
};

/**
 * AcademicYear Reducer
 *
 * Consumes ACADEMIC_YEAR_RETRIEVED action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - current start and end dates of academic year
 */

/***/ }),

/***/ "l4i3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ParticipationReport = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactRedux = __webpack_require__("4n+p");

var _redux = __webpack_require__("2KeS");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dayjs = __webpack_require__("oqQY");

var _dayjs2 = _interopRequireDefault(_dayjs);

var _Mathletics = __webpack_require__("+cV+");

var _Mathletics2 = _interopRequireDefault(_Mathletics);

var _reactInlinesvg = __webpack_require__("h2Qy");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _lodash = __webpack_require__("M4fF");

var _participationReport = __webpack_require__("sNQ+");

var _participationReport2 = _interopRequireDefault(_participationReport);

var _urlHelper = __webpack_require__("uOny");

var _urlHelper2 = _interopRequireDefault(_urlHelper);

var _participationReportActions = __webpack_require__("Ci4y");

var _participationReportActions2 = _interopRequireDefault(_participationReportActions);

var _modalActions = __webpack_require__("P039");

var _modalActions2 = _interopRequireDefault(_modalActions);

var _utils = __webpack_require__("6QRH");

var _participationReportConstants = __webpack_require__("HsVg");

var _certificates = __webpack_require__("rrgl");

var _certificates2 = _interopRequireDefault(_certificates);

var _livePoints = __webpack_require__("akZC");

var _livePoints2 = _interopRequireDefault(_livePoints);

var _loginInfo = __webpack_require__("Hy9S");

var _loginInfo2 = _interopRequireDefault(_loginInfo);

var _reportTable = __webpack_require__("++Ft");

var _reportTable2 = _interopRequireDefault(_reportTable);

var _localeActions = __webpack_require__("rrpD");

var _localeActions2 = _interopRequireDefault(_localeActions);

var _localeUtils = __webpack_require__("MGx+");

var _rankTiles = __webpack_require__("lAta");

var _rankTiles2 = _interopRequireDefault(_rankTiles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * ParticipationReport Redux component
 * Receives properties via 'props'
 * Displays a participation report for a student
 */
var ParticipationReport = exports.ParticipationReport = (_temp = _class = function (_Component) {
    _inherits(ParticipationReport, _Component);

    function ParticipationReport(props) {
        _classCallCheck(this, ParticipationReport);

        var _this = _possibleConstructorReturn(this, (ParticipationReport.__proto__ || Object.getPrototypeOf(ParticipationReport)).call(this, props));

        _this.setTablesConfig = function () {
            var tableConfigActivities = (0, _lodash.cloneDeep)(_participationReportConstants.ACTIVITIES_TABLE_CONFIG);
            var tableConfigLiveMaths = (0, _lodash.cloneDeep)(_participationReportConstants.LIVE_MATHS_TABLE_CONFIG);
            var tableConfigSkillQuest = (0, _lodash.cloneDeep)(_participationReportConstants.SKILL_QUEST_TABLE_CONFIG);
            var tableConfigNewCourses = (0, _lodash.cloneDeep)(_participationReportConstants.NEW_COURSES_TABLE_CONFIG);
            var tableConfigChallenges = (0, _lodash.cloneDeep)(_participationReportConstants.CHALLENGES_TABLE_CONFIG);
            var localeData = _this.props.localeData;

            (0, _localeUtils.translateTableLabels)(tableConfigActivities, localeData);
            (0, _localeUtils.translateTableLabels)(tableConfigLiveMaths, localeData);
            (0, _localeUtils.translateTableLabels)(tableConfigSkillQuest, localeData);
            (0, _localeUtils.translateTableLabels)(tableConfigNewCourses, localeData);
            (0, _localeUtils.translateTableLabels)(tableConfigChallenges, localeData);
            _this.setState({
                tableConfigActivities: tableConfigActivities,
                tableConfigLiveMaths: tableConfigLiveMaths,
                tableConfigSkillQuest: tableConfigSkillQuest,
                tableConfigNewCourses: tableConfigNewCourses,
                tableConfigChallenges: tableConfigChallenges
            });
        };

        _this.displayError = function (error) {
            var localeData = _this.props.localeData;

            _this.props.openModal({
                title: localeData['Modal - Oops'],
                content: _react2.default.createElement(
                    'p',
                    null,
                    error
                ),
                buttons: [{ title: localeData['Modal - TryAgain'], primary: true }]
            });
        };

        _this.state = {
            activitiesFooterData: {}, // each course will add a new entry into object, using the course name as the key
            newCoursesFooterData: {},
            skillQuestFooterData: {},
            challengesFooterData: null,
            liveMathsFooterData: null,
            tableConfigActivities: {},
            tableConfigLiveMaths: {},
            tableConfigSkillQuest: {},
            tableConfigNewCourses: {},
            tableConfigChallenges: {},
            studentName: '',
            formattedStartDate: '',
            formattedEndDate: '',
            academicYear: '',
            locale: ''
        };

        // this page gets a lot of its data from query paramaters as it is opened in a new tab
        var queryParams = ['studentName', 'profileId', 'productId', 'schoolId', 'classroomId', 'startDate', 'endDate', 'academicYear', 'locale'];
        queryParams.forEach(function (paramName) {
            _this.state[paramName] = _urlHelper2.default.getQueryParamValue(paramName);
        });
        /**
         * SET LOCALE
         */
        var localeCode = (0, _localeUtils.locale)() || 'en-AU';
        // eslint-disable-next-line global-require,import/no-dynamic-require
        __webpack_require__("273U")("./" + localeCode.toLowerCase());
        _dayjs2.default.locale(localeCode);
        _this.state.formattedStartDate = (0, _utils.formatDate)(_this.state.startDate);
        _this.state.formattedEndDate = (0, _utils.formatDate)(_this.state.endDate);
        return _this;
    }

    _createClass(ParticipationReport, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _state = this.state,
                profileId = _state.profileId,
                productId = _state.productId,
                schoolId = _state.schoolId,
                classroomId = _state.classroomId,
                startDate = _state.startDate,
                endDate = _state.endDate,
                academicYear = _state.academicYear;

            var localeCode = (0, _localeUtils.locale)() || 'en-AU';
            var setTranslationData = this.props.setTranslationData;

            this.props.getParticipationReport({
                productId: productId, profileId: profileId, schoolId: schoolId, classroomId: classroomId, startDate: startDate, endDate: endDate, academicYear: academicYear, locale: localeCode
            }).then(function (action) {
                if (action.type !== _participationReportActions.PARTICIPATION_REPORT_RETRIEVED) {
                    _this2.displayError(action.error);
                }
            }, function (error) {
                return _this2.displayError(error.message);
            });
            setTranslationData();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.participationReport) {
                var _nextProps$participat = nextProps.participationReport,
                    courseResult = _nextProps$participat.courseResult,
                    liveMathsResult = _nextProps$participat.liveMathsResult,
                    questCourseResult = _nextProps$participat.questCourseResult,
                    newCoursesResult = _nextProps$participat.newCoursesResult,
                    challengesResult = _nextProps$participat.challengesResult;


                this.generateFooterData({
                    courseResult: courseResult,
                    liveMathsResult: liveMathsResult,
                    questCourseResult: questCourseResult,
                    newCoursesResult: newCoursesResult,
                    challengesResult: challengesResult
                });
                this.setTablesConfig();
            }
        }
    }, {
        key: 'generateFooterData',
        value: function generateFooterData(_ref) {
            var courseResult = _ref.courseResult,
                liveMathsResult = _ref.liveMathsResult,
                questCourseResult = _ref.questCourseResult,
                newCoursesResult = _ref.newCoursesResult,
                challengesResult = _ref.challengesResult;

            var skillQuestFooterData = {};
            questCourseResult.forEach(function (course) {
                var averageAccuracy = course.averageAccuracy;

                skillQuestFooterData[course.courseName] = { averageAccuracy: averageAccuracy };
            });
            var activitiesFooterData = {};
            courseResult.courses.forEach(function (course) {
                var averageResult = course.averageResult,
                    totalPoints = course.totalPoints;

                activitiesFooterData[course.courseName] = { averageResult: averageResult, totalPoints: totalPoints };
            });
            var maxLiveMathsLevels = liveMathsResult.maxLiveMathsLevels,
                averageCorrect = liveMathsResult.averageCorrect,
                totalPoints = liveMathsResult.totalPoints;

            var newCoursesFooterData = {};
            newCoursesResult.forEach(function (course) {
                var averageResult = course.averageResult,
                    totalCurriculumPoints = course.totalPoints;

                newCoursesFooterData[course.courseName] = { averageResult: averageResult, totalPoints: totalCurriculumPoints };
            });
            var averageResult = challengesResult.averageResult,
                totalChallengesPoints = challengesResult.totalPoints;


            this.setState({
                activitiesFooterData: activitiesFooterData,
                liveMathsFooterData: {
                    maxLiveMathsLevels: maxLiveMathsLevels, averageCorrect: averageCorrect, totalPoints: totalPoints
                },
                skillQuestFooterData: skillQuestFooterData,
                newCoursesFooterData: newCoursesFooterData,
                challengesFooterData: {
                    averageResult: averageResult, totalChallengesPoints: totalChallengesPoints
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state2 = this.state,
                studentName = _state2.studentName,
                formattedStartDate = _state2.formattedStartDate,
                formattedEndDate = _state2.formattedEndDate,
                activitiesFooterData = _state2.activitiesFooterData,
                liveMathsFooterData = _state2.liveMathsFooterData,
                skillQuestFooterData = _state2.skillQuestFooterData,
                newCoursesFooterData = _state2.newCoursesFooterData,
                challengesFooterData = _state2.challengesFooterData,
                tableConfigActivities = _state2.tableConfigActivities,
                tableConfigLiveMaths = _state2.tableConfigLiveMaths,
                tableConfigSkillQuest = _state2.tableConfigSkillQuest,
                tableConfigNewCourses = _state2.tableConfigNewCourses,
                tableConfigChallenges = _state2.tableConfigChallenges;
            var _props = this.props,
                participationReport = _props.participationReport,
                localeData = _props.localeData;

            if (!participationReport) {
                return _react2.default.createElement('div', null);
            }
            var newCertificateSummary = participationReport.newCertificateSummary,
                pastCertificateSummary = participationReport.pastCertificateSummary,
                participationInfo = participationReport.participationInfo,
                logInInfo = participationReport.logInInfo,
                liveMathsInfo = participationReport.liveMathsResult.liveMathsInfo,
                courseResult = participationReport.courseResult,
                questCourseResult = participationReport.questCourseResult,
                newCoursesResult = participationReport.newCoursesResult,
                challenges = participationReport.challengesResult.challenges;


            var skillQuestHeaderPrefix = localeData['TableHeader - SkillQuests'];
            var activitiesHeaderPrefix = localeData['TableHeader - Activities'];
            var newCoursesHeaderPrefix = localeData['TableHeader - NewCourses'];
            var challengesHeaderPrefix = localeData['TableHeader - Challenges'];

            return _react2.default.createElement(
                'div',
                { className: _participationReport2.default.component },
                _react2.default.createElement(
                    'div',
                    { className: _participationReport2.default.header },
                    _react2.default.createElement(
                        'div',
                        { className: _participationReport2.default.logo },
                        _react2.default.createElement(_reactInlinesvg2.default, { src: _Mathletics2.default })
                    ),
                    _react2.default.createElement(
                        'h1',
                        null,
                        localeData['Header - ClassDetails']
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _participationReport2.default['selection-info'] },
                    _react2.default.createElement(
                        'h2',
                        { className: _participationReport2.default['student-name'] },
                        studentName
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _participationReport2.default['selected-date'] },
                        formattedStartDate + ' - ' + formattedEndDate
                    )
                ),
                participationReport && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: _participationReport2.default.section },
                        _react2.default.createElement(
                            'div',
                            { className: _participationReport2.default.heading },
                            localeData['Label - NewCertificates']
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _participationReport2.default['new-certificate-info'] },
                            _react2.default.createElement(_rankTiles2.default, { newCertificateSummary: newCertificateSummary })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _participationReport2.default.info },
                            localeData[_participationReportConstants.WEEKLY_POINTS]
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _participationReport2.default['student-certificate-info'] },
                        _react2.default.createElement(_certificates2.default, { pastCertificateSummary: pastCertificateSummary }),
                        _react2.default.createElement(_livePoints2.default, { participationInfo: participationInfo, courseResult: courseResult }),
                        _react2.default.createElement(_loginInfo2.default, { logInInfo: logInInfo })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _participationReport2.default['weekly-points-info'] },
                        localeData[_participationReportConstants.WEEKLY_POINTS_INFO]
                    ),
                    courseResult.courses.map(function (course) {
                        return _react2.default.createElement(
                            'div',
                            { className: _participationReport2.default.activities, key: course.courseName },
                            _react2.default.createElement(_reportTable2.default, {
                                heading: activitiesHeaderPrefix + ': ' + course.courseName,
                                subHeading: localeData[_participationReportConstants.ACTIVITIES_POINTS_INFO],
                                tableConfig: tableConfigActivities,
                                tableData: course.allActivities,
                                tableFooterData: activitiesFooterData[course.courseName]
                            })
                        );
                    }),
                    newCoursesResult[0] && newCoursesResult.map(function (result) {
                        return _react2.default.createElement(
                            'div',
                            { className: _participationReport2.default['new-courses'], key: result.courseName },
                            _react2.default.createElement(_reportTable2.default, {
                                heading: newCoursesHeaderPrefix + ': ' + result.courseName,
                                subHeading: localeData[_participationReportConstants.NEW_COURSES_POINTS_INFO],
                                tableConfig: tableConfigNewCourses,
                                tableData: result.courseResults,
                                tableFooterData: newCoursesFooterData[result.courseName]
                            })
                        );
                    }),
                    challenges.length > 0 && _react2.default.createElement(
                        'div',
                        { className: _participationReport2.default.challenges },
                        _react2.default.createElement(_reportTable2.default, {
                            heading: challengesHeaderPrefix,
                            subHeading: localeData[_participationReportConstants.CHALLENGES_POINTS_INFO],
                            tableConfig: tableConfigChallenges,
                            tableData: challenges,
                            tableFooterData: challengesFooterData
                        })
                    ),
                    questCourseResult.map(function (result) {
                        return _react2.default.createElement(
                            'div',
                            { className: _participationReport2.default['skill-quest'], key: result.courseName },
                            _react2.default.createElement(_reportTable2.default, {
                                heading: skillQuestHeaderPrefix + ': ' + result.courseName,
                                subHeading: localeData[_participationReportConstants.SKILL_QUEST_POINTS_INFO],
                                tableConfig: tableConfigSkillQuest,
                                tableData: result.allActivities,
                                tableFooterData: skillQuestFooterData[result.courseName]
                            })
                        );
                    }),
                    liveMathsInfo.length > 0 && _react2.default.createElement(
                        'div',
                        { className: _participationReport2.default['live-maths'] },
                        _react2.default.createElement(_reportTable2.default, {
                            heading: localeData[_participationReportConstants.LIVE_MATHS_HEADER],
                            subHeading: localeData[_participationReportConstants.LIVE_MATHS_INFO],
                            tableConfig: tableConfigLiveMaths,
                            tableData: liveMathsInfo,
                            tableFooterData: liveMathsFooterData
                        })
                    )
                )
            );
        }
    }]);

    return ParticipationReport;
}(_react.Component), _class.propTypes = {
    participationReport: _propTypes2.default.object,
    getParticipationReport: _propTypes2.default.func,
    localeData: _propTypes2.default.object,
    setTranslationData: _propTypes2.default.func,
    openModal: _propTypes2.default.func
}, _temp);

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from ParticipationReportCombinedReducers.
 */

function mapStateToProps(state) {
    return {
        participationReport: state.participationReport,
        localeData: state.localeData
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getParticipationReport: _participationReportActions2.default.getParticipationReport,
        setTranslationData: _localeActions2.default.setTranslationData,
        openModal: _modalActions2.default.openModal
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable2.default)(_participationReport2.default)(ParticipationReport));

/***/ }),

/***/ "l9Tw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SHOW_TOAST_MESSAGE = exports.SHOW_TOAST_MESSAGE = 'SHOW_TOAST_MESSAGE';
var CLEAR_TOAST_DATA = exports.CLEAR_TOAST_DATA = 'CLEAR_TOAST_DATA';

var showToastMessage = function showToastMessage(messageData) {
    return {
        type: SHOW_TOAST_MESSAGE,
        payload: messageData
    };
};

var clearToastData = function clearToastData() {
    return {
        type: CLEAR_TOAST_DATA
    };
};

exports.default = {
    showToastMessage: showToastMessage,
    clearToastData: clearToastData
};

/***/ }),

/***/ "lAta":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _rankTiles = __webpack_require__("7L7O");

var _rankTiles2 = _interopRequireDefault(_rankTiles);

var _tile = __webpack_require__("QXFs");

var _tile2 = _interopRequireDefault(_tile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RankTiles = function RankTiles(data) {
    var rankList = Object.entries(data.newCertificateSummary);
    var tiles = rankList.map(function (rank) {
        var key = rank[0];
        var value = rank[1];
        return _react2.default.createElement(
            'div',
            { key: key },
            _react2.default.createElement(_tile2.default, { total: value, rank: key })
        );
    });

    return _react2.default.createElement(
        'div',
        { className: _rankTiles2.default['rank-tiles'] },
        tiles
    );
};

RankTiles.propType = {
    newCertificateSummary: _propTypes2.default.object
};

exports.default = (0, _reactStyleable2.default)(_rankTiles2.default)(RankTiles);

/***/ }),

/***/ "mEYJ":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/100dd29cd5c4078cae9f5c2f978c1be8.svg";

/***/ }),

/***/ "n+MJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!action) return state;

    switch (action.type) {
        case _schoolIdActions.SET_SCHOOL_ID:
            return action.payload;

        default:
            return state;
    }
};

var _schoolIdActions = __webpack_require__("zs5o");

var defaultState = null;

/**
 * School ID Reducer
 *
 * Consumes SET_SCHOOL_ID action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {number} - the school id
 */

/***/ }),

/***/ "n/tl":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/02e99f8cbc9069e1cd1727ca1a243b70.svg";

/***/ }),

/***/ "nIya":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Tj2k");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js?modules=false!../node_modules/postcss-loader/lib/index.js!../node_modules/sass-loader/index.js!./core.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js?modules=false!../node_modules/postcss-loader/lib/index.js!../node_modules/sass-loader/index.js!./core.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "nOMl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = __webpack_require__("h2Qy");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _iconMessage = __webpack_require__("NVqf");

var _iconMessage2 = _interopRequireDefault(_iconMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * IconMessage pro-forma template for stateless component
 * Displays icon in grey circle with message underneath
 */
var IconMessage = function IconMessage(_ref) {
    var iconSrc = _ref.iconSrc,
        message = _ref.message;
    return _react2.default.createElement(
        'div',
        { className: _iconMessage2.default.component },
        _react2.default.createElement(
            'div',
            { className: _iconMessage2.default['icon-container'] },
            _react2.default.createElement(_reactInlinesvg2.default, { src: iconSrc, cacheGetRequests: true })
        ),
        _react2.default.createElement(
            'p',
            null,
            message
        )
    );
};

IconMessage.propTypes = {
    iconSrc: _propTypes2.default.string,
    message: _propTypes2.default.string
};

exports.default = (0, _reactStyleable2.default)(_iconMessage2.default)(IconMessage);

/***/ }),

/***/ "nRKh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ACADEMIC_YEAR_RETRIEVED = undefined;

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _resourceHandlers = __webpack_require__("Qbfx");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACADEMIC_YEAR_RETRIEVED = exports.ACADEMIC_YEAR_RETRIEVED = 'ACADEMIC_YEAR_RETRIEVED';

function getAcademicYear() {
    return function (dispatch) {
        return _resources2.default.academicYear.get().send().then(function (payload) {
            return (0, _resourceHandlers.handleResourceSuccess)(dispatch, payload, {
                type: ACADEMIC_YEAR_RETRIEVED,
                payload: payload.data
            });
        }, function (error) {
            return (0, _resourceHandlers.handleResourceError)(dispatch, error);
        });
    };
}

exports.default = {
    getAcademicYear: getAcademicYear
};

/***/ }),

/***/ "o+QR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var START_DATE = exports.START_DATE = 'startDate';
var END_DATE = exports.END_DATE = 'endDate';

/***/ }),

/***/ "o5aZ":
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "o5aZ";

/***/ }),

/***/ "oEFU":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---2AQ8o {\n  display: block;\n  padding: 16px 4px;\n  color: #595959; }\n  @media (min-width: 992px) {\n    .component---2AQ8o {\n      padding: 16px 8px; } }\n  .component---2AQ8o .count---2Z9se {\n    font-size: 24px; }\n  @media (min-width: 992px) {\n      .component---2AQ8o .count---2Z9se {\n        font-size: 30px; } }\n  .component---2AQ8o .title---2hbe3 {\n    font-size: 16px; }\n  @media (min-width: 992px) {\n      .component---2AQ8o .title---2hbe3 {\n        font-size: 18px; } }\n  .component---2AQ8o .icon---EQY6K {\n    text-align: center; }\n  .component---2AQ8o .icon---EQY6K img {\n      width: 60px;\n      height: 60px; }\n  @media (min-width: 992px) {\n        .component---2AQ8o .icon---EQY6K img {\n          width: 75px;\n          height: 75px; } }\n", ""]);

// exports
exports.locals = {
	"component": "component---2AQ8o",
	"count": "count---2Z9se",
	"title": "title---2hbe3",
	"icon": "icon---EQY6K"
};

/***/ }),

/***/ "oV0N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CertificatesTypes = exports.PastCertificatesTypes = exports.Certificates = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _lodash = __webpack_require__("M4fF");

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _reactRedux = __webpack_require__("4n+p");

var _redux = __webpack_require__("2KeS");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactComponents = __webpack_require__("fmgT");

var _certificates = __webpack_require__("XAH4");

var _certificates2 = _interopRequireDefault(_certificates);

var _modalActions = __webpack_require__("P039");

var _modalActions2 = _interopRequireDefault(_modalActions);

var _studentCertificatesActions = __webpack_require__("SCGg");

var _studentCertificatesActions2 = _interopRequireDefault(_studentCertificatesActions);

var _backendConstantsContract = __webpack_require__("vmQ6");

var _certificateTemplate = __webpack_require__("7rey");

var _certificateTemplate2 = _interopRequireDefault(_certificateTemplate);

var _certificateTemplateConstants = __webpack_require__("P2FU");

var _certificatesConstants = __webpack_require__("J7W8");

var _downloadConstants = __webpack_require__("XrKD");

var _datePickerActions = __webpack_require__("qFO3");

var _datePickerActions2 = _interopRequireDefault(_datePickerActions);

var _downloadCertificatesActions = __webpack_require__("EzKo");

var _downloadCertificatesActions2 = _interopRequireDefault(_downloadCertificatesActions);

var _datePicker = __webpack_require__("9PoH");

var _datePickerConstants = __webpack_require__("p2pT");

var _certificatesWrapper = __webpack_require__("k1kO");

var _certificatesWrapper2 = _interopRequireDefault(_certificatesWrapper);

var _downloadIcon = __webpack_require__("vGvd");

var _downloadIcon2 = _interopRequireDefault(_downloadIcon);

var _utils = __webpack_require__("6QRH");

var _studentCertificatesGemCountActions = __webpack_require__("WElh");

var _studentCertificatesGemCountActions2 = _interopRequireDefault(_studentCertificatesGemCountActions);

var _generateCertificateFilename = __webpack_require__("5F4+");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Certificates Redux component
 * Receives properties via 'props'
 * Displays certificates page for a student (or all students) with totals for each type of
 * certificate (gold, silver, bronze) and option to download them by type or all in one
 */
var Certificates = exports.Certificates = (_temp = _class = function (_Component) {
    _inherits(Certificates, _Component);

    function Certificates(props) {
        var _this2 = this;

        _classCallCheck(this, Certificates);

        var _this = _possibleConstructorReturn(this, (Certificates.__proto__ || Object.getPrototypeOf(Certificates)).call(this, props));

        _this.selectOption = function (option) {
            _this.setState({ selectedOption: _extends({}, option) }, function () {
                _this.setCertificateCounts(_this.props.studentCertificates);
            });
        };

        _this.displayError = function (error) {
            var localeData = _this.props.localeData;

            _this.props.openModal({
                title: localeData['Modal - Oops'],
                content: _react2.default.createElement(
                    'p',
                    null,
                    error
                ),
                buttons: [{ title: localeData['Modal - TryAgain'], primary: true }]
            });
        };

        _this.downloadPastCertificatesByType = function (_ref) {
            var certificateType = _ref.certificateType,
                downloadType = _ref.downloadType;
            var _this$props = _this.props,
                productId = _this$props.productId,
                selectedClassroom = _this$props.selectedClassroom,
                selectedDateRange = _this$props.selectedDateRange,
                downloadPastCertsByType = _this$props.downloadPastCertsByType;
            var selectedOption = _this.state.selectedOption;


            downloadPastCertsByType({
                certificateType: certificateType,
                paramData: {
                    userProfileId: selectedOption.value,
                    productId: productId,
                    classroomId: selectedClassroom.id,
                    classroomName: selectedClassroom.class,
                    startDate: selectedDateRange.startDate,
                    endDate: selectedDateRange.endDate,
                    studentName: _this.getStudentName()
                },
                downloadType: downloadType
            });
        };

        _this.downloadAllPastCertificates = function () {
            var _this$props2 = _this.props,
                productId = _this$props2.productId,
                selectedClassroom = _this$props2.selectedClassroom,
                selectedDateRange = _this$props2.selectedDateRange,
                downloadAllPastCerts = _this$props2.downloadAllPastCerts;
            var selectedOption = _this.state.selectedOption;


            downloadAllPastCerts({
                userProfileId: selectedOption.value,
                productId: productId,
                classroomId: selectedClassroom.id,
                startDate: selectedDateRange.startDate,
                endDate: selectedDateRange.endDate,
                classroomName: selectedClassroom.class,
                studentName: _this.getStudentName(),
                downloadType: _downloadConstants.ALL_PAST
            });
        };

        _this.certificateTypeName = function (certificateRank) {
            var localeData = _this.props.localeData;

            switch (certificateRank) {
                case 1:
                    return localeData['Label - Bronze'];
                case 2:
                    return localeData['Label - Silver'];
                case 3:
                    return localeData['Label - Gold'];
                case 4:
                    return localeData['Label - Platinum'];
                case 5:
                    return localeData['Label - Emerald'];
                case 6:
                    return localeData['Label - Diamond'];
                case 7:
                    return localeData['Label - Epic'];
                case 8:
                    return localeData['Label - Legend'];
                default:
                    return '';
            }
        };

        _this.showPrintTypeModal = function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
                var content = _ref3.content,
                    total = _ref3.total,
                    _ref3$certificateRank = _ref3.certificateRank,
                    certificateRank = _ref3$certificateRank === undefined ? null : _ref3$certificateRank,
                    isDownloadCertificateType = _ref3.isDownloadCertificateType;

                var _this$props3, selectedDateRange, selectedClassroom, localeData, selectedOption, certificateType, studentCertificatesGemCount, selectedGems, result, label, certificatesCount;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this$props3 = _this.props, selectedDateRange = _this$props3.selectedDateRange, selectedClassroom = _this$props3.selectedClassroom, localeData = _this$props3.localeData;
                                selectedOption = _this.state.selectedOption;
                                certificateType = _this.certificateTypeName(certificateRank);
                                _context.next = 5;
                                return _this.getStudentCertificatesGemCount(selectedDateRange.startDate, selectedDateRange.endDate, selectedOption.value, certificateRank);

                            case 5:
                                studentCertificatesGemCount = _this.props.studentCertificatesGemCount;
                                selectedGems = studentCertificatesGemCount.retrievedGems.map(function () {
                                    return true;
                                }).map(function (_, selectedIndex) {
                                    return selectedIndex;
                                }).filter(function (selectedIndex) {
                                    return selectedIndex !== -1;
                                });
                                result = selectedGems.map(function (gemType) {
                                    return 'gemTypes: ' + (gemType + 1);
                                }).join(', ');

                                _this.props.downloadCertificatesByGem({
                                    payload: {
                                        selectedGems: { result: result, resultCount: total }
                                    }
                                });
                                label = selectedClassroom.class + ' | ' + selectedOption.label;
                                certificatesCount = (0, _lodash.isArray)(studentCertificatesGemCount.retrievedGems) ? studentCertificatesGemCount.retrievedGems.reduce(function (acc, item) {
                                    return acc + item.count;
                                }, 0) : null;


                                _this.props.openModal({
                                    title: total + ' ' + (total === 1 ? localeData['Label - Certificate'] : localeData['Label - Certificates']),
                                    content: content,
                                    label: label,
                                    dateRange: selectedDateRange.type,
                                    certificatesCount: certificatesCount,
                                    retrievedGems: studentCertificatesGemCount.retrievedGems,
                                    certificateType: certificateType,
                                    isDownloadCertificateType: isDownloadCertificateType,
                                    buttons: [{
                                        title: '' + localeData['Label - FullColour'],
                                        primary: true,
                                        icon: _downloadIcon2.default,
                                        btnType: _downloadConstants.FULL_COLOR,
                                        handler: function handler() {
                                            return _this.downloadNewCertificates({
                                                downloadType: _downloadConstants.FULL_COLOR,
                                                certificateRank: certificateRank
                                            });
                                        },
                                        disabled: certificatesCount === 0
                                    }, {
                                        title: '' + localeData['Label - PrintFriendly'],
                                        primary: true,
                                        icon: _downloadIcon2.default,
                                        btnType: _downloadConstants.PRINT_FRIENDLY,
                                        handler: function handler() {
                                            return _this.downloadNewCertificates({
                                                downloadType: _downloadConstants.PRINT_FRIENDLY,
                                                certificateRank: certificateRank
                                            });
                                        },
                                        disabled: certificatesCount === 0
                                    }],
                                    useNewModal: true
                                });

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref2.apply(this, arguments);
            };
        }();

        _this.downloadNewCertificates = function (_ref4) {
            var downloadType = _ref4.downloadType,
                certificateRank = _ref4.certificateRank;
            var _this$props4 = _this.props,
                productId = _this$props4.productId,
                selectedClassroom = _this$props4.selectedClassroom,
                selectedDateRange = _this$props4.selectedDateRange,
                downloadAllNewCerts = _this$props4.downloadAllNewCerts,
                studentCertificates = _this$props4.studentCertificates,
                downloadNewCertsByType = _this$props4.downloadNewCertsByType;
            var _this$state = _this.state,
                selectedOption = _this$state.selectedOption,
                gemsSelected = _this$state.gemsSelected;

            var userId = selectedOption.value === _certificatesConstants.ALL_STUDENTS ? null : studentCertificates.studentList.find(function (student) {
                return student.id === selectedOption.value;
            }).userId;
            var userProfileId = selectedOption.value;
            var dataObj = {
                userProfileId: userProfileId,
                productId: productId,
                classroomId: selectedClassroom.id,
                startDate: selectedDateRange.startDate,
                endDate: selectedDateRange.endDate,
                userId: userId,
                downloadType: downloadType,
                classroomName: selectedClassroom.class,
                studentName: _this.getStudentName(),
                fullColor: downloadType === _downloadConstants.FULL_COLOR,
                gemTypes: gemsSelected
            };
            var isAllNewCerts = (0, _utils.isUndefined)(certificateRank);
            var isClassLevel = userProfileId === _certificatesConstants.ALL_STUDENTS;
            if (isAllNewCerts) {
                dataObj.isClassLevel = isClassLevel;
                downloadAllNewCerts(dataObj);
            } else {
                dataObj.certificateRank = certificateRank;
                downloadNewCertsByType(dataObj);
            }
        };

        _this.onBackClick = function () {
            var history = _this.context.router.history;

            history.goBack();
        };

        _this.getStudentName = function () {
            var selectedOption = _this.state.selectedOption;
            var studentCertificates = _this.props.studentCertificates;


            if (selectedOption.value === _certificatesConstants.ALL_STUDENTS) {
                return null;
            }
            var studentName = studentCertificates.studentList.find(function (student) {
                return student.id === selectedOption.value;
            });
            return studentName.firstName + '_' + studentName.lastName;
        };

        _this.state = {
            studentList: [],
            selectedOption: null,
            templates: {
                certificates: [],
                pastCertificates: []
            },
            studentTotalNewCertificates: null,
            studentTotalPastCertificates: null,
            options: _datePickerConstants.DEFAULT_DATE_OPTIONS_OBJ,
            gemsSelected: null
        };
        return _this;
    }

    _createClass(Certificates, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var history = this.context.router.history;
            var _props = this.props,
                selectedDateRange = _props.selectedDateRange,
                selectedClassroom = _props.selectedClassroom,
                selectedStudent = _props.selectedStudent;


            if (!selectedClassroom || !selectedDateRange.startDate) {
                history.push('/home');
            } else {
                this.setSelectedOption(selectedStudent);
                this.getStudentCertificates(selectedDateRange.startDate, selectedDateRange.endDate);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            var _props2 = this.props,
                selectedStudent = _props2.selectedStudent,
                studentCertificates = _props2.studentCertificates,
                selectedDateRange = _props2.selectedDateRange,
                studentCertificatesGemCount = _props2.studentCertificatesGemCount;
            var newSelectedStudent = newProps.selectedStudent,
                newStudentCertificates = newProps.studentCertificates,
                newSelectedDateRange = newProps.selectedDateRange,
                newStudentCertificatesGemCount = newProps.studentCertificatesGemCount;


            if (studentCertificates !== newStudentCertificates) {
                this.setCertificateCounts(newStudentCertificates);
                this.setStudentList(newStudentCertificates.studentList);
            }
            if (newSelectedStudent !== selectedStudent) {
                this.setSelectedOption(newSelectedStudent);
            }
            if (selectedDateRange !== newSelectedDateRange) {
                this.getStudentCertificates(newSelectedDateRange.startDate, newSelectedDateRange.endDate);
            }

            if (studentCertificatesGemCount.selectedGems !== newStudentCertificatesGemCount.selectedGems) {
                this.setState({ gemsSelected: newStudentCertificatesGemCount.selectedGems.result });
            }
        }
    }, {
        key: 'getStudentCertificates',
        value: function getStudentCertificates(startDate, endDate) {
            var _this3 = this;

            var _props3 = this.props,
                selectedClassroom = _props3.selectedClassroom,
                getStudentCertificates = _props3.getStudentCertificates;


            getStudentCertificates({
                classroomId: selectedClassroom.id,
                startDate: startDate,
                endDate: endDate,
                productId: _backendConstantsContract.MATHLETICS_PRODUCT_ID
            }).then(function (action) {
                if (action.type !== _studentCertificatesActions.STUDENT_CERTIFICATES_RETRIEVED) {
                    _this3.displayError(action.error);
                }
            }, function (error) {
                return _this3.displayError(error);
            });
        }
    }, {
        key: 'getStudentCertificatesGemCount',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(startDate, endDate, selectedStudent, certificateRank) {
                var _this4 = this;

                var _props4, selectedClassroom, getStudentCertificatesGemCount;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _props4 = this.props, selectedClassroom = _props4.selectedClassroom, getStudentCertificatesGemCount = _props4.getStudentCertificatesGemCount;
                                _context2.next = 3;
                                return getStudentCertificatesGemCount({
                                    classroomId: selectedClassroom.id,
                                    startDate: (0, _generateCertificateFilename.formatDateForGemCount)(startDate),
                                    endDate: (0, _generateCertificateFilename.formatDateForGemCount)(endDate),
                                    groupId: 0,
                                    studentUserProfileId: selectedStudent,
                                    certificateType: certificateRank
                                }).then(function (action) {
                                    if (action.type !== _studentCertificatesGemCountActions.STUDENT_CERTIFICATES_GEM_COUNT_RETRIEVED) {
                                        _this4.displayError(action.error);
                                    }
                                }, function (error) {
                                    return _this4.displayError(error);
                                });

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getStudentCertificatesGemCount(_x2, _x3, _x4, _x5) {
                return _ref5.apply(this, arguments);
            }

            return getStudentCertificatesGemCount;
        }()
    }, {
        key: 'setStudentList',
        value: function setStudentList(studentList) {
            var localeData = this.props.localeData;

            this.setState({
                studentList: [{ label: localeData['Label - AllStudents'], value: _certificatesConstants.ALL_STUDENTS }].concat(_toConsumableArray(studentList.map(function (student) {
                    return { label: student.firstName + ' ' + student.lastName, value: student.id };
                })))
            });
        }
    }, {
        key: 'setSelectedOption',
        value: function setSelectedOption(selectedStudent) {
            this.setState({
                selectedOption: {
                    label: selectedStudent.student, value: selectedStudent.id
                }
            });
        }
    }, {
        key: 'setCertificateCounts',
        value: function setCertificateCounts(studentCertificates) {
            var selectedOption = this.state.selectedOption;

            var selectedCertificateInfo = void 0;
            var isAllStudents = selectedOption.value === _certificatesConstants.ALL_STUDENTS;
            if (isAllStudents) {
                selectedCertificateInfo = studentCertificates.allStudents;
            } else {
                selectedCertificateInfo = studentCertificates.studentList.find(function (student) {
                    return student.id === selectedOption.value;
                });
            }
            var localeData = this.props.localeData;

            if (!selectedCertificateInfo) {
                this.setState({ templates: { certificates: [], pastCertificates: [] } });
                this.displayError(localeData['Empty - StudentCertificate'] + ' (' + selectedOption.label + ')');
            } else {
                this.setState({
                    templates: {
                        certificates: [{
                            type: _certificatesConstants.BRONZE_CERT_TYPE,
                            total: selectedCertificateInfo.certificates.bronze,
                            label: localeData['Label - Bronze'],
                            isAllStudents: isAllStudents
                        }, {
                            type: _certificatesConstants.SILVER_CERT_TYPE,
                            total: selectedCertificateInfo.certificates.silver,
                            label: localeData['Label - Silver'],
                            isAllStudents: isAllStudents
                        }, {
                            type: _certificatesConstants.GOLD_CERT_TYPE,
                            total: selectedCertificateInfo.certificates.gold,
                            label: localeData['Label - Gold'],
                            isAllStudents: isAllStudents
                        }, {
                            type: _certificatesConstants.PLATINUM_CERT_TYPE,
                            total: selectedCertificateInfo.certificates.platinum,
                            label: localeData['Label - Platinum'],
                            isAllStudents: isAllStudents
                        }, {
                            type: _certificatesConstants.EMERALD_CERT_TYPE,
                            total: selectedCertificateInfo.certificates.emerald,
                            label: localeData['Label - Emerald'],
                            isAllStudents: isAllStudents
                        }, {
                            type: _certificatesConstants.DIAMOND_CERT_TYPE,
                            total: selectedCertificateInfo.certificates.diamond,
                            label: localeData['Label - Diamond'],
                            isAllStudents: isAllStudents
                        }, {
                            type: _certificatesConstants.EPIC_CERT_TYPE,
                            total: selectedCertificateInfo.certificates.epic,
                            label: localeData['Label - Epic'],
                            isAllStudents: isAllStudents
                        }, {
                            type: _certificatesConstants.LEGEND_CERT_TYPE,
                            total: selectedCertificateInfo.certificates.legend,
                            label: localeData['Label - Legend'],
                            isAllStudents: isAllStudents
                        }],
                        pastCertificates: [{
                            type: _certificatesConstants.BRONZE_CERT_TYPE_PAST,
                            total: selectedCertificateInfo.pastCertificates.bronze,
                            label: localeData['Label - Bronze']
                        }, {
                            type: _certificatesConstants.SILVER_CERT_TYPE_PAST,
                            total: selectedCertificateInfo.pastCertificates.silver,
                            label: localeData['Label - Silver']
                        }, {
                            type: _certificatesConstants.GOLD_CERT_TYPE_PAST,
                            total: selectedCertificateInfo.pastCertificates.gold,
                            label: localeData['Label - Gold']
                        }]
                    },
                    studentTotalNewCertificates: selectedCertificateInfo.certificates.total,
                    studentTotalPastCertificates: selectedCertificateInfo.pastCertificates.total
                });
            }
        }

        /**
         * Downloads pdf certificates for a particular type (gold, silver, bronze)
         * Either for the current student or all students, depending on the selection in student name dropdown
         */


        /**
         * Downloads pdf Past Certificates for all types (gold, silver, bronze) in one file
         * Either for the current student or all students, depending on the selection in student name dropdown
         */

    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _props5 = this.props,
                selectedClassroom = _props5.selectedClassroom,
                studentCertificates = _props5.studentCertificates,
                selectedDateRange = _props5.selectedDateRange,
                academicYear = _props5.academicYear,
                updateSelectedDateRange = _props5.updateSelectedDateRange,
                localeData = _props5.localeData;
            var _state = this.state,
                templates = _state.templates,
                studentList = _state.studentList,
                selectedOption = _state.selectedOption,
                studentTotalNewCertificates = _state.studentTotalNewCertificates,
                studentTotalPastCertificates = _state.studentTotalPastCertificates;


            if (!selectedClassroom || !studentList || !selectedOption) {
                return null;
            }

            var certificateLabel = localeData['Label - Certificates'].toLowerCase();
            return _react2.default.createElement(
                'div',
                { className: _certificates2.default.component },
                _react2.default.createElement(_reactComponents.Header, { title: localeData['Header - ClassDetails'] }),
                _react2.default.createElement(
                    'div',
                    { className: _certificates2.default['main-content'] },
                    _react2.default.createElement(
                        'div',
                        { className: _certificates2.default.header },
                        _react2.default.createElement(
                            'h2',
                            null,
                            selectedClassroom.class,
                            ' ',
                            certificateLabel
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _certificates2.default['sub-header'] },
                            _react2.default.createElement(
                                'div',
                                { className: _certificates2.default['filter-container'] },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'student-filter' },
                                    _react2.default.createElement(_reactComponents.DropdownMenu, {
                                        className: _certificates2.default['student-dropdown'],
                                        options: studentList,
                                        selectedOption: selectedOption,
                                        onSelectOption: this.selectOption
                                    })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: _certificates2.default['date-filter'] },
                                    _react2.default.createElement(_datePicker.DatePicker, {
                                        currentDate: selectedDateRange,
                                        academicYear: academicYear,
                                        onDateChange: updateSelectedDateRange,
                                        localeData: localeData,
                                        isLeft: true
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _certificates2.default['class-total'] },
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    localeData['Label - Total'] + ': ',
                                    studentTotalNewCertificates + studentTotalPastCertificates
                                )
                            )
                        )
                    ),
                    templates.certificates.length > 0 && _react2.default.createElement(
                        _certificatesWrapper2.default,
                        {
                            heading: localeData['Label - NewCertificates'],
                            onDownload: function onDownload() {
                                _this5.showPrintTypeModal({
                                    content: '' + localeData['PrintModal - SelectVersion'],
                                    total: studentTotalNewCertificates,
                                    isDownloadCertificateType: false
                                });
                            },
                            downloadDisabled: studentTotalNewCertificates === 0,
                            downloadText: localeData['Label - DownloadAll'],
                            templateType: _downloadConstants.ALL_NEW
                        },
                        templates.certificates.map(function (template) {
                            return _react2.default.createElement(_certificateTemplate2.default, {
                                key: template.type,
                                template: template,
                                schoolType: studentCertificates.schoolType,
                                onDownload: function onDownload() {
                                    return _this5.showPrintTypeModal({
                                        content: '' + localeData['PrintModal - SelectRankVersion'],
                                        total: template.total,
                                        certificateRank: _certificatesConstants.CERT_VALUES[template.type],
                                        isDownloadCertificateType: true
                                    });
                                }
                            });
                        })
                    ),
                    templates.pastCertificates.length > 0 && _react2.default.createElement(
                        _certificatesWrapper2.default,
                        {
                            heading: localeData['Label - PastCertificates'],
                            onDownload: this.downloadAllPastCertificates,
                            downloadDisabled: studentTotalPastCertificates === 0,
                            downloadText: localeData['Label - DownloadAll'],
                            templateType: _downloadConstants.ALL_PAST
                        },
                        templates.pastCertificates.map(function (template) {
                            return _react2.default.createElement(_certificateTemplate2.default, {
                                key: template.type,
                                template: template,
                                schoolType: studentCertificates.schoolType,
                                onDownload: function onDownload() {
                                    return _this5.downloadPastCertificatesByType({
                                        certificateType: _certificatesConstants.CERT_VALUES[template.type],
                                        downloadType: template.type
                                    });
                                }
                            });
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactComponents.Footer,
                    null,
                    _react2.default.createElement(_reactComponents.Button, {
                        text: localeData['Label - Back'],
                        type: _reactComponents.Button.LOZENGE,
                        size: _reactComponents.Button.LARGE,
                        primary: true,
                        onClick: this.onBackClick
                    })
                )
            );
        }
    }]);

    return Certificates;
}(_react.Component), _class.contextTypes = {
    router: _propTypes2.default.object
}, _temp);
var PastCertificatesTypes = exports.PastCertificatesTypes = _propTypes2.default.shape({
    gold: _propTypes2.default.number,
    silver: _propTypes2.default.number,
    bronze: _propTypes2.default.number,
    goldBars: _propTypes2.default.number,
    total: _propTypes2.default.number
});

var CertificatesTypes = exports.CertificatesTypes = _propTypes2.default.shape({
    bronze: _propTypes2.default.number,
    silver: _propTypes2.default.number,
    gold: _propTypes2.default.number,
    platinum: _propTypes2.default.number,
    emerald: _propTypes2.default.number,
    diamond: _propTypes2.default.number,
    epic: _propTypes2.default.number,
    legend: _propTypes2.default.number,
    total: _propTypes2.default.number
});

Certificates.propTypes = {
    studentCertificates: _propTypes2.default.shape({
        schoolType: _propTypes2.default.oneOf([_certificateTemplateConstants.PRIMARY, _certificateTemplateConstants.SECONDARY]),
        allStudents: _propTypes2.default.shape({
            total: _propTypes2.default.number,
            pastCertificates: PastCertificatesTypes,
            certificates: CertificatesTypes
        }),
        studentList: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            id: _propTypes2.default.number,
            firstName: _propTypes2.default.string,
            lastName: _propTypes2.default.string,
            pastCertificates: PastCertificatesTypes,
            certificates: CertificatesTypes
        }))
    }),
    selectedDateRange: _propTypes2.default.shape({
        type: _propTypes2.default.string,
        startDate: _propTypes2.default.string,
        endDate: _propTypes2.default.string
    }),
    academicYear: _propTypes2.default.shape({
        startDate: _propTypes2.default.string,
        endDate: _propTypes2.default.string
    }),
    selectedStudent: _propTypes2.default.shape({
        id: _propTypes2.default.number,
        student: _propTypes2.default.string
    }),
    selectedClassroom: _propTypes2.default.shape({
        id: _propTypes2.default.number,
        class: _propTypes2.default.string
    }),
    productId: _propTypes2.default.string,
    getStudentCertificates: _propTypes2.default.func,
    getStudentCertificatesGemCount: _propTypes2.default.func,
    downloadCertificatesByGem: _propTypes2.default.func,
    downloadAllNewCerts: _propTypes2.default.func,
    downloadNewCertsByType: _propTypes2.default.func,
    downloadPastCertsByType: _propTypes2.default.func,
    downloadAllPastCerts: _propTypes2.default.func,
    openModal: _propTypes2.default.func,
    updateSelectedDateRange: _propTypes2.default.func,
    localeData: _propTypes2.default.object,
    studentCertificatesGemCount: _propTypes2.default.shape({
        retrievedGems: _propTypes2.default.array,
        selectedGems: _propTypes2.default.object
    })
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CertificatesCombinedReducers.
 */
function mapStateToProps(state) {
    return {
        localeData: state.localeData,
        selectedDateRange: state.selectedDateRange,
        selectedClassroom: state.selectedClass,
        productId: state.productId,
        selectedStudent: state.selectedStudent,
        studentCertificates: state.studentCertificates,
        studentCertificatesGemCount: state.studentCertificatesGemCount,
        academicYear: state.academicYear
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        openModal: _modalActions2.default.openModal,
        getStudentCertificates: _studentCertificatesActions2.default.getStudentCertificates,
        getStudentCertificatesGemCount: _studentCertificatesGemCountActions2.default.getStudentCertificatesGemCount,
        downloadCertificatesByGem: _studentCertificatesGemCountActions2.default.downloadCertificatesByGem,
        updateSelectedDateRange: _datePickerActions2.default.updateSelectedDateRange,
        downloadAllPastCerts: _downloadCertificatesActions2.default.downloadAllPastCerts,
        downloadPastCertsByType: _downloadCertificatesActions2.default.downloadPastCertsByType,
        downloadAllNewCerts: _downloadCertificatesActions2.default.downloadAllNewCerts,
        downloadNewCertsByType: _downloadCertificatesActions2.default.downloadNewCertsByType
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable2.default)(_certificates2.default)(Certificates));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "on1x":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/c36aff78e159151c8c7e7ae306064e0e.svg";

/***/ }),

/***/ "p2pT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var THIS_WEEK = exports.THIS_WEEK = 'This week';
var LAST_WEEK = exports.LAST_WEEK = 'Last week';
var THIS_SCHOOL_YEAR = exports.THIS_SCHOOL_YEAR = 'This school year';
var CUSTOM_DATE = exports.CUSTOM_DATE = 'Custom date';
var CUSTOM_DATE_TIME = exports.CUSTOM_DATE_TIME = 'Date and Time';
var LIFETIME = exports.LIFETIME = 'Lifetime';

var THIS_WEEK_OBJ = exports.THIS_WEEK_OBJ = {
    label: THIS_WEEK,
    value: THIS_WEEK
};

var LAST_WEEK_OBJ = exports.LAST_WEEK_OBJ = {
    label: LAST_WEEK,
    value: LAST_WEEK
};
var THIS_SCHOOL_YEAR_OBJ = exports.THIS_SCHOOL_YEAR_OBJ = {
    label: THIS_SCHOOL_YEAR,
    value: THIS_SCHOOL_YEAR
};
var CUSTOM_DATE_OBJ = exports.CUSTOM_DATE_OBJ = {
    label: CUSTOM_DATE,
    value: CUSTOM_DATE
};

var CUSTOM_DATE_TIME_OBJ = exports.CUSTOM_DATE_TIME_OBJ = {
    label: CUSTOM_DATE_TIME,
    value: CUSTOM_DATE_TIME
};

var LIFETIME_OBJ = exports.LIFETIME_OBJ = {
    label: LIFETIME,
    value: LIFETIME
};

var DEFAULT_DATE_OPTIONS_OBJ = exports.DEFAULT_DATE_OPTIONS_OBJ = [THIS_WEEK_OBJ, LAST_WEEK_OBJ, THIS_SCHOOL_YEAR_OBJ, CUSTOM_DATE_OBJ];

var DEFAULT_DATE_OPTIONS = exports.DEFAULT_DATE_OPTIONS = [THIS_WEEK, LAST_WEEK, THIS_SCHOOL_YEAR, CUSTOM_DATE];
var DATE_OPTIONS = exports.DATE_OPTIONS = [].concat(DEFAULT_DATE_OPTIONS, [CUSTOM_DATE_TIME, LIFETIME]);

/***/ }),

/***/ "p6pg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!action) return state;

    switch (action.type) {
        case _selectedClassActions.SELECT_CLASS:
            return action.payload;
        default:
            return state;
    }
};

var _selectedClassActions = __webpack_require__("7wS1");

var defaultState = null;

/**
 * Selected Class Reducer
 *
 * Consumes SELECT_CLASS action
 *
 * @param {array} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {Selected Class Object} - current selected class object
 */

/***/ }),

/***/ "pIOt":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/d688e56d1d42ff6090a8fde2ab053e50.svg";

/***/ }),

/***/ "pJ47":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/d1042ec0721c96f365236de2b75e49a8.png";

/***/ }),

/***/ "pc5E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (!action) return state;

    switch (action.type) {
        case _modalActions.OPEN_MODAL:
            return _extends({}, state, {
                modalData: [].concat(_toConsumableArray(state.modalData), [{
                    id: state.modalData.length,
                    title: action.payload.title,
                    content: action.payload.content,
                    buttons: action.payload.buttons,
                    label: action.payload.label,
                    dateRange: action.payload.dateRange,
                    certificateType: action.payload.certificateType,
                    isDownloadCertificateType: action.payload.isDownloadCertificateType,
                    certificatesCount: action.payload.certificatesCount,
                    retrievedGems: action.payload.retrievedGems
                }]),
                useNewModal: action.payload.useNewModal || false
            });

        case _modalActions.CLOSE_MODAL:
            return defaultState;

        default:
            return state;
    }
};

var _modalActions = __webpack_require__("P039");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var defaultState = exports.defaultState = {
    modalData: [],
    useNewModal: false
};

/**
 * Modal Reducer
 *
 * Consumes OPEN_MODAL action
 * Consumes CLOSE_MODAL action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - current list of modals to display
 */

/***/ }),

/***/ "plXt":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/119aad80b53e89a46fabdeab669cea3d.png";

/***/ }),

/***/ "pxdW":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/908d56ed296646a03e814f80db74bd77.svg";

/***/ }),

/***/ "qC0W":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/f0c0c4f3f902644844186ea5c79378e1.svg";

/***/ }),

/***/ "qFO3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var UPDATE_SELECTED_DATE_RANGE = exports.UPDATE_SELECTED_DATE_RANGE = 'UPDATE_SELECTED_DATE_RANGE';

function updateSelectedDateRange(type, startDate, endDate) {
    return {
        type: UPDATE_SELECTED_DATE_RANGE,
        payload: {
            type: type,
            startDate: startDate,
            endDate: endDate
        }
    };
}

exports.default = {
    updateSelectedDateRange: updateSelectedDateRange
};

/***/ }),

/***/ "qS76":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HIDE_BUSY = exports.SHOW_BUSY = undefined;

var _mathleticsPortalCommunicationService = __webpack_require__("UTT2");

var _mathleticsPortalCommunicationService2 = _interopRequireDefault(_mathleticsPortalCommunicationService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_BUSY = exports.SHOW_BUSY = 'SHOW_BUSY';
var HIDE_BUSY = exports.HIDE_BUSY = 'HIDE_BUSY';

function showBusy() {
    return function (dispatch) {
        _mathleticsPortalCommunicationService2.default.requestLoadingSpinner(true);
        dispatch({ type: SHOW_BUSY });
    };
}

function hideBusy() {
    return function (dispatch) {
        _mathleticsPortalCommunicationService2.default.requestLoadingSpinner(false);
        dispatch({ type: HIDE_BUSY });
    };
}

exports.default = {
    showBusy: showBusy,
    hideBusy: hideBusy
};

/***/ }),

/***/ "qfeG":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/f3ee0081a94d508a5c5e08069c1b5de3.svg";

/***/ }),

/***/ "r30a":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".rank-tiles---1FXBR {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n  .rank-tiles---1FXBR .tile---3NhZg {\n    width: 114px;\n    height: 164px;\n    border-radius: 15px;\n    border: 1px solid #4dc4ef;\n    background: #fff;\n    -webkit-box-shadow: 0 4px 5px 0 rgba(0, 102, 116, .25);\n            box-shadow: 0 4px 5px 0 rgba(0, 102, 116, .25);\n    margin: 4px; }\n  .rank-tiles---1FXBR .tile---3NhZg.no-certificates---2kJK1 {\n      width: 76px;\n      height: 107px;\n      -webkit-box-shadow: none;\n              box-shadow: none;\n      border: 1px solid #cbd3dc; }\n  .rank-tiles---1FXBR .tile---3NhZg.no-certificates---2kJK1 .content---1o0Dp .rank-icon---3Izpn {\n        width: 70px;\n        height: 42px; }\n  .rank-tiles---1FXBR .tile---3NhZg.no-certificates---2kJK1 .content---1o0Dp .rank-icon---3Izpn svg {\n          width: 100%;\n          height: 100%; }\n  .rank-tiles---1FXBR .tile---3NhZg.no-certificates---2kJK1 .content---1o0Dp .rank---1u3bP {\n        font-size: 12px;\n        font-weight: 400; }\n  .rank-tiles---1FXBR .tile---3NhZg.no-certificates---2kJK1 .content---1o0Dp .total---19taz {\n        border-radius: 22px;\n        background: #f4f8fa; }\n  .rank-tiles---1FXBR .tile---3NhZg .content---1o0Dp {\n      margin: 12px 8px;\n      width: calc(100% - 16px);\n      height: calc(100% - 24px);\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between; }\n  .rank-tiles---1FXBR .tile---3NhZg .content---1o0Dp .rank-icon---3Izpn {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        width: 100px;\n        height: 70px; }\n  .rank-tiles---1FXBR .tile---3NhZg .content---1o0Dp .rank---1u3bP {\n        color: #33475f;\n        text-align: center;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal; }\n  .rank-tiles---1FXBR .tile---3NhZg .content---1o0Dp .total---19taz {\n        border-radius: 22px;\n        background: #bceafd;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        width: 44px;\n        height: 24px;\n        color: #33475f;\n        font-size: 10px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 14.545px; }\n", ""]);

// exports
exports.locals = {
	"rank-tiles": "rank-tiles---1FXBR",
	"tile": "tile---3NhZg",
	"no-certificates": "no-certificates---2kJK1",
	"content": "content---1o0Dp",
	"rank-icon": "rank-icon---3Izpn",
	"rank": "rank---1u3bP",
	"total": "total---19taz"
};

/***/ }),

/***/ "rAoZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = __webpack_require__("h2Qy");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _spinner = __webpack_require__("cV31");

var _spinner2 = _interopRequireDefault(_spinner);

var _styled = __webpack_require__("GQck");

var _constants = __webpack_require__("rbvv");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Button component
 * Supports different styles through setting primary, danger & info props
 */
var CustomButton = function CustomButton(props) {
    var text = props.text,
        icon = props.icon,
        _onClick = props.onClick,
        disabled = props.disabled,
        className = props.className,
        type = props.type,
        size = props.size,
        alignIcon = props.alignIcon,
        hasSpinner = props.hasSpinner;


    var styleProps = {};
    ['primary', 'danger', 'info', 'disabled', 'inverse'].forEach(function (style) {
        if (props[style]) {
            styleProps[style] = true;
        }
    });

    var buttonState = _constants.TEXT_ONLY;
    if (icon && text) {
        buttonState = _constants.ICON_AND_TEXT;
    } else if (icon) {
        buttonState = _constants.ICON_ONLY;
    }

    function renderIcon(iconType) {
        return _react2.default.createElement(
            _styled.Icon,
            {
                buttonState: buttonState,
                size: size,
                alignIcon: alignIcon,
                hasSpinner: hasSpinner,
                key: 1
            },
            _react2.default.createElement(_reactInlinesvg2.default, { src: iconType, cacheRequests: false })
        );
    }

    function getContent() {
        if (!icon) {
            return text;
        }
        if (alignIcon === _constants.RIGHT) {
            return [text, renderIcon(icon)];
        }
        return [renderIcon(icon), text];
    }

    return _react2.default.createElement(
        _styled.ButtonWrapper,
        _extends({}, styleProps, {
            buttonState: buttonState,
            type: type,
            size: size,
            disabled: hasSpinner || disabled,
            hasSpinner: hasSpinner,
            className: className,
            role: 'button',
            tabIndex: '0',
            onClick: function onClick() {
                if (!disabled) {
                    _onClick();
                }
            }
        }),
        hasSpinner && _react2.default.createElement(
            _styled.Content,
            { hasSpinner: true },
            renderIcon(_spinner2.default)
        ),
        !hasSpinner && _react2.default.createElement(
            _styled.Content,
            null,
            getContent()
        )
    );
};

CustomButton.SQUARE = _constants.SQUARE;
CustomButton.LOZENGE = _constants.LOZENGE;
CustomButton.SMALL = _constants.SMALL;
CustomButton.MEDIUM = _constants.MEDIUM;
CustomButton.LARGE = _constants.LARGE;
CustomButton.LEFT = _constants.LEFT;
CustomButton.RIGHT = _constants.RIGHT;

CustomButton.propTypes = {
    /** Text to display inside of button (can be combined with icon) */
    text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    /** SVG icon to display inside of button (can be combined with text) */
    icon: _propTypes2.default.string,
    /** If use both icon and text aligns icon to side of text */
    alignIcon: _propTypes2.default.oneOf([CustomButton.LEFT, CustomButton.RIGHT]),
    /** Callback when button is clicked */
    onClick: _propTypes2.default.func.isRequired,
    /** Button cannot be clicked, and displays with an alpha and a not-allowed cursor */
    disabled: _propTypes2.default.bool,
    /** Type of button this is, quick way to apply styles */
    type: _propTypes2.default.oneOf([CustomButton.SQUARE, CustomButton.LOZENGE]),
    /** Size of button */
    size: _propTypes2.default.oneOf([CustomButton.SMALL, CustomButton.MEDIUM, CustomButton.LARGE]),
    /** Custom class to attach to parent div - use this to override any styles */
    className: _propTypes2.default.string,
    /** hasSpinner * */
    hasSpinner: _propTypes2.default.bool
};

CustomButton.defaultProps = {
    type: CustomButton.SQUARE,
    size: CustomButton.MEDIUM,
    alignIcon: CustomButton.LEFT,
    primary: false,
    danger: false,
    info: false,
    disabled: false,
    inverse: false,
    hasSpinner: false
};

exports.default = CustomButton;

/***/ }),

/***/ "rbvv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ICON_AND_TEXT = exports.ICON_AND_TEXT = 'ICON_AND_TEXT';
var TEXT_ONLY = exports.TEXT_ONLY = 'TEXT_ONLY';
var ICON_ONLY = exports.ICON_ONLY = 'ICON_ONLY';

var SQUARE = exports.SQUARE = 'SQUARE';
var LOZENGE = exports.LOZENGE = 'LOZENGE';

var SMALL = exports.SMALL = 'SMALL';
var MEDIUM = exports.MEDIUM = 'MEDIUM';
var LARGE = exports.LARGE = 'LARGE';

var LEFT = exports.LEFT = 'LEFT';
var RIGHT = exports.RIGHT = 'RIGHT';

/***/ }),

/***/ "rnUz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _palette = __webpack_require__("Flem");

var _palette2 = _interopRequireDefault(_palette);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var typography = {
  family: 'poppins, Arial, sans-serif',
  size: '14px',
  lineHeight: '18px',
  weightLight: 400,
  weightNormal: 500,
  weightBold: 600,
  colour: _palette2.default.primary.dark
};

typography.title = {
  size: '30px',
  weight: typography.weightBold,
  colour: typography.colour
};

typography.subtitle = {
  size: '16px',
  weight: typography.weightNormal,
  colour: _palette2.default.primary.main
};

typography.heading = {
  size: '25px',
  weight: typography.weightBold
};

typography.modalTitle = {
  size: '20px',
  weight: typography.weightNormal
};

typography.info = {
  size: '13px',
  weight: typography.weightNormal
};

exports.default = typography;

/***/ }),

/***/ "rrgl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("4n+p");

var _reactInlinesvg = __webpack_require__("h2Qy");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

__webpack_require__("nIya");

var _certificates = __webpack_require__("wAWk");

var _certificates2 = _interopRequireDefault(_certificates);

var _certificateCount = __webpack_require__("6BEW");

var _certificateCount2 = _interopRequireDefault(_certificateCount);

var _goldBar = __webpack_require__("2atI");

var _goldBar2 = _interopRequireDefault(_goldBar);

var _goldCertificate = __webpack_require__("emqf");

var _goldCertificate2 = _interopRequireDefault(_goldCertificate);

var _bronzeCertificate = __webpack_require__("plXt");

var _bronzeCertificate2 = _interopRequireDefault(_bronzeCertificate);

var _silverCertificate = __webpack_require__("pJ47");

var _silverCertificate2 = _interopRequireDefault(_silverCertificate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Certificate component
 * Displays number of Gold, Silver and Bronze certificates earned by the student
 * Also displays Gold bars earned by the student for a selected time period
 */
var Certificates = (_temp = _class = function (_Component) {
    _inherits(Certificates, _Component);

    function Certificates(props) {
        _classCallCheck(this, Certificates);

        var _this = _possibleConstructorReturn(this, (Certificates.__proto__ || Object.getPrototypeOf(Certificates)).call(this, props));

        var pastCertificateSummary = props.pastCertificateSummary,
            localeData = props.localeData;
        var goldPast = pastCertificateSummary.goldPast,
            silverPast = pastCertificateSummary.silverPast,
            bronzePast = pastCertificateSummary.bronzePast,
            goldBarsPast = pastCertificateSummary.goldBarsPast;

        _this.state = {
            certificates: [{
                title: localeData['Label - Bronze'],
                count: bronzePast,
                icon: _bronzeCertificate2.default
            }, {
                title: localeData['Label - Silver'],
                count: silverPast,
                icon: _silverCertificate2.default
            }, {
                title: localeData['Label - Gold'],
                count: goldPast,
                icon: _goldCertificate2.default
            }],
            certGoldBars: goldBarsPast + ' ' + localeData['Cert - Gold Bars'],
            certLabel: localeData['Label - PastCertificates']
        };
        return _this;
    }

    _createClass(Certificates, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                certificates = _state.certificates,
                certGoldBars = _state.certGoldBars,
                certLabel = _state.certLabel;


            return _react2.default.createElement(
                'div',
                { className: _certificates2.default.component },
                _react2.default.createElement(
                    'div',
                    { className: _certificates2.default.heading },
                    certLabel
                ),
                _react2.default.createElement(
                    'div',
                    { className: _certificates2.default.certificates },
                    certificates.map(function (certificate) {
                        return _react2.default.createElement(
                            'div',
                            { key: certificate.title },
                            _react2.default.createElement(_certificateCount2.default, {
                                icon: certificate.icon,
                                title: certificate.title,
                                count: certificate.count })
                        );
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _certificates2.default.goldbar },
                    _react2.default.createElement(_reactInlinesvg2.default, { src: _goldBar2.default, cacheGetRequests: true }),
                    _react2.default.createElement(
                        'div',
                        { className: _certificates2.default.goldbarCount },
                        certGoldBars
                    )
                )
            );
        }
    }]);

    return Certificates;
}(_react.Component), _class.propTypes = {
    pastCertificateSummary: _propTypes2.default.shape({
        gold: _propTypes2.default.string,
        silver: _propTypes2.default.string,
        bronze: _propTypes2.default.string,
        goldBars: _propTypes2.default.number
    }),
    localeData: _propTypes2.default.object
}, _temp);


function mapStateToProps(state) {
    return {
        localeData: state.localeData
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactStyleable2.default)(_certificates2.default)(Certificates));

/***/ }),

/***/ "rrpD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(fetch) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SET_LOCALE_DATA = undefined;

var _resources = __webpack_require__("viEY");

var _resources2 = _interopRequireDefault(_resources);

var _localeUtils = __webpack_require__("MGx+");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global fetch */

var SET_LOCALE_DATA = exports.SET_LOCALE_DATA = 'SET_LOCALE_DATA';

function setTranslationData() {
    function setLocale(response, dispatch) {
        response.json().then(function (translations) {
            return dispatch({
                type: SET_LOCALE_DATA,
                payload: {
                    translations: translations
                }
            });
        });
    }
    return function (dispatch) {
        return _resources2.default.getConfigurationItem('LocalisationCdnBaseUrl').then(function (linguiCdnBaseUrl) {
            var localePath = (0, _localeUtils.locale)();
            var cdnPath = linguiCdnBaseUrl + '/' + localePath + '.json';
            fetch(cdnPath)
            // eslint-disable-next-line consistent-return
            .then(function (response) {
                if (response.ok) {
                    setLocale(response, dispatch);
                } else {
                    cdnPath = linguiCdnBaseUrl + '/en-AU.json';
                    fetch(cdnPath).then(function (response2) {
                        return setLocale(response2, dispatch);
                    })
                    // eslint-disable-next-line no-console
                    .catch(function (error) {
                        return console.log('fetching of default locale also failed: ' + error);
                    });
                }
            })
            // eslint-disable-next-line no-console
            .catch(function (error) {
                return console.log('fetching json locale failed: ' + error);
            });
        });
    };
}

exports.default = {
    setTranslationData: setTranslationData
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("rp8n")))

/***/ }),

/***/ "rrrd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".certificate-template---2MKfH {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border: 1px solid #4dc4ef;\n  margin: 0 7px 7px;\n  border-radius: 20px;\n  padding: 15px 20px 10px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 120px;\n  height: 164px; }\n  .certificate-template---2MKfH .icon---2kxI6 {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin-bottom: 5px;\n    width: 94px;\n    height: 49%; }\n  .certificate-template---2MKfH .certificate-type---3dK13 {\n    font-size: 12px;\n    font-weight: 400;\n    margin-bottom: 10px; }\n  .certificate-template---2MKfH .btn-container---3DT-w .download-btn---15KGo {\n    height: 33px;\n    width: 78px;\n    border: unset;\n    background: linear-gradient(103.65deg, #00abe8, #007acc, #0063a7); }\n  .certificate-template---2MKfH .btn-container---3DT-w .download-btn---15KGo svg path {\n      fill: unset !important; }\n  .certificate-template---2MKfH .btn-container---3DT-w .disabled---kymJT {\n    background: #f4f8fa;\n    color: #33475f; }\n", ""]);

// exports
exports.locals = {
	"certificate-template": "certificate-template---2MKfH",
	"icon": "icon---2kxI6",
	"certificate-type": "certificate-type---3dK13",
	"btn-container": "btn-container---3DT-w",
	"download-btn": "download-btn---15KGo",
	"disabled": "disabled---kymJT"
};

/***/ }),

/***/ "sNQ+":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("QFxx");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./participation-report.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./participation-report.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "sR3R":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/e7cbe3dc6a53bb453896a4d839d057b8.svg";

/***/ }),

/***/ "smAp":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/444daa86d2f977903edf6799e8083602.svg";

/***/ }),

/***/ "spca":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/6daa0cd0c50ac000b03c92589fab81e5.svg";

/***/ }),

/***/ "tijh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---3_NS2 h3 {\n  font-size: 25px;\n  font-weight: normal; }\n\n.component---3_NS2 .sub-heading---1Ccp_ {\n  font-size: 12px; }\n\n.component---3_NS2 .data-table---1vRnR {\n  margin-top: 16px; }\n\n.component---3_NS2 .data-table---1vRnR table {\n    text-align: left; }\n\n.component---3_NS2 .data-table---1vRnR table thead th,\n    .component---3_NS2 .data-table---1vRnR table tbody td,\n    .component---3_NS2 .data-table---1vRnR table tfoot td {\n      font-weight: normal;\n      font-size: 14px;\n      padding: 20px; }\n\n@media (min-width: 992px) {\n        .component---3_NS2 .data-table---1vRnR table thead th,\n        .component---3_NS2 .data-table---1vRnR table tbody td,\n        .component---3_NS2 .data-table---1vRnR table tfoot td {\n          font-size: 16px; } }\n\n.component---3_NS2 .data-table---1vRnR table thead th {\n      background-color: #e7e9ea;\n      color: #415667;\n      border: none; }\n\n.component---3_NS2 .data-table---1vRnR table tbody td {\n      color: #6c7378; }\n\n.component---3_NS2 .data-table---1vRnR table tfoot td {\n      background-color: #415667;\n      color: #fff;\n      border: none; }\n", ""]);

// exports
exports.locals = {
	"component": "component---3_NS2",
	"sub-heading": "sub-heading---1Ccp_",
	"data-table": "data-table---1vRnR"
};

/***/ }),

/***/ "u0LN":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/f8e36975ba8a88b16cda4b8eb1ec9c02.svg";

/***/ }),

/***/ "u5Xn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__("KJcn");

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = __webpack_require__("h2Qy");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

__webpack_require__("nIya");

var _pointsDisplay = __webpack_require__("TFxc");

var _pointsDisplay2 = _interopRequireDefault(_pointsDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Points Display Component for Live Maths and Activity
 * Displays points earned by the student for a selected date
 */

var PointsDisplay = function PointsDisplay(_ref) {
    var imgSrc = _ref.imgSrc,
        title = _ref.title,
        points = _ref.points,
        elementStyle = _ref.elementStyle;
    return _react2.default.createElement(
        'div',
        { className: _pointsDisplay2.default.component },
        _react2.default.createElement(
            'div',
            { className: _pointsDisplay2.default[elementStyle] + ' ' + _pointsDisplay2.default.logo },
            _react2.default.createElement(_reactInlinesvg2.default, { src: imgSrc })
        ),
        _react2.default.createElement(
            'div',
            { className: _pointsDisplay2.default.pointdetails },
            _react2.default.createElement(
                'div',
                { className: _pointsDisplay2.default.points },
                points.toLocaleString('en-AU')
            ),
            _react2.default.createElement(
                'div',
                { className: _pointsDisplay2.default.title },
                title
            )
        )
    );
};

PointsDisplay.propTypes = {
    imgSrc: _propTypes2.default.string,
    title: _propTypes2.default.string,
    points: _propTypes2.default.number,
    elementStyle: _propTypes2.default.string
};

exports.default = (0, _reactStyleable2.default)(_pointsDisplay2.default)(PointsDisplay);

/***/ }),

/***/ "uMie":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModalContainer = undefined;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("4n+p");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__("2KeS");

var _modal = __webpack_require__("40IM");

var _modal2 = _interopRequireDefault(_modal);

var _newModal = __webpack_require__("HENK");

var _newModal2 = _interopRequireDefault(_newModal);

var _modalActions = __webpack_require__("P039");

var _modalActions2 = _interopRequireDefault(_modalActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ModalContainer Redux component
 * Responsible for managing the display of modals in the app
 *
 */
var ModalContainer = exports.ModalContainer = function ModalContainer(_ref) {
    var modalMessages = _ref.modalMessages,
        closeModal = _ref.closeModal;
    return _react2.default.createElement(
        'div',
        null,
        modalMessages.modalData.map(function (message) {
            return modalMessages.useNewModal ? _react2.default.createElement(_newModal2.default, {
                key: message.id,
                message: message,
                onClose: closeModal
            }) : _react2.default.createElement(_modal2.default, {
                key: message.id,
                message: message,
                onClose: closeModal
            });
        })
    );
};

ModalContainer.propTypes = {
    modalMessages: _propTypes2.default.object,
    closeModal: _propTypes2.default.func
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        modalMessages: state.modalMessages
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        closeModal: _modalActions2.default.closeModal
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModalContainer);

/***/ }),

/***/ "uOny":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("M4fF");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global window */

var UrlHelper = function () {
    function UrlHelper() {
        _classCallCheck(this, UrlHelper);
    }

    _createClass(UrlHelper, null, [{
        key: 'getQueryParamValue',
        value: function getQueryParamValue(key) {
            var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;

            var queryParams = url.substring(1).split('&');
            var param = queryParams.find(function (p) {
                return p.indexOf(key + '=') === 0;
            });
            if (param && param.indexOf('=') !== -1) {
                return decodeURI(param.split('=')[1]);
            }
            return null;
        }
    }, {
        key: 'generateQueryString',
        value: function generateQueryString(params) {
            var keys = (0, _lodash.keys)(params);
            return keys.map(function (name) {
                return name + '=' + encodeURIComponent(params[name]);
            });
        }
    }, {
        key: 'isRunningOnDeveloperMachine',
        value: function isRunningOnDeveloperMachine() {
            return (/^https?:\/\/localhost/.test(window.location)
            );
        }
    }]);

    return UrlHelper;
}();

exports.default = UrlHelper;

/***/ }),

/***/ "ukx/":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("jgMC");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./popup-menu.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./popup-menu.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uvI+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = __webpack_require__("h2Qy");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _closeIcon = __webpack_require__("Xotz");

var _closeIcon2 = _interopRequireDefault(_closeIcon);

var _closeButton = __webpack_require__("PlEc");

var _closeButton2 = _interopRequireDefault(_closeButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton(_ref) {
    var onClose = _ref.onClose,
        className = _ref.className;

    var classes = className ? className + ' ' + _closeButton2.default['close-button'] : _closeButton2.default['close-button'];
    return _react2.default.createElement(
        'div',
        {
            className: classes,
            onClick: onClose,
            role: 'button',
            tabIndex: '0'
        },
        _react2.default.createElement(_reactInlinesvg2.default, { src: _closeIcon2.default })
    );
};

CloseButton.propTypes = {
    onClose: _propTypes2.default.func,
    className: _propTypes2.default.string
};

exports.default = CloseButton;

/***/ }),

/***/ "vGvd":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/6f7573b588c11026afe1d5798a4242a2.svg";

/***/ }),

/***/ "vSiG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (!action) return state;

    switch (action.type) {
        case _studentCertificatesGemCountActions.STUDENT_CERTIFICATES_GEM_COUNT_RETRIEVED:
            {
                var retrievedGems = action.payload.retrievedGems;

                return _extends({}, state, { retrievedGems: retrievedGems });
            }
        case _studentCertificatesGemCountActions.STUDENT_CERTIFICATES_GEM_COUNT_SELECTED:
            {
                var selectedGems = action.payload.selectedGems;

                return _extends({}, state, { selectedGems: selectedGems });
            }
        default:
            return state;
    }
};

var _studentCertificatesGemCountActions = __webpack_require__("WElh");

var initialState = {
    retrievedGems: [],
    selectedGems: null
};

/**
 * Student Certificates Gem Count Reducer
 *
 * Consumes STUDENT_CERTIFICATES_GEM_COUNT_RETRIEVED action
 *
 * @param {array} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - contains list of individual student certificates for a class
 *                     as well as total for class
 */

/***/ }),

/***/ "viEY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _basicResources = __webpack_require__("iV3T");

var _basicResources2 = _interopRequireDefault(_basicResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should generally call its initialise() method, to set
// up the environment and create all of the resources the application will use.

// In some (hopefully, rare) situations, it may be required that the environment is provided
// from a parent application. In these situations, call createResources(parentEnv) directly,
// and pass it the Resources.env object that is the environment required.
var Resources = function () {
    function Resources() {
        _classCallCheck(this, Resources);
    }

    _createClass(Resources, null, [{
        key: 'createResources',

        // createResources() should create a static field for each resource:
        //
        //    const env = parentEnv || Resources.env;
        //
        //    Resources.colours = env.resource('Colours')
        //                           .baseUrl('@AvatarAdminBaseUrl')
        //                           .service('colours');
        //
        //
        // Application code can then access those resources like so:
        //
        //    const allColours = Resource.colours.get().send();

        value: function createResources(parentEnv) {
            var _this = this;

            var env = parentEnv || Resources.env;

            var BASE_URL = '@SchoolUsageReportsGatewayBaseUrl';
            var CERTIFICATE_GATEWAY_URL = '@CertificateGatewayBaseUrl';

            Resources.classOverview = env.resource('overview').baseUrl(BASE_URL).service('/school/classroom/usage');

            Resources.classDetails = env.resource('classDetails').baseUrl(BASE_URL).service('/school/classroom/{classroomId}/usage/date-range');

            Resources.academicYear = env.resource('academicYear').baseUrl(BASE_URL).service('/school/academicYear');

            Resources.participationReport = env.resource('participationReport').baseUrl(BASE_URL).service('/school/student/{profileId}/usage');

            Resources.studentCertificates = env.resource('studentCertificates').baseUrl(BASE_URL).service('/school/classroom/{classroomId}/certificates');

            Resources.studentCertificatesGemCount = env.resource('studentCertificatesGemCount').baseUrl(CERTIFICATE_GATEWAY_URL).service('/new-certificates/gemCounts');

            /**
             * Gets Configuration Item
             * @params: key: configuration item key
             */
            Resources.getConfigurationItem = function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(key) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    return _context.abrupt('return', env.getConfigurationItem(key));

                                case 1:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }();
        }

        // Initialise the environment and resources, based on the provided
        // environment name.  We return the environment so the caller has
        // access to everything, in particular the authToken if one was
        // passed in the query parameters.

    }, {
        key: 'initialise',
        value: function initialise(envName, credentials) {
            Resources.env = _basicResources2.default.initialise(envName, credentials);

            Resources.createResources();

            return Resources.env;
        }
    }]);

    return Resources;
}();

exports.default = Resources;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "vmQ6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * The Front and Back end devs need to share certain values that impact the
 * business logic of the application.  From the point of view of the Front End,
 * this file is the single source of truth for this information.
 */

var MATHLETICS_PRODUCT_ID = exports.MATHLETICS_PRODUCT_ID = '1';
var PHONICS_PRODUCT_ID = exports.PHONICS_PRODUCT_ID = '8';

/***/ }),

/***/ "vrRF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  black: {
    100: 'rgba(0, 0, 0, 0.07)',
    200: 'rgba(0, 0, 0, 0.2)',
    300: 'rgba(0, 0, 0, 0.33)',
    400: 'rgba(0, 0, 0, 0.4)',
    500: 'rgba(0, 0, 0, 0.5)',
    600: 'rgba(0, 0, 0, 0.6)',
    700: 'rgba(0, 0, 0, 0.7)',
    800: 'rgba(0, 0, 0, 0.8)',
    900: 'rgba(0, 0, 0, 0.9)'
  },
  grey: {
    100: 'rgba(72, 72, 72, 0.07)',
    200: 'rgba(72, 72, 72, 0.2)',
    300: 'rgba(72, 72, 72, 0.33)',
    400: 'rgba(72, 72, 72, 0.4)',
    500: 'rgba(72, 72, 72, 0.5)',
    600: 'rgba(72, 72, 72, 0.6)',
    700: 'rgba(72, 72, 72, 0.7)',
    800: 'rgba(72, 72, 72, 0.8)',
    900: 'rgba(72, 72, 72, 0.9)'
  }
};

/***/ }),

/***/ "vtwl":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---gDnRo {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  height: 100vh; }\n  .component---gDnRo > div {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto; }\n  .component---gDnRo h1 {\n    font-weight: normal; }\n  .component---gDnRo .main-content---2BovZ {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 100%;\n            flex: 1 1 100%;\n    overflow: hidden;\n    margin: 20px;\n    padding: 20px;\n    border-radius: 5px;\n    background-color: #fff;\n    -webkit-box-shadow: 5px 5px rgba(0, 0, 0, .07);\n            box-shadow: 5px 5px rgba(0, 0, 0, .07);\n    overflow: auto;\n    padding: 20px 40px; }\n  @media print {\n      .component---gDnRo .main-content---2BovZ {\n        -webkit-box-shadow: none;\n                box-shadow: none; } }\n  .component---gDnRo .header---1I2S8 {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    margin-bottom: 10px; }\n  .component---gDnRo .header---1I2S8 h2 {\n      color: #415667;\n      font-size: 25px;\n      font-weight: 600; }\n  .component---gDnRo .header---1I2S8 .sub-header---d_Qx2 {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      max-height: 50px; }\n  .component---gDnRo .header---1I2S8 .sub-header---d_Qx2 .class-total---NiipO span {\n        font-size: 22px;\n        font-weight: 500;\n        color: #33475f; }\n  .component---gDnRo .header---1I2S8 .filter-container---3et4V {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      font-size: 16px;\n      margin: 10px 0 16px; }\n  .component---gDnRo .header---1I2S8 .filter-container---3et4V .date-filter---3iSKU {\n        margin-left: 10px; }\n  .component---gDnRo .header---1I2S8 .student-dropdown---3qDgS {\n      min-width: 160px; }\n  .component---gDnRo .downloads---3AR3m {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    height: calc(100% - 115px); }\n  .component---gDnRo .downloads---3AR3m .templates---17kEs {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      max-height: calc(100vh - 390px);\n      width: 100%;\n      max-width: 1000px; }\n  .component---gDnRo .downloads---3AR3m .download-all---2_cy6 {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      margin-top: 25px;\n      letter-spacing: 1px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---gDnRo",
	"main-content": "main-content---2BovZ",
	"header": "header---1I2S8",
	"sub-header": "sub-header---d_Qx2",
	"class-total": "class-total---NiipO",
	"filter-container": "filter-container---3et4V",
	"date-filter": "date-filter---3iSKU",
	"student-dropdown": "student-dropdown---3qDgS",
	"downloads": "downloads---3AR3m",
	"templates": "templates---17kEs",
	"download-all": "download-all---2_cy6"
};

/***/ }),

/***/ "w22/":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/e3cb10c34fa4d47f3d18132005111c19.svg";

/***/ }),

/***/ "w8LL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  dropdown: 90,
  modal: 100
};

/***/ }),

/***/ "wAWk":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("AoEh");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./certificates.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./certificates.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "wBUB":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/6d913b8a6339e89cb9e15d50b455a02e.svg";

/***/ }),

/***/ "wfBL":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/7d9107cdc32567399cc994df1e3767c0.svg";

/***/ }),

/***/ "wmVF":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/8f0535f65f025bc023bce3f2114cfca6.svg";

/***/ }),

/***/ "x4K0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("4n+p");

var _reactRouterDom = __webpack_require__("F8kA");

__webpack_require__("nIya");

var _basicApp = __webpack_require__("SgkA");

var _basicApp2 = _interopRequireDefault(_basicApp);

var _overview = __webpack_require__("3a/N");

var _overview2 = _interopRequireDefault(_overview);

var _classDetails = __webpack_require__("RkUy");

var _classDetails2 = _interopRequireDefault(_classDetails);

var _busyIndicator = __webpack_require__("0Cvf");

var _busyIndicator2 = _interopRequireDefault(_busyIndicator);

var _modalContainer = __webpack_require__("uMie");

var _modalContainer2 = _interopRequireDefault(_modalContainer);

var _participationReport = __webpack_require__("l4i3");

var _participationReport2 = _interopRequireDefault(_participationReport);

var _certificates = __webpack_require__("oV0N");

var _certificates2 = _interopRequireDefault(_certificates);

var _toastContainer = __webpack_require__("9L0d");

var _toastContainer2 = _interopRequireDefault(_toastContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */

var EntryApp = function (_BasicApp) {
    _inherits(EntryApp, _BasicApp);

    function EntryApp() {
        _classCallCheck(this, EntryApp);

        return _possibleConstructorReturn(this, (EntryApp.__proto__ || Object.getPrototypeOf(EntryApp)).apply(this, arguments));
    }

    _createClass(EntryApp, [{
        key: 'render',
        value: function render(store) {
            // When executing on demo, QA, or production, the host app will inject a property
            // called pppAppConfig into the global window variable.  This will provide the
            // base name of the app.  Most of the time that will be an empty string, but in
            // case it is not, we will extract it and pass it to the router, below.

            // eslint-disable-next-line no-underscore-dangle
            var appConfig = window._env_;
            var BASE_NAME = appConfig ? appConfig.BaseName : '';

            return _react2.default.createElement(
                _reactRedux.Provider,
                { store: store },
                _react2.default.createElement(
                    _reactRouterDom.BrowserRouter,
                    { history: _reactRouterDom.browserHistory, basename: BASE_NAME },
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_busyIndicator2.default, null),
                        _react2.default.createElement(
                            _reactRouterDom.Switch,
                            null,
                            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/home', component: _overview2.default }),
                            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/class-details', component: _classDetails2.default }),
                            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/participation-report', component: _participationReport2.default }),
                            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/certificates', component: _certificates2.default }),
                            _react2.default.createElement(_reactRouterDom.Redirect, { exact: true, from: '*', to: '/home' })
                        ),
                        _react2.default.createElement(_modalContainer2.default, null),
                        _react2.default.createElement(_toastContainer2.default, null)
                    )
                )
            );
        }
    }]);

    return EntryApp;
}(_basicApp2.default);

exports.default = EntryApp;


window.EntryApp = EntryApp;

/***/ }),

/***/ "xebo":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/a811a6ef7da423c90b33730728a2ed0c.svg";

/***/ }),

/***/ "y18N":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Z5LP");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./login-info-display.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./login-info-display.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "yU2o":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("rrrd");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./certificate-template.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./certificate-template.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "yu+Z":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/b4f887fafb11fc6353d91898f843298f.svg";

/***/ }),

/***/ "zs5o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SET_SCHOOL_ID = undefined;

var _reduxActions = __webpack_require__("sTbe");

var SET_SCHOOL_ID = exports.SET_SCHOOL_ID = 'SET_SCHOOL_ID';

var setSchoolId = (0, _reduxActions.createAction)(SET_SCHOOL_ID);

exports.default = {
    setSchoolId: setSchoolId
};

/***/ })

},[2]);


// WEBPACK FOOTER //
// entry-app.b09363c6c379b7bc5a98.js